import * as i0 from '@angular/core';
import { Component, Inject, EventEmitter, Injectable, ViewChild, Output, Input } from '@angular/core';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4.js';
import { get } from 'ol/proj.js';
import { format, distance } from 'ol/coordinate';
import TileGrid from 'ol/tilegrid/TileGrid';
import { LineString, Point, MultiLineString, Polygon } from 'ol/geom';
import { getTopLeft, getArea, getCenter, containsCoordinate, getWidth, getHeight } from 'ol/extent';
import { getLength } from 'ol/sphere';
import Map from 'ol/Map';
import View from 'ol/View';
import { ScaleLine, MousePosition } from 'ol/control';
import { shiftKeyOnly } from 'ol/events/condition';
import Feature from 'ol/Feature';
import { Collection } from 'ol';
import { DateTime } from 'luxon';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Circle from 'ol/style/Circle';
import Icon from 'ol/style/Icon';
import Text from 'ol/style/Text';
import { DragRotate, DoubleClickZoom, DragPan, PinchRotate, PinchZoom, KeyboardPan, KeyboardZoom, MouseWheelZoom, DragZoom, Draw, Translate } from 'ol/interaction';
import { NgClass } from '@angular/common';
import { interval, takeWhile, Observable, BehaviorSubject, firstValueFrom, take } from 'rxjs';
import * as i1 from '@angular/cdk/clipboard';
import * as i1$1 from '@angular/forms';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/material/slider';
import { MatSliderModule } from '@angular/material/slider';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import TileWms from 'ol/source/TileWMS';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import WKT from 'ol/format/WKT';
import GeoJSON from 'ol/format/GeoJSON';
import ImageWMS from 'ol/source/ImageWMS.js';
import { Image as Image$1 } from 'ol/layer.js';
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import WMSCapabilities from 'ol/format/WMSCapabilities.js';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import LayerGroup from 'ol/layer/Group';
import { jsPDF } from 'jspdf';
import { transformExtent } from 'ol/proj';
import { Cluster } from 'ol/source';
import * as i3 from '@angular/common/http';
import Overlay from 'ol/Overlay';

/**
 * This module provides utility functions for working with arrays.
 *
 * @module
 */
/**
 * This method registers and returns an OpenLayers-projection object. asd \
 *
 * @param name The name of the projection. Preferably as EPSG-format. (Etc. EPSG:3000)
 * @param projection The projection string. Can be found at https://epsg.io/
 * @returns The projection object, or null if any error
 */
function registerProjection(name, projection) {
    proj4.defs(name, projection);
    register(proj4);
    return get(name);
}
/**
 * Method that generates a custom coordinat string
 * @param fractionDigits number of digits in the fraction
 * @returns CoordinateFormat obj
 */
function customCoordinateString(fractionDigits) {
    return function (coordinate) {
        return format(coordinate, "SWERREF99 TM: N={y}, E={x}", fractionDigits);
    };
}
function distanceBetweenPoints(coord1, coord2) {
    var lineString = new LineString([coord1, coord2]);
    return lineString.getLength();
}
function FormatDistanceMeterKilometer(distanceInMeter, decimals) {
    if (distanceInMeter < 1000) {
        return distanceInMeter.toFixed(0) + "m";
    }
    const distanceInKilometer = distanceInMeter / 1000;
    return distanceInKilometer.toFixed(decimals) + "km";
}
/**
 * PaperSizes in (width x height) in mm
 */
const PaperSize = {
    A0: [841, 1189],
    A1: [594, 841],
    A2: [420, 594],
    A3: [297, 420],
    A4: [210, 297],
};
// CONSTANTS //
//Projections
const resolutions = [
    2645.8386250105837, 1322.9193125052918, 529.1677250021168, 264.5838625010584, 132.2919312505292, 66.1459656252646, 26.458386250105832,
    13.229193125052916, 6.614596562526458, 3.9687579375158757, 2.6458386250105836, 1.3229193125052918, 0.6614596562526459, 0.26458386250105836,
    0.13229193125052918, 0.06614596562526459, 0.026458386250105832,
];
const extent = [-200000, 4400000, 1445000, 9440000];
const INIT_EXTENT = [-73310.49787687784, 6399425.980703183, 1002990.4517692432, 6990413.04759978];
const WGS_84 = registerProjection("EPSG:4326", 'GEOGCS["WGS 84",DATUM["WGS_1984",SPHEROID["WGS 84",6378137,298.257223563,AUTHORITY["EPSG","7030"]],AUTHORITY["EPSG","6326"]],PRIMEM["Greenwich",0,AUTHORITY["EPSG","8901"]],UNIT["degree",0.01745329251994328,AUTHORITY["EPSG","9122"]],AUTHORITY["EPSG","4326"]]');
//WGS_84?.setExtent(extent);
/*export const SWEREF_99_TM = registerProjection(
    "EPSG:3006",
    'PROJCS["SWEREF99 TM", GEOGCS["SWEREF99", DATUM["SWEREF99", SPHEROID["GRS 1980",6378137,298.257222101], TOWGS84[0,0,0,0,0,0,0]], PRIMEM["Greenwich",0, AUTHORITY["EPSG","8901"]], UNIT["degree",0.0174532925199433, AUTHORITY["EPSG","9122"]], AUTHORITY["EPSG","4619"]], PROJECTION["Transverse_Mercator"], PARAMETER["latitude_of_origin",0], PARAMETER["central_meridian",15], PARAMETER["scale_factor",0.9996], PARAMETER["false_easting",500000], PARAMETER["false_northing",0], UNIT["metre",1, AUTHORITY["EPSG","9001"]], AUTHORITY["EPSG","3006"]]'
);
SWEREF_99_TM?.setExtent(extent);*/
const SWEREF_99_TM = registerProjection("EPSG:3006", "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +axis=neu");
SWEREF_99_TM?.setExtent(extent);
const tileGrid = new TileGrid({
    extent: SWEREF_99_TM?.getExtent(),
    origin: getTopLeft(SWEREF_99_TM?.getExtent()),
    resolutions: resolutions,
    tileSize: [512, 512],
});
const tileGridWmts = new TileGrid({
    extent: SWEREF_99_TM?.getExtent(),
    origin: getTopLeft(SWEREF_99_TM?.getExtent()),
    resolutions: resolutions,
    tileSize: [256, 256],
});
function getCenterRight(extent) {
    return [extent[2], (extent[1] + extent[3]) / 2];
}
function getExtentFromCoordinates(coordinates) {
    const extent = [Infinity, Infinity, -Infinity, -Infinity];
    for (const coordinate of coordinates) {
        extent[0] = Math.min(extent[0], coordinate[0]);
        extent[1] = Math.min(extent[1], coordinate[1]);
        extent[2] = Math.max(extent[2], coordinate[0]);
        extent[3] = Math.max(extent[3], coordinate[1]);
    }
    return extent;
}
/**
 * Get the center point along the length of a LineString.
 * @param {LineString} lineString The LineString geometry.
 * @returns {[number, number] | null} The center point [x, y], or null if the lineString has no segments.
 */
function getCenterPointOfLine(lineString) {
    const coordinates = lineString.getCoordinates();
    // Return null if the LineString doesn't have enough points
    if (coordinates.length < 2) {
        return null;
    }
    // Calculate total length of the LineString
    const totalLength = getLength(lineString);
    // Target length to reach the midpoint
    const targetLength = totalLength / 2;
    // Iterate through the segments to find the midpoint
    let accumulatedLength = 0;
    for (let i = 0; i < coordinates.length - 1; i++) {
        const start = coordinates[i];
        const end = coordinates[i + 1];
        // Calculate the length of the current segment
        const segment = new LineString([start, end]);
        const segmentLength = getLength(segment);
        if (accumulatedLength + segmentLength >= targetLength) {
            // Find the proportion of the segment where the midpoint lies
            const remainingLength = targetLength - accumulatedLength;
            const ratio = remainingLength / segmentLength;
            // Calculate the midpoint on this segment
            const x = start[0] + ratio * (end[0] - start[0]);
            const y = start[1] + ratio * (end[1] - start[1]);
            return [x, y];
        }
        // Accumulate the length of the current segment
        accumulatedLength += segmentLength;
    }
    // Fallback, return the last coordinate (should not happen with valid input)
    return coordinates[coordinates.length - 1];
}
//COORDINATES
const BORLANGE_COORD = [523194, 6705347];
const LEKSAND_COORD = [500166, 6733158];
const STOCKHOLM_COORD = [667070, 6584665];
const SWEDEN_CENTER_COORD = [609924.45, 6877630.37];
const SUNDBYBERG_WKT = "POLYGON((668869.16857169 6586138.4514435,665118.69232074 6586694.0775548,664020.66929136 6584359.1249682,664754.8895098 6583691.0507154,666851.71662012 6583485.9982219,668677.34527138 6583638.1339429,669953.96240794 6584815.532131,669762.13910763 6585754.8048429,668869.16857169 6586138.4514435))";
const LEKSAND_WKT = "POLYGON((490913.92557784 6742641.3406994,487275.89746845 6738804.8746931,485952.97815594 6733248.6135806,488268.08695282 6727824.6443993,491509.23926846 6723326.7187368,496073.31089661 6719093.3769368,500240.506731 6718431.9172805,501828.009906 6719424.1067649,503415.51308101 6721540.7776649,506656.66539665 6724252.7622556,509037.92015916 6725575.6815681,511353.02895604 6728486.1040556,515189.49496231 6734042.3651681,515454.07882481 6736423.6199306,515586.37075606 6739929.3561087,514726.47320293 6743567.3842181,513138.97002792 6745948.6389806,510625.42333416 6748660.6235713,505929.05977477 6745353.32529,502224.88569976 6743435.0922869,499843.63093725 6745022.5954619,490913.92557784 6742641.3406994))";
const NORRLAND_WKT = "POLYGON((439379.33917534 7166095.112607,759475.64770129 7090746.7085769,799163.22707645 7158215.5935147,788579.8725764 7197903.1728898,792548.63051392 7232299.075015,804454.90432647 7254788.7033275,808423.66226398 7282570.0088902,833559.12920158 7302413.7985777,837527.8871391 7335486.7813904,889121.74032681 7334163.8620779,919548.88451443 7335486.7813904,887798.8210143 7392372.3118281,885152.98238929 7455872.4388283,863986.27338921 7498205.8568285,854725.83820167 7561705.9838288,800486.14638895 7615945.6756415,735663.10007619 7660924.9322667,713173.4717636 7675477.0447042,707881.79451358 7610653.9983915,697298.44001354 7588164.3700789,629829.55507577 7609331.079079,621892.03920074 7551122.6293287,592787.81432562 7555091.3872662,546485.63838794 7486299.583016,557068.99288798 7443966.1650158,513412.6555753 7375174.3607655,516108.65930064 7346012.1391078,480430.90127846 7332679.6524428,479372.56582845 7281350.3831176,439379.33917534 7166095.112607))";
/**
 * Current tools:\
 * Pointer: 0, \
 * PinPosition: 1, \
 * Ruler: 2, \
 * Zoom: 3, \
 * ExportRectangle: 4,\
 * StreetView: 5
 */
const MapTools = {
    None: -1,
    Pointer: 0,
    PinPosition: 1,
    Ruler: 2,
    Zoom: 3,
    ExportRectangle: 4,
    StreetView: 5,
};
/**
 * Adds a new MapTool. \
 * Current ones:\
 * Pointer: 0, \
 * PinPosition: 1, \
 * Ruler: 2, \
 * Zoom: 3, \
 * ExportRectangle: 4,\
 * StreetView: 5
 * @param mapToolName Tool of the new mapTool
 */
function extendMapTools(mapToolName) {
    //Calculate new id
    let smallestId = 0;
    Object.keys(MapTools).forEach(key => {
        if (MapTools[key] > smallestId)
            smallestId = MapTools[key];
    });
    MapTools[mapToolName] = smallestId + 1;
}
/*export enum MapTools {
  None = 0,
  Pointer = 1,
  Polygon = 2,
  Square = 3,
  Pin = 4,
  Info = 5,
  Ruler = 6
}*/
/**
 * Method that calculates wether a circle intersects a line or not.
 * @param l1 First point on line
 * @param l2 Second point on line
 * @param circle Center point of circle
 * @param circleRadius The radius of the circle (in pixels)
 * @returns True if circle intersects line
 */
function LineIntersectCircle(l1, l2, circle, circleRadius) {
    let lineStart = { x: l1[0], y: l1[1] };
    let lineEnd = { x: l2[0], y: l2[1] };
    let circleCenter = { x: circle[0], y: circle[1] };
    const dx = lineEnd.x - lineStart.x;
    const dy = lineEnd.y - lineStart.y;
    const a = dx * dx + dy * dy;
    const b = 2 * (dx * (lineStart.x - circleCenter.x) + dy * (lineStart.y - circleCenter.y));
    const c = circleCenter.x * circleCenter.x +
        circleCenter.y * circleCenter.y +
        lineStart.x * lineStart.x +
        lineStart.y * lineStart.y -
        2 * (circleCenter.x * lineStart.x + circleCenter.y * lineStart.y) -
        circleRadius * circleRadius;
    const discriminant = b * b - 4 * a * c;
    if (discriminant < 0) {
        return false;
    }
    const sqrtDiscriminant = Math.sqrt(discriminant);
    const t1 = (-b + sqrtDiscriminant) / (2 * a);
    const t2 = (-b - sqrtDiscriminant) / (2 * a);
    if (t1 >= 0 && t1 <= 1) {
        return true;
    }
    if (t2 >= 0 && t2 <= 1) {
        return true;
    }
    return false;
}
function roundDownToMultiple(number, multiple) {
    return Math.floor(number / multiple) * multiple;
}
/**
 * Method that generates a GUID.
 * @returns GUID
 */
function generateGUID() {
    let d = new Date().getTime();
    const guid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return guid;
}

/**
 * Class that contains all the controls present on the ol/map.
 */
class TrvControl {
    /**
     * ol/ScaleLine control.
     */
    scaleLineControl;
    /** ol/MousePosition control */
    mousePositionControl;
    /** List containing all controls that's added to the map */
    controlList = [];
    /** Reference to parent TrvMap */
    trvMap;
    constructor(trvMap) {
        this.trvMap = trvMap;
        if (trvMap)
            this.resetControls();
    }
    resetControls() {
        const view = this.trvMap.map?.getView();
        this.controlList.forEach(control => {
            if (this.trvMap.map)
                this.trvMap.map.removeControl(control);
        });
        this.scaleLineControl = new ScaleLine({
            units: "metric",
            target: document.getElementById("map-scale-line" + (this.trvMap.id ? this.trvMap.id : "")),
        });
        this.mousePositionControl = new MousePosition({
            coordinateFormat: customCoordinateString(0),
            projection: SWEREF_99_TM?.getCode(),
            className: "custom-mouse-position",
            target: document.getElementById("mouse-position" + (this.trvMap.id ? this.trvMap.id : "")),
            placeholder: customCoordinateString(0)(view ? view.getCenter() : [0, 0]),
        });
        if (!this.trvMap.hideControls) {
            this.controlList = [this.scaleLineControl, this.mousePositionControl];
            this.controlList.forEach(control => {
                if (this.trvMap.map)
                    this.trvMap.map.addControl(control);
            });
        }
    }
    /**
     * Method that adds a control to the map.
     * @param control The control to be added
     */
    addControl(control) {
        this.controlList.push(control);
        this.trvMap.map.addControl(control);
    }
}

/** Default dotted line style */
const DefaultDottedStyle = new Style({
    stroke: new Stroke({
        color: "#d12e2c",
        width: 3,
        lineDash: [0.1, 5],
    }),
});
/** Default point style */
const DefaultPointStyle = new Style({
    image: new Circle({
        radius: 7,
        fill: new Fill({
            color: "rgba(31,226,250,0.1)",
        }),
        stroke: new Stroke({
            color: "rgba(31,226,250,0.7)",
            width: 1.25,
        }),
    }),
});
/** Style for the ruler-tool */
const RulerLineString = new Style({
    stroke: new Stroke({
        color: "rgba(0, 0, 0, 0.7)",
        lineDash: [7, 15],
        width: 3,
    }),
});
/** Style for the ruler-tool when hoovering over a line */
const RulerLineHover = new Style({
    stroke: new Stroke({
        color: "rgba(30, 90, 136, 0.8)",
        width: 8,
    }),
});
/** Style for the points in ruler-tool */
const RulerLinePoint = new Style({
    image: new Circle({
        radius: 5,
        fill: new Fill({
            color: "rgba(30, 90, 136,0.2)",
        }),
        stroke: new Stroke({
            color: "rgba(30, 90, 136,0.4)",
            width: 1.25,
        }),
    }),
});
/** The Default style for features in trv-ng-map */
const DefaultStyle = new Style({
    fill: new Fill({
        color: "rgba(255,255,255,0.1)",
    }),
    stroke: new Stroke({
        color: "#3399CC",
        width: 1.25,
    }),
});
/** Default zoom-style */
const DefaultZoomStyle = new Style({
    fill: new Fill({
        color: "rgba(255,255,255,0.7)",
    }),
    stroke: new Stroke({
        color: "rgba(255,255,255,1)",
        width: 1.25,
    }),
});
/** Default style for the rectangle in Maptools.ExportRectangle */
const DefaultExportRectStyle = new Style({
    fill: new Fill({
        color: "rgba(215,0,0,0.1)",
    }),
    stroke: new Stroke({
        color: "#D70000",
        width: 1.25,
    }),
});
/** Style for the Street-view man standing */
var StreetViewIconStanding = new Style({
    image: new Icon({
        anchor: [0.5, 0.9],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 0.8,
        src: "assets/images/street-view/street_view_black.png",
    }),
});
/** Style for the Street-view man laying to the side */
var StreetViewIconLaying = new Style({
    image: new Icon({
        anchor: [0.5, 0.9],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 0.8,
        src: "assets/images/street-view/street_view_black_side.png",
    }),
    text: new Text({
        font: "14px Calibri,sans-serif",
        fill: new Fill({ color: "#000" }),
        text: "",
        stroke: new Stroke({
            color: "#fff",
            width: 2,
        }),
        offsetY: -9,
        offsetX: 20,
        textAlign: "left",
    }),
});
/** Style used for the Zoom-tool */
var ZoomPointStyle = new Style({
    image: new Icon({
        anchor: [-0.8, 0.1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 0.6,
        src: "assets/images/misc/search.png",
    }),
});
//#region Pin styles
/** A red pin-style */
var PinRedStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_red.svg",
    }),
});
/** A dark-red pin-style */
var PinRedDarkStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_reddark.svg",
    }),
});
/** A red pin-style with i-icon */
var PinRedInfoStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_red_info.svg",
    }),
});
/** A red pin-style with ?-icon */
var PinRedQuestionStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_red_question.svg",
    }),
});
/** A red pin-style with !-icon */
var PinRedExclamationStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_red_exclamation.svg",
    }),
});
/** A red pin-style with house-icon */
var PinRedHouseStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_red_house.svg",
    }),
});
/** A red pin-style with user-icon */
var PinRedUserStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_red_user.svg",
    }),
});
/** A red pin-style with star-icon */
var PinRedStarStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_red_star.svg",
    }),
});
/** A red pin-style with search-icon */
var PinRedSearchStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_red_search.svg",
    }),
});
/** A red pin-style with a pen on the side */
var PinRedPenStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_red_search.svg",
    }),
});
//Blue
/** A blue pin-style */
var PinBlueStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_blue.svg",
    }),
});
/** A dark-blue pin-style */
var PinBlueDarkStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_bluedark.svg",
    }),
});
/** A blue pin-style with i-icon */
var PinBlueInfoStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_blue_info.svg",
    }),
});
/** A blue pin-style  with ?-icon*/
var PinBlueQuestionStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_blue_question.svg",
    }),
});
/** A blue pin-style with !-icon*/
var PinBlueExclamationStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_blue_exclamation.svg",
    }),
});
/** A blue pin-style with house-icon*/
var PinBlueHouseStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_blue_house.svg",
    }),
});
/** A blue pin-style with user-icon */
var PinBlueUserStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_blue_user.svg",
    }),
});
/** A blue pin-style with star-icon */
var PinBlueStarStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_blue_star.svg",
    }),
});
/** A blue pin-style with search-icon */
var PinBlueSearchStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_blue_search.svg",
    }),
});
/** A blue pin-style with a pen on the side*/
var PinBluePenStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_blue_pen.svg",
    }),
});
//Purple
/** A purple pin-style */
var PinPurpleStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_purple.svg",
    }),
});
/** A dark-purple pin-style */
var PinPurpleDarkStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_purpledark.svg",
    }),
});
/** A purple pin-style with i-icon */
var PinPurpleInfoStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_purple_info.svg",
    }),
});
/** A purple pin-style with ?-icon*/
var PinPurpleQuestionStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_purple_question.svg",
    }),
});
/** A purple pin-style with !-icon*/
var PinPurpleExclamationStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_purple_exclamation.svg",
    }),
});
/** A purple pin-style with house-icon */
var PinPurpleHouseStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_purple_house.svg",
    }),
});
/** A purple pin-style with user-icon*/
var PinPurpleUserStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_purple_user.svg",
    }),
});
/** A purple pin-style with star-icon*/
var PinPurpleStarStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_purple_star.svg",
    }),
});
/** A purple pin-style with search-icon */
var PinPurpleSearchStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_purple_search.svg",
    }),
});
/** A purple pin-style with pen on the side*/
var PinPurplePenStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_purple_pen.svg",
    }),
});
//Green
/** A green pin-style */
var PinGreenStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_green.svg",
    }),
});
/** A dark-green pin-style */
var PinGreenDarkStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_greendark.svg",
    }),
});
/** A green pin-style with i-icon*/
var PinGreenInfoStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_green_info.svg",
    }),
});
/** A green pin-style with ?-icon */
var PinGreenQuestionStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_green_question.svg",
    }),
});
/** A green pin-style with !-icon*/
var PinGreenExclamationStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_green_exclamation.svg",
    }),
});
/** A green pin-style with house-icon*/
var PinGreenHouseStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_green_house.svg",
    }),
});
/** A green pin-style with user-icon*/
var PinGreenUserStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_green_user.svg",
    }),
});
/** A green pin-style with star-icon*/
var PinGreenStarStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_green_star.svg",
    }),
});
/** A green pin-style with search-icon*/
var PinGreenSearchStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_green_search.svg",
    }),
});
/** A green pin-style with a pen on the side*/
var PinGreenPenStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_green_pen.svg",
    }),
});
//Orange
/** An orange pin-style */
var PinOrangeStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_orange.svg",
    }),
});
/** A dark-orange pin-style */
var PinOrangeDarkStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_orangedark.svg",
    }),
});
/** An orange pin-style with i-icon */
var PinOrangeInfoStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_orange_info.svg",
    }),
});
/** An orange pin-style with ?-icon */
var PinOrangeQuestionStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_orange_question.svg",
    }),
});
/** An orange pin-style with !-icon */
var PinOrangeExclamationStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_orange_exclamation.svg",
    }),
});
/** An orange pin-style with house-icon*/
var PinOrangeHouseStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_orange_house.svg",
    }),
});
/** An orange pin-style with user-icon */
var PinOrangeUserStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_orange_user.svg",
    }),
});
/** An orange pin-style with star-icon */
var PinOrangeStarStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_orange_star.svg",
    }),
});
/** An orange pin-style with search-icon */
var PinOrangeSearchStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_orange_search.svg",
    }),
});
/** An orange pin-style with a pen on the side*/
var PinOrangePenStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_orange_pen.svg",
    }),
});
//Yellow
/** A yellow pin-style */
var PinYellowStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_yellow.svg",
    }),
});
/** A dark-yellow pin-style */
var PinYellowDarkStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_yellowdark.svg",
    }),
});
/** A yellow pin-style with i-icon */
var PinYellowInfoStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_yellow_info.svg",
    }),
});
/** A yellow pin-style with ?-icon */
var PinYellowQuestionStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_yellow_question.svg",
    }),
});
/** A yellow pin-style with !-icon */
var PinYellowExclamationStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_yellow_exclamation.svg",
    }),
});
/** A yellow pin-style with house-icon */
var PinYellowHouseStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_yellow_house.svg",
    }),
});
/** A yellow pin-style with user-icon*/
var PinYellowUserStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_yellow_user.svg",
    }),
});
/** A yellow pin-style with star-icon */
var PinYellowStarStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_yellow_star.svg",
    }),
});
/** A yellow pin-style with search-icon*/
var PinYellowSearchStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_yellow_search.svg",
    }),
});
/** A yellow pin-style with pen on the side */
var PinYellowPenStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_yellow_pen.svg",
    }),
});
//Teal
/** A teal pin-style */
var PinTealStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_teal.svg",
    }),
});
/** A dark-teal pin-style */
var PinTealDarkStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_tealdark.svg",
    }),
});
/** A teal pin-style with i-icon */
var PinTealInfoStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_teal_info.svg",
    }),
});
/** A teal pin-style with ?-icon */
var PinTealQuestionStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_teal_question.svg",
    }),
});
/** A teal pin-style with !-icon */
var PinTealExclamationStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_teal_exclamation.svg",
    }),
});
/** A teal pin-style with house-icon */
var PinTealHouseStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_teal_house.svg",
    }),
});
/** A teal pin-style with user-icon */
var PinTealUserStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_teal_user.svg",
    }),
});
/** A teal pin-style with star-icon */
var PinTealStarStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_teal_star.svg",
    }),
});
/** A teal pin-style with search-icon */
var PinTealSearchStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_teal_search.svg",
    }),
});
/** A teal pin-style with pen on the side*/
var PinTealPenStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_teal_pen.svg",
    }),
});
//Pink
/** A pink pin-style */
var PinPinkStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_pink.svg",
    }),
});
/** A dark-pink pin-style */
var PinPinkDarkStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_pinkdark.svg",
    }),
});
/** A pink pin-style with i-icon */
var PinPinkInfoStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_pink_info.svg",
    }),
});
/** A pink pin-style with ?-icon */
var PinPinkQuestionStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_pink_question.svg",
    }),
});
/** A pink pin-style with !-icon */
var PinPinkExclamationStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_pink_exclamation.svg",
    }),
});
/** A pink pin-style with house-icon */
var PinPinkHouseStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_pink_house.svg",
    }),
});
/** A pink pin-style with user-icon */
var PinPinkUserStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_pink_user.svg",
    }),
});
/** A pink pin-style with star-icon */
var PinPinkStarStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_pink_star.svg",
    }),
});
/** A pink pin-style search-icon */
var PinPinkSearchStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_pink_search.svg",
    }),
});
/** A pink pin-style with pen on the side*/
var PinPinkPenStyle = new Style({
    image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        scale: 1,
        src: "assets/images/pins/pin_pink_pen.svg",
    }),
});
//#endregion

class OlOverlayComponent {
    overLay = null;
    prevPosition = undefined;
    constructor() { }
    open() {
        if (this.overLay && this.prevPosition) {
            this.overLay.setPosition(this.prevPosition);
        }
    }
    close() {
        if (this.overLay) {
            this.prevPosition = this.overLay.getPosition();
            this.overLay.setPosition(undefined);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: OlOverlayComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.0", type: OlOverlayComponent, isStandalone: true, selector: "lib-ol-overlay", ngImport: i0, template: "<p>overlay-component works!</p>\r\n", styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: OlOverlayComponent, decorators: [{
            type: Component,
            args: [{ selector: "lib-ol-overlay", standalone: true, template: "<p>overlay-component works!</p>\r\n" }]
        }], ctorParameters: () => [] });

class RulerLengthComponent extends OlOverlayComponent {
    trvMapService;
    rulerDistance;
    simpleRulerTool = false;
    trvMap;
    constructor(trvMapService) {
        super();
        this.trvMapService = trvMapService;
    }
    ngOnInit() { }
    formatDistance(input) {
        return FormatDistanceMeterKilometer(input, 3);
    }
    seeWkt(index) {
        if (this.rulerDistance && index >= 0 && index < this.rulerDistance.distance.length) {
            let trvMap = this.trvMap;
            trvMap.trvLayer.tempLayer.getSource()?.clear();
            let feature = trvMap.trvLayer.getFeatureFromWkt(this.rulerDistance.wkt[index]);
            feature.setStyle(RulerLineHover);
            trvMap.trvLayer.addFeature(feature, trvMap?.trvLayer.tempLayer);
        }
    }
    seeWktAllPrevious(index) {
        if (this.rulerDistance && index >= 0 && index < this.rulerDistance.distance.length) {
            let trvMap = this.trvMap;
            trvMap.trvLayer.tempLayer.getSource()?.clear();
            for (let i = 0; i <= index; i++) {
                const wkt = this.rulerDistance.wkt[i];
                let feature = trvMap.trvLayer.getFeatureFromWkt(wkt);
                feature.setStyle(RulerLineHover);
                trvMap.trvLayer.addFeature(feature, trvMap?.trvLayer.tempLayer);
            }
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: RulerLengthComponent, deps: [{ token: TrvNgMapService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.2.0", type: RulerLengthComponent, isStandalone: true, selector: "lib-ruler-length", usesInheritance: true, ngImport: i0, template: "@if (!simpleRulerTool) {\r\n<div class=\"ruler\">\r\n    <div class=\"header\">\r\n        L\u00E4ngdverktyg\r\n        <button type=\"button\" aria-label=\"St\u00E4ng\" class=\"btn btn-link\" (click)=\"close()\">\r\n            <svg\r\n                _ngcontent-app-c19=\"\"\r\n                xmlns=\"http://www.w3.org/2000/svg\"\r\n                width=\"18\"\r\n                height=\"18\"\r\n                fill=\"currentColor\"\r\n                class=\"bi bi-x-lg\"\r\n                viewBox=\"0 0 16 16\"\r\n            >\r\n                <path\r\n                    _ngcontent-app-c19=\"\"\r\n                    d=\"M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z\"\r\n                    fill-rule=\"\"\r\n                    class=\"ng-star-inserted\"\r\n                ></path>\r\n            </svg>\r\n        </button>\r\n    </div>\r\n    <div class=\"body\">\r\n        @if (simpleRulerTool && rulerDistance) {\r\n        <div>\r\n            <span (mousemove)=\"seeWktAllPrevious(rulerDistance.totalDistance.length - 1)\" class=\"simpleSpan\">\r\n                <strong>L\u00E4ngd:</strong>\r\n                {{ formatDistance(rulerDistance.totalDistance[rulerDistance.totalDistance.length - 1]) }}\r\n            </span>\r\n        </div>\r\n        }\r\n\r\n        <div>\r\n            @if (rulerDistance) {\r\n            <table class=\"\">\r\n                <thead>\r\n                    <tr>\r\n                        <th scope=\"col\">L\u00E4ngd delstr\u00E4cka</th>\r\n                        <th scope=\"col\">Total l\u00E4ngd</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody>\r\n                    @for (distance of rulerDistance.distance; track distance; let i = $index) {\r\n                    <tr\r\n                        [ngClass]=\"{\r\n                            'last-row': i === rulerDistance.distance.length - 1\r\n                        }\"\r\n                    >\r\n                        <td (mousemove)=\"seeWkt(i)\">\r\n                            {{ formatDistance(rulerDistance.distance[i]) }}\r\n                        </td>\r\n                        <td (mousemove)=\"seeWktAllPrevious(i)\">\r\n                            {{ formatDistance(rulerDistance.totalDistance[i]) }}\r\n                        </td>\r\n                    </tr>\r\n                    }\r\n                </tbody>\r\n            </table>\r\n            }\r\n        </div>\r\n    </div>\r\n</div>\r\n} @else {\r\n  @if(rulerDistance) {\r\n<div class=\"simple-ruler\">\r\n    \r\n    <span (mousemove)=\"seeWktAllPrevious(rulerDistance.totalDistance.length - 1)\" class=\"simpleSpan\">\r\n        {{ formatDistance(rulerDistance.totalDistance[rulerDistance.totalDistance.length - 1]) }}\r\n    </span>\r\n    \r\n    <button type=\"button\" aria-label=\"St\u00E4ng\" class=\"btn btn-link\" (click)=\"close()\">\r\n        <svg\r\n            _ngcontent-app-c19=\"\"\r\n            xmlns=\"http://www.w3.org/2000/svg\"\r\n            width=\"12\"\r\n            height=\"12\"\r\n            fill=\"currentColor\"\r\n            class=\"bi bi-x-lg\"\r\n            viewBox=\"0 0 16 16\"\r\n        >\r\n            <path\r\n                _ngcontent-app-c19=\"\"\r\n                d=\"M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z\"\r\n                fill-rule=\"\"\r\n                class=\"ng-star-inserted\"\r\n            ></path>\r\n        </svg>\r\n    </button>\r\n</div>\r\n}\r\n}", styles: [""], dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: RulerLengthComponent, decorators: [{
            type: Component,
            args: [{ selector: "lib-ruler-length", imports: [
                        NgClass
                    ], template: "@if (!simpleRulerTool) {\r\n<div class=\"ruler\">\r\n    <div class=\"header\">\r\n        L\u00E4ngdverktyg\r\n        <button type=\"button\" aria-label=\"St\u00E4ng\" class=\"btn btn-link\" (click)=\"close()\">\r\n            <svg\r\n                _ngcontent-app-c19=\"\"\r\n                xmlns=\"http://www.w3.org/2000/svg\"\r\n                width=\"18\"\r\n                height=\"18\"\r\n                fill=\"currentColor\"\r\n                class=\"bi bi-x-lg\"\r\n                viewBox=\"0 0 16 16\"\r\n            >\r\n                <path\r\n                    _ngcontent-app-c19=\"\"\r\n                    d=\"M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z\"\r\n                    fill-rule=\"\"\r\n                    class=\"ng-star-inserted\"\r\n                ></path>\r\n            </svg>\r\n        </button>\r\n    </div>\r\n    <div class=\"body\">\r\n        @if (simpleRulerTool && rulerDistance) {\r\n        <div>\r\n            <span (mousemove)=\"seeWktAllPrevious(rulerDistance.totalDistance.length - 1)\" class=\"simpleSpan\">\r\n                <strong>L\u00E4ngd:</strong>\r\n                {{ formatDistance(rulerDistance.totalDistance[rulerDistance.totalDistance.length - 1]) }}\r\n            </span>\r\n        </div>\r\n        }\r\n\r\n        <div>\r\n            @if (rulerDistance) {\r\n            <table class=\"\">\r\n                <thead>\r\n                    <tr>\r\n                        <th scope=\"col\">L\u00E4ngd delstr\u00E4cka</th>\r\n                        <th scope=\"col\">Total l\u00E4ngd</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody>\r\n                    @for (distance of rulerDistance.distance; track distance; let i = $index) {\r\n                    <tr\r\n                        [ngClass]=\"{\r\n                            'last-row': i === rulerDistance.distance.length - 1\r\n                        }\"\r\n                    >\r\n                        <td (mousemove)=\"seeWkt(i)\">\r\n                            {{ formatDistance(rulerDistance.distance[i]) }}\r\n                        </td>\r\n                        <td (mousemove)=\"seeWktAllPrevious(i)\">\r\n                            {{ formatDistance(rulerDistance.totalDistance[i]) }}\r\n                        </td>\r\n                    </tr>\r\n                    }\r\n                </tbody>\r\n            </table>\r\n            }\r\n        </div>\r\n    </div>\r\n</div>\r\n} @else {\r\n  @if(rulerDistance) {\r\n<div class=\"simple-ruler\">\r\n    \r\n    <span (mousemove)=\"seeWktAllPrevious(rulerDistance.totalDistance.length - 1)\" class=\"simpleSpan\">\r\n        {{ formatDistance(rulerDistance.totalDistance[rulerDistance.totalDistance.length - 1]) }}\r\n    </span>\r\n    \r\n    <button type=\"button\" aria-label=\"St\u00E4ng\" class=\"btn btn-link\" (click)=\"close()\">\r\n        <svg\r\n            _ngcontent-app-c19=\"\"\r\n            xmlns=\"http://www.w3.org/2000/svg\"\r\n            width=\"12\"\r\n            height=\"12\"\r\n            fill=\"currentColor\"\r\n            class=\"bi bi-x-lg\"\r\n            viewBox=\"0 0 16 16\"\r\n        >\r\n            <path\r\n                _ngcontent-app-c19=\"\"\r\n                d=\"M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z\"\r\n                fill-rule=\"\"\r\n                class=\"ng-star-inserted\"\r\n            ></path>\r\n        </svg>\r\n    </button>\r\n</div>\r\n}\r\n}" }]
        }], ctorParameters: () => [{ type: TrvNgMapService, decorators: [{
                    type: Inject,
                    args: [TrvNgMapService]
                }] }] });

class PointerPositionOverlayComponent extends OlOverlayComponent {
    clipboard;
    cdr;
    trvMapService;
    feature;
    coordinate;
    showExit = false;
    showMessage = false;
    messageTime;
    messageTimeDisplayMs = 2500;
    currMs = 0;
    percentage = 0;
    timerSubscription;
    trvMap;
    constructor(clipboard, cdr, trvMapService) {
        super();
        this.clipboard = clipboard;
        this.cdr = cdr;
        this.trvMapService = trvMapService;
    }
    ngOnInit() { }
    init() {
        this.showMessage = false;
        this.percentage = 100;
        this.currMs = 0;
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }
    copyPositions() {
        if (this.coordinate) {
            this.clipboard.copy("N=" + this.coordinate[1].toFixed(3) + " E=" + this.coordinate[0].toFixed(3));
            this.displayMessage();
        }
    }
    displayMessage() {
        const messageTime = DateTime.local();
        this.showMessage = true;
        this.percentage = 100;
        this.currMs = 0;
        const timer$ = interval(10);
        this.timerSubscription = timer$
            .pipe(takeWhile(() => {
            if (!(this.currMs < this.messageTimeDisplayMs))
                this.showMessage = false;
            return this.currMs < this.messageTimeDisplayMs;
        }))
            .subscribe(() => {
            const now = DateTime.local();
            const duration = now.diff(messageTime);
            const millisecondsElapsed = duration.as("milliseconds");
            this.currMs = millisecondsElapsed;
            let dec = 1 - this.currMs / this.messageTimeDisplayMs;
            let percentage = dec * 100;
            if (percentage < 0)
                percentage = 0;
            if (percentage > 100)
                percentage = 100;
            this.percentage = percentage;
            if (millisecondsElapsed > this.messageTimeDisplayMs) {
                this.showMessage = false;
            }
        });
    }
    onMouseEnter() {
        if (this.showExit)
            this.trvMap.trvInteractions.isHoveringPinOverlay = true;
    }
    // Method to execute when mouse leaves the div
    onMouseLeave() {
        if (this.showExit)
            this.trvMap.trvInteractions.isHoveringPinOverlay = false;
    }
    closeAndRemove() {
        if (this.feature) {
            this.trvMap?.trvLayer.pinLayer.getSource()?.removeFeature(this.feature);
        }
        this.close();
    }
    ngOnDestroy() {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: PointerPositionOverlayComponent, deps: [{ token: i1.Clipboard }, { token: i0.ChangeDetectorRef }, { token: TrvNgMapService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.2.0", type: PointerPositionOverlayComponent, isStandalone: true, selector: "lib-pointer-position-overlay", usesInheritance: true, ngImport: i0, template: "@if (showMessage) {\r\n    <div class=\"pin-position-message\">\r\n        <div class=\"msg\">Kopierade till urklipp</div>\r\n        <div class=\"bar\" [style.width.%]=\"percentage\"></div>\r\n    </div>\r\n}\r\n@if(trvMap?.trvInteractions?.simplePositionTool) {\r\n<div class=\"simple-pin-position-overlay\">\r\n    <div class=\"simple-pin-position-icon-section\" (click)=\"copyPositions()\" data-tooltip=\"Kopiera koordinater\" data-tooltip-position=\"bottom\">\r\n        <div class=\"d-flex justify-content-center align-items-center h-100\">\r\n            <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\">\r\n                <path d=\"M17.625 21.75h-12.375v-15.375h1.5v-1.5h-3v18.375h15.375v-3h-1.5v1.5z\"></path>\r\n                <path d=\"M16.811 0.75h-8.561v18h15v-11.561zM21.75 7.811v0.064h-5.625v-5.625h0.064zM9.75 17.25v-15h4.875v7.125h7.125v7.875z\"></path>\r\n            </svg>\r\n        </div>\r\n    </div>\r\n    @if (coordinate) {\r\n    <span>N={{ coordinate[1].toFixed(0) }} E={{ coordinate[0].toFixed(0) }}</span>\r\n    }\r\n    <div class=\"simple-pin-position-close-section\">\r\n        <button type=\"button\" aria-label=\"St\u00E4ng\" class=\"btn btn-link\" (click)=\"closeAndRemove()\">\r\n            <svg\r\n                _ngcontent-app-c19=\"\"\r\n                xmlns=\"http://www.w3.org/2000/svg\"\r\n                width=\"14\"\r\n                height=\"14\"\r\n                fill=\"currentColor\"\r\n                class=\"bi bi-x-lg\"\r\n                viewBox=\"0 0 16 16\"\r\n            >\r\n                <path\r\n                    _ngcontent-app-c19=\"\"\r\n                    d=\"M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z\"\r\n                    fill-rule=\"\"\r\n                    class=\"ng-star-inserted\"\r\n                ></path>\r\n            </svg>\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n} @else {\r\n<div class=\"pin-position-overlay\" (mouseenter)=\"onMouseEnter()\" (mouseleave)=\"onMouseLeave()\">\r\n    <div class=\"pin-position-icon-section\" (click)=\"copyPositions()\" data-tooltip=\"Kopiera koordinater\" data-tooltip-position=\"bottom\">\r\n        <div class=\"d-flex justify-content-center align-items-center h-100\">\r\n            <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\r\n                <path d=\"M17.625 21.75h-12.375v-15.375h1.5v-1.5h-3v18.375h15.375v-3h-1.5v1.5z\"></path>\r\n                <path d=\"M16.811 0.75h-8.561v18h15v-11.561zM21.75 7.811v0.064h-5.625v-5.625h0.064zM9.75 17.25v-15h4.875v7.125h7.125v7.875z\"></path>\r\n            </svg>\r\n        </div>\r\n    </div>\r\n    <div class=\"pin-position-coordinate-section\">\r\n        @if (coordinate) {\r\n        <span>N={{ coordinate[1].toFixed(0) }} E={{ coordinate[0].toFixed(0) }}</span>\r\n        }\r\n    </div>\r\n    @if (showExit) {\r\n    <div class=\"pin-position-close-section\">\r\n        <button type=\"button\" aria-label=\"St\u00E4ng\" class=\"btn btn-link\" (click)=\"closeAndRemove()\">\r\n            <svg\r\n                _ngcontent-app-c19=\"\"\r\n                xmlns=\"http://www.w3.org/2000/svg\"\r\n                width=\"18\"\r\n                height=\"18\"\r\n                fill=\"currentColor\"\r\n                class=\"bi bi-x-lg\"\r\n                viewBox=\"0 0 16 16\"\r\n            >\r\n                <path\r\n                    _ngcontent-app-c19=\"\"\r\n                    d=\"M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z\"\r\n                    fill-rule=\"\"\r\n                    class=\"ng-star-inserted\"\r\n                ></path>\r\n            </svg>\r\n        </button>\r\n    </div>\r\n    }\r\n</div>\r\n}\r\n", styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: PointerPositionOverlayComponent, decorators: [{
            type: Component,
            args: [{ selector: "lib-pointer-position-overlay", imports: [], template: "@if (showMessage) {\r\n    <div class=\"pin-position-message\">\r\n        <div class=\"msg\">Kopierade till urklipp</div>\r\n        <div class=\"bar\" [style.width.%]=\"percentage\"></div>\r\n    </div>\r\n}\r\n@if(trvMap?.trvInteractions?.simplePositionTool) {\r\n<div class=\"simple-pin-position-overlay\">\r\n    <div class=\"simple-pin-position-icon-section\" (click)=\"copyPositions()\" data-tooltip=\"Kopiera koordinater\" data-tooltip-position=\"bottom\">\r\n        <div class=\"d-flex justify-content-center align-items-center h-100\">\r\n            <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\">\r\n                <path d=\"M17.625 21.75h-12.375v-15.375h1.5v-1.5h-3v18.375h15.375v-3h-1.5v1.5z\"></path>\r\n                <path d=\"M16.811 0.75h-8.561v18h15v-11.561zM21.75 7.811v0.064h-5.625v-5.625h0.064zM9.75 17.25v-15h4.875v7.125h7.125v7.875z\"></path>\r\n            </svg>\r\n        </div>\r\n    </div>\r\n    @if (coordinate) {\r\n    <span>N={{ coordinate[1].toFixed(0) }} E={{ coordinate[0].toFixed(0) }}</span>\r\n    }\r\n    <div class=\"simple-pin-position-close-section\">\r\n        <button type=\"button\" aria-label=\"St\u00E4ng\" class=\"btn btn-link\" (click)=\"closeAndRemove()\">\r\n            <svg\r\n                _ngcontent-app-c19=\"\"\r\n                xmlns=\"http://www.w3.org/2000/svg\"\r\n                width=\"14\"\r\n                height=\"14\"\r\n                fill=\"currentColor\"\r\n                class=\"bi bi-x-lg\"\r\n                viewBox=\"0 0 16 16\"\r\n            >\r\n                <path\r\n                    _ngcontent-app-c19=\"\"\r\n                    d=\"M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z\"\r\n                    fill-rule=\"\"\r\n                    class=\"ng-star-inserted\"\r\n                ></path>\r\n            </svg>\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n} @else {\r\n<div class=\"pin-position-overlay\" (mouseenter)=\"onMouseEnter()\" (mouseleave)=\"onMouseLeave()\">\r\n    <div class=\"pin-position-icon-section\" (click)=\"copyPositions()\" data-tooltip=\"Kopiera koordinater\" data-tooltip-position=\"bottom\">\r\n        <div class=\"d-flex justify-content-center align-items-center h-100\">\r\n            <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\r\n                <path d=\"M17.625 21.75h-12.375v-15.375h1.5v-1.5h-3v18.375h15.375v-3h-1.5v1.5z\"></path>\r\n                <path d=\"M16.811 0.75h-8.561v18h15v-11.561zM21.75 7.811v0.064h-5.625v-5.625h0.064zM9.75 17.25v-15h4.875v7.125h7.125v7.875z\"></path>\r\n            </svg>\r\n        </div>\r\n    </div>\r\n    <div class=\"pin-position-coordinate-section\">\r\n        @if (coordinate) {\r\n        <span>N={{ coordinate[1].toFixed(0) }} E={{ coordinate[0].toFixed(0) }}</span>\r\n        }\r\n    </div>\r\n    @if (showExit) {\r\n    <div class=\"pin-position-close-section\">\r\n        <button type=\"button\" aria-label=\"St\u00E4ng\" class=\"btn btn-link\" (click)=\"closeAndRemove()\">\r\n            <svg\r\n                _ngcontent-app-c19=\"\"\r\n                xmlns=\"http://www.w3.org/2000/svg\"\r\n                width=\"18\"\r\n                height=\"18\"\r\n                fill=\"currentColor\"\r\n                class=\"bi bi-x-lg\"\r\n                viewBox=\"0 0 16 16\"\r\n            >\r\n                <path\r\n                    _ngcontent-app-c19=\"\"\r\n                    d=\"M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z\"\r\n                    fill-rule=\"\"\r\n                    class=\"ng-star-inserted\"\r\n                ></path>\r\n            </svg>\r\n        </button>\r\n    </div>\r\n    }\r\n</div>\r\n}\r\n" }]
        }], ctorParameters: () => [{ type: i1.Clipboard }, { type: i0.ChangeDetectorRef }, { type: TrvNgMapService }] });

/**
 * Class that handles all the Interactions to the map. \
 * This class handles both regular ol/interactions, \
 * as well as custom ones that can be registered.
 */
class TrvInteractions {
    trvMapService;
    httpClient;
    /** Reference to parent TrvMap object */
    trvMap;
    /** Reference to TrvMapOverLayService */
    trvMapOverlayService;
    /** This variables holds references to what MapTool is mapped to what Interaction */
    customToolInteractions = {};
    /** Constant that defines how many milliseconds (maximum) ther should be between two clicks for it to be definend as a double click.\
     * Todo: Move to TrvMapUtils
     */
    doubleClickTimeMs = 200;
    //Interaction constants
    DragRotate = DragRotate;
    DoubleClickZoom = DoubleClickZoom;
    DragPan = DragPan;
    PinchRotate = PinchRotate;
    PinchZoom = PinchZoom;
    KeyboardPan = KeyboardPan;
    KeyboardZoom = KeyboardZoom;
    MouseWheelZoom = MouseWheelZoom;
    DragZoom = DragZoom;
    /** Custom Interactions of DragZoom that removes the ability to DragZoom with shift down. */
    DragZoomCustom = new DragZoom({
        condition: function (event) {
            return !shiftKeyOnly(event);
        },
    });
    /** Custom Interactions of DragZoom that removes the ability to DragZoom with shift down. */
    DragZoomShift = new DragZoomShift({
        condition: function (event) {
            return shiftKeyOnly(event);
        },
    });
    /** Custom Interaction that enables DragPan if shift is held down.  */
    DragPanShift = new DragPan({
        condition: function (event) {
            return shiftKeyOnly(event);
        },
    });
    dragPanInteraction;
    //Tool specific variables
    //Ruler tool
    //#region RulerTool variables
    rulerActive = false;
    timeLastUsedRulerMs = DateTime.now().toMillis();
    rulerCoordinates = [];
    rulerMouseCoord = null;
    rulerMouseFeature = null;
    rulerDistanceComponent;
    isHoveringPinOverlay = false;
    lineDraw;
    isDrawingRuler = false;
    /**
     * Enables advanced or simple ruler tool. \
     * simpleRulerTool = true only shows the distance in the ruler tool overlay. \
     * simpleRulerTool = false shows the acumulated distance in a table in the ruler tool overlay.
     */
    simpleRulerTool = false;
    //#endregion
    //Zoom tool
    //#region RulerTool variables
    zoomActive = false;
    zoomCoordinate = null;
    //#endregion
    //#region ExportMapTool variables
    exportMapFeature;
    startDragCoordinate;
    isDraggingExportFeature = false;
    exportTranslate;
    exportTranslateFeaturesCollection = new Collection();
    isExportTranslating = false;
    //#endregion
    //#region TrvRouting variables
    trvRoutingBaseUrl = "https://bas.gis.trafikverket.local/arcgis/rest/services/Routing/TrvRouting/GPServer";
    //#endregion
    //#region StreetView Tool variables
    currentStreetViewCoordinates = [0, 0];
    /** Threshold value in pixels. \
     * Used in streetview tool as a threshold to recheck Check availablility for streetview
     */
    streetViewDistanceThreshold = 20;
    /**
     * Threshold value for zoom. \
     * Used in streetview tool as threshold for what zoom level is acceptable for streetview
     */
    streetViewZoomThreshold = 7.5;
    //#endregion
    mouseDown = false;
    /** Mapping of MapTools to interaction function */
    interactionsMap = {};
    /** */
    pointerPositionOverlayStatic;
    pointerPositionOverlayMoving;
    /**
     * Enables advanced or simple position tool. \
     * simplePositionTool = true  doesn't show preview when hoovering the map, as well as a simple design\
     * simplePositionTool = false shows preview when hoovering the map.
     */
    simplePositionTool = false;
    constructor(trvMap, trvMapService, trvMapOverlayService, httpClient) {
        this.trvMapService = trvMapService;
        this.httpClient = httpClient;
        this.trvMap = trvMap;
        this.trvMapOverlayService = trvMapOverlayService;
        this.trvMap.map.addInteraction(this.DragZoomCustom);
        this.DragZoomCustom.setActive(false);
        this.trvMap.map.addInteraction(this.DragZoomShift);
        this.DragZoomShift.setActive(true);
        this.trvMap.map.addInteraction(this.DragPanShift);
        this.DragPanShift.setActive(false);
        this.dragPanInteraction = this.trvMap.map
            .getInteractions()
            .getArray()
            .find(interaction => interaction instanceof DragPan);
        this.registerMapToolInteraction({
            mapTool: MapTools.Ruler,
            initFunc: this.rulerInit.bind(this),
            resetFunc: this.rulerReset.bind(this),
            clickFunc: this.rulerClick.bind(this),
            moveFunc: this.rulerMove.bind(this),
        });
        this.registerInteractionStateForTool(MapTools.Ruler, DoubleClickZoom, false);
        this.registerMapToolInteraction({
            mapTool: MapTools.StreetView,
            initFunc: this.streetViewInit.bind(this),
            resetFunc: this.streetViewReset.bind(this),
            clickFunc: this.streetViewToolClick.bind(this),
            moveFunc: this.streetViewToolMove.bind(this),
        });
        this.registerMapToolInteraction({
            mapTool: MapTools.Zoom,
            initFunc: this.initZoom.bind(this),
            resetFunc: this.resetZoom.bind(this),
            moveFunc: this.zoomPointerMove.bind(this),
        });
        this.registerInteractionStateForTool(MapTools.Zoom, DoubleClickZoom, false);
        this.registerInteractionStateForTool(MapTools.Zoom, DragPan, false);
        this.registerInteractionStateForTool(MapTools.Zoom, KeyboardZoom, false);
        this.registerMapToolInteraction({
            mapTool: MapTools.ExportRectangle,
            initFunc: this.exportMapToolInit.bind(this),
            resetFunc: this.exportMapToolReset.bind(this),
            moveFunc: this.exportMapToolMove.bind(this),
            //moveFunc: this.exportMapToolPointerDown.bind(this),
        });
        // resetFunc: this.rulerPointerReset.bind(this),
        this.registerInteractionStateForTool(MapTools.ExportRectangle, DoubleClickZoom, false);
        //Pin-location tool
        this.registerMapToolInteraction({
            mapTool: MapTools.PinPosition,
            resetFunc: this.pinPositionReset.bind(this),
            clickFunc: this.pinPositionPointerClick.bind(this),
            moveFunc: this.pinPositionPointerMove.bind(this),
        });
        this.registerInteractionStateForTool(MapTools.PinPosition, this.DoubleClickZoom, false);
        this.registerInteractionStateForTool(MapTools.Pointer, this.DragZoomShift, true);
        this.registerInteractionStateForTool(MapTools.ExportRectangle, this.DragZoomShift, true);
        this.registerInteractionStateForTool(MapTools.StreetView, this.DragZoomShift, true);
        this.initializeInteractions();
        this.defaultInteractionsState();
    }
    /**
     * Method that register what different functions a Maptool should run on different conditions.\
     * Example usage:
     *
     * ```ts
     * trvInteractions.registerMapToolInteraction({
     *  mapTool: MapTools.CustomTool,
     *  moveFunc: this.customMoveFunc.bind(this),
     *  clickFunc: this.customClickFunc.bind(this),
     *  initFunc: this.customInitFunc.bind(this),
     *  resetFunc: this.customResetFunc.bind(this)
     * })
     * ```
     *
     * @param {RegisterObj} registerObj - An object containing properties for configuring the map tool interaction.
     * @param {MapToolsType} registerObj.mapTool - MapTool to register functions to
     * @param {*} [registerObj.moveFunc=null] -  Reference to the function that triggers when mouse is moved inside the map (Optional)
     * @param {*} [registerObj.clickFunc=null] - Reference to the function that triggers when mouse is clicked inside the map (Optional)
     * @param {*} [registerObj.initFunc=null] -  Reference to the function that triggers when a mapTool is changed, for initializing (Optional)
     * @param {*} [registerObj.resetFunc=null] - Reference to the function that triggers when a mapTool is changed, for reseting (Optional)
     */
    registerMapToolInteraction(registerObj) {
        const innerObj = {
            move: registerObj.moveFunc,
            click: registerObj.clickFunc,
            init: registerObj.initFunc,
            reset: registerObj.resetFunc,
        };
        this.interactionsMap[registerObj.mapTool] = innerObj;
    }
    /**
     * Method that activates / deactivates in interaction based on className and a boolean
     * @param className The name of the class to activate / deactivate
     * @param active True if active, false if not active
     */
    setInteractionState(className, active) {
        this.trvMap.map.getInteractions().forEach(interaction => {
            if (interaction.constructor.name === className.constructor.name) {
                interaction.setActive(active);
            }
        });
    }
    /**
     * Method that registers if an interaction should be active or not for a specific MapTool.
     * @param toolName The MapTool
     * @param className The class name of the interaction
     * @param active Boolean value if the interaction should be
     */
    registerInteractionStateForTool(toolName, className, active) {
        if (!this.customToolInteractions.hasOwnProperty(toolName)) {
            this.customToolInteractions[toolName] = [];
        }
        let interactionActive = {
            interaction: className,
            active: active,
        };
        this.customToolInteractions[toolName].push(interactionActive);
    }
    /**
     * Method that enables / disables registered interactions for a MapTool.
     * @param toolName The MapTool
     */
    setInteractionsStateForTool(toolName) {
        if (this.customToolInteractions.hasOwnProperty(toolName)) {
            this.customToolInteractions[toolName].forEach((interactionActive) => {
                this.setInteractionState(interactionActive.interaction, interactionActive.active);
            });
        }
    }
    /**
     * Method that enables the Default interaction states. \
     * Ex. The interactions DragPan & DoubleClickZoom should be active by default.
     */
    defaultInteractionsState() {
        this.trvMap.map.getInteractions().forEach(interaction => {
            if (interaction instanceof DragRotate)
                interaction.setActive(true);
            if (interaction instanceof DoubleClickZoom)
                interaction.setActive(true);
            if (interaction instanceof DragPan) {
                interaction.setActive(true);
            }
            if (interaction instanceof DragPanShiftDisable) {
                interaction.setActive(false);
            }
            if (interaction instanceof PinchRotate)
                interaction.setActive(false);
            if (interaction instanceof PinchZoom)
                interaction.setActive(true);
            if (interaction instanceof KeyboardPan)
                interaction.setActive(true);
            if (interaction instanceof KeyboardZoom)
                interaction.setActive(true);
            if (interaction instanceof MouseWheelZoom)
                interaction.setActive(true);
            if (interaction instanceof DragZoom) {
                interaction.setActive(false);
            }
            if (interaction instanceof DragZoomShift) {
                interaction.setActive(false);
            }
            //.log(interaction)
        });
    }
    /**
     * Method that initializes all custom interactions
     */
    initializeInteractions() {
        let thethis = this;
        //Handle click
        this.trvMap.map.on("click", function (evt) {
            if (evt.dragging) {
                return;
            }
            const currMapTool = thethis.trvMap.activeMapTool?.value;
            //IF the mapTool has a registered function for click
            if (currMapTool in thethis.interactionsMap) {
                if (thethis.interactionsMap[currMapTool]["click"] != null)
                    thethis.interactionsMap[currMapTool]["click"](evt, thethis.trvMap);
            }
        });
        //Handles what happens when the pointer moves over the map
        this.trvMap.map.on("pointermove", function (evt) {
            const currMapTool = thethis.trvMap.activeMapTool?.value;
            //IF the mapTool has a registered function for click
            if (currMapTool in thethis.interactionsMap) {
                if (thethis.interactionsMap[currMapTool]["move"] != null)
                    thethis.interactionsMap[currMapTool]["move"](evt, thethis.trvMap);
            }
        });
        this.trvMap.map.getViewport().addEventListener("pointerdown", this.onMouseDown);
        this.trvMap.map.getViewport().addEventListener("pointerup", this.onMouseUp);
    }
    /**
     * Method that runs the initFunction for the current activeMapTool. \
     * This method only runs if the maptool has been changed.
     */
    initMaptoolInteractions() {
        if (this.trvMap.activeMapTool?.value != this.trvMap.prevMapTool) {
            //Loop through all registred mapTool interactions and call reset func.
            const mapToolInteractionFuncs = this.interactionsMap[this.trvMap.activeMapTool?.value];
            if (mapToolInteractionFuncs && mapToolInteractionFuncs["init"] != null) {
                mapToolInteractionFuncs["init"](this.trvMap);
            }
        }
    }
    /**
     * Method that runs the resetfunction for the current activeMapTool. \
     * This method only runs if the mapTool has been changed.
     */
    resetMaptoolInteractions() {
        //If maptool was changed.
        if (this.trvMap.activeMapTool?.value != this.trvMap.prevMapTool) {
            //Loop through all registred mapTool interactions and call reset func.
            for (let i in this.interactionsMap) {
                const mapToolInteractionFuncs = this.interactionsMap[i];
                if (mapToolInteractionFuncs["reset"] != null) {
                    mapToolInteractionFuncs["reset"](this.trvMap);
                }
            }
        }
    }
    onMouseDown = (event) => {
        this.mouseDown = true;
    };
    onMouseUp = (event) => {
        this.mouseDown = false;
    };
    clearPinPosition() {
        this.trvMap.trvLayer
            .pinLayer.getSource()
            ?.getFeatures()
            .forEach(pinFeature => {
            let overlay = pinFeature.get("overlay");
            if (overlay) {
                overlay.closeAndRemove();
            }
        });
    }
    pointerInit(trvMap) {
        //console.log("init");
    }
    pinPositionPointerClick(evt, trvMap) {
        let point = new Point(evt.coordinate);
        let pinFeature = new Feature(point);
        pinFeature.setStyle(PinBlueInfoStyle);
        this.trvMap.trvLayer.addFeature(pinFeature, this.trvMap.trvLayer.pinLayer, false, null);
        let offset = [25, 6];
        let pos = "bottom-left";
        if (this.simplePositionTool) {
            offset = [25, -2];
        }
        const pointerPositionOverlayStatic = this.trvMapOverlayService.addOverlay(trvMap, PointerPositionOverlayComponent, evt.coordinate, offset, pos);
        pointerPositionOverlayStatic.overLay?.setPosition(evt.coordinate);
        pointerPositionOverlayStatic.coordinate = evt.coordinate;
        pointerPositionOverlayStatic.showExit = true;
        pointerPositionOverlayStatic.feature = pinFeature;
        pointerPositionOverlayStatic.trvMap = trvMap;
        pointerPositionOverlayStatic.init();
        pinFeature.set("overlay", pointerPositionOverlayStatic);
    }
    pinPositionPointerMove(evt, trvMap) {
        if (this.simplePositionTool)
            return;
        trvMap.trvLayer.tempLayer?.getSource()?.clear();
        let point = new Point(evt.coordinate);
        let pinFeature = new Feature(point);
        pinFeature.setStyle(PinBlueInfoStyle);
        if (!this.isHoveringPinOverlay)
            trvMap.trvLayer.addFeature(pinFeature, trvMap.trvLayer.tempLayer, false, null);
        //Handle overlay
        if (!this.pointerPositionOverlayMoving)
            this.pointerPositionOverlayMoving = this.trvMapOverlayService.addOverlay(trvMap, PointerPositionOverlayComponent, evt.coordinate, [25, 6], "bottom-left");
        if (!this.isHoveringPinOverlay) {
            this.pointerPositionOverlayMoving.coordinate = evt.coordinate;
            this.pointerPositionOverlayMoving.trvMap = trvMap;
            this.pointerPositionOverlayMoving.overLay?.setPosition(evt.coordinate);
            this.pointerPositionOverlayMoving.init();
            this.pointerPositionOverlayMoving.open();
        }
        else {
            this.pointerPositionOverlayMoving.close();
        }
    }
    pinPositionReset(trvMap) {
        trvMap.trvLayer.tempLayer?.getSource()?.clear();
        if (this.pointerPositionOverlayMoving) {
            this.pointerPositionOverlayMoving.closeAndRemove();
            this.pointerPositionOverlayMoving = undefined;
            this.isHoveringPinOverlay = false;
        }
    }
    rulerMove(evt, trvMap) {
        trvMap.trvLayer.tempLayer?.getSource()?.clear();
        const point = new Point(evt.coordinate);
        this.rulerMouseCoord = evt.coordinate;
        const mouseFeature = new Feature(point);
        mouseFeature.setStyle(DefaultPointStyle);
        trvMap.trvLayer.addFeature(mouseFeature, this.trvMap.trvLayer.tempLayer, false, null);
    }
    rulerClick(evt, trvMap) { }
    rulerInit(trvMap) {
        this.lineDraw = new Draw({
            source: trvMap.trvLayer.rulerLayer.getSource(),
            type: "LineString",
            style: RulerLineString,
        });
        trvMap.map.addInteraction(this.lineDraw);
        if (this.rulerCoordinates && this.rulerCoordinates.length > 0) {
            if (this.rulerDistanceComponent) {
                this.rulerDistanceComponent.open();
            }
        }
        //Event that triggers when drawing is starting
        this.lineDraw.on("drawstart", (event) => {
            trvMap.trvLayer.rulerLayer?.getSource()?.clear();
            this.isDrawingRuler = true;
            let drawFeature = event.feature;
            drawFeature.on("change", evt => {
                let feature = evt.target;
                if (feature instanceof Feature && feature.getGeometry() instanceof LineString) {
                    let coord = feature.getGeometry().getCoordinates();
                    this.rulerCoordinates = coord;
                    //Update position overlay
                    const centerRightOfExtent = getCenterRight(getExtentFromCoordinates(coord));
                    this.addOrUpdateRulerOverlay(trvMap, centerRightOfExtent);
                    trvMap.trvLayer.tempLayer2.getSource()?.clear();
                    this.rulerCoordinates.forEach(pointCoord => {
                        let rulerPointFeature = new Feature(new Point(pointCoord));
                        trvMap.trvLayer.addFeature(rulerPointFeature, trvMap.trvLayer.tempLayer2);
                        rulerPointFeature.setStyle(RulerLinePoint);
                    });
                }
            });
        });
        //Event that triggers when drawing is finished
        this.lineDraw.on("drawend", (event) => {
            //Wait .5 second before we set isDrawing to false.
            setTimeout(() => {
                this.isDrawingRuler = false;
            }, 500);
            console.log("HELLO?");
            // get the drawn feature
            const feature = event.feature;
            feature.setStyle(RulerLineString);
            const geom = feature.getGeometry();
            if (geom instanceof LineString) {
                let coord = geom.getCoordinates();
                this.rulerCoordinates = coord;
                //Update position overlay
                const centerRightOfExtent = getCenterRight(getExtentFromCoordinates(coord));
                this.addOrUpdateRulerOverlay(trvMap, centerRightOfExtent);
                trvMap.trvLayer.tempLayer2.getSource()?.clear();
                this.rulerCoordinates.forEach(pointCoord => {
                    let rulerPointFeature = new Feature(new Point(pointCoord));
                    trvMap.trvLayer.addFeature(rulerPointFeature, trvMap.trvLayer.rulerLayer);
                    rulerPointFeature.setStyle(RulerLinePoint);
                });
            }
        });
    }
    rulerReset(trvMap) {
        this.isDrawingRuler = false;
        if (this.lineDraw) {
            trvMap.map.removeInteraction(this.lineDraw);
        }
    }
    /**
     * Method the invokes the invokes the eraser tool.
     * This method clears all temporary layers that have been added to the layergroup trvLayer.temporaryLayers.
     */
    eraserTool() {
        this.trvMap.trvLayer.clearAllTemporaryLayers();
        this.removeRulerOverlay();
        this.clearPinPosition();
    }
    /**
     * Method that returns all features that are within a radius of a ol/pixel.
     * @param pixel ol/pixel. Pixel can be calculated like this: \
     * const pixel = trvMap.map.getEventPixel(evt.originalEvent);
     * @param radiusInPixels The radius in pixels
     * @param _layer The layer to target. Default is trvLayer.workingLayer
     * @returns List of features. If no result, empty list
     */
    getFeaturesWithinRadius(pixel, radiusInPixels, _layer = this.trvMap.trvLayer.workingLayer) {
        let res = [];
        _layer?.getSource()?.forEachFeature(feature => {
            const geometry = feature.getGeometry();
            const featurePixel = this.trvMap.map.getPixelFromCoordinate(geometry.getCoordinates());
            const clickDistance = distance(pixel, featurePixel);
            if (clickDistance <= radiusInPixels) {
                res.push(feature);
            }
        });
        return res;
    }
    /**
     *   Returns all line-features that exists within a certain radius of pixel
     * @param pixel The point you want to check
     * @param radiusInPixels The radius in pixels
     * @param _layer The targeted layer
     * @returns All linestring-Features within a certain radius of pixel
     */
    getLineFeaturesWithinRadius(pixel, radiusInPixels, _layer = this.trvMap.trvLayer.workingLayer) {
        let res = [];
        _layer?.getSource()?.forEachFeature(feature => {
            const linestring = feature.getGeometry();
            if (linestring instanceof MultiLineString) {
                const lines = linestring.getCoordinates();
                loop1: for (let line of lines) {
                    for (let i = 0; i < line.length - 1; i++) {
                        const startCoord = line[i];
                        const endCoord = line[i + 1];
                        const startPixel = this.trvMap.map.getPixelFromCoordinate(startCoord);
                        const endPixel = this.trvMap.map.getPixelFromCoordinate(endCoord);
                        if (LineIntersectCircle(startPixel, endPixel, pixel, radiusInPixels)) {
                            res.push(feature);
                            break loop1;
                        }
                    }
                }
            }
            else if (linestring instanceof LineString) {
                const coordinates = linestring.getCoordinates();
                for (let i = 0; i < coordinates.length - 1; i++) {
                    const startCoord = coordinates[i];
                    const endCoord = coordinates[i + 1];
                    const startPixel = this.trvMap.map.getPixelFromCoordinate(startCoord);
                    const endPixel = this.trvMap.map.getPixelFromCoordinate(endCoord);
                    if (LineIntersectCircle(startPixel, endPixel, pixel, radiusInPixels)) {
                        res.push(feature);
                        break;
                    }
                }
            }
        });
        return res;
    }
    /**
     * Method that finds the smallest (by area) feature at a pixel. \
     * If multiple features are overlaps at that pixel, the smallest is returned. \
     * If no feature is found, undefined is returned.
     * @param pixel ol/pixel. Pixel can be calculated like this: \
     * const pixel = trvMap.map.getEventPixel(evt.originalEvent);
     * @param _layer The layer to target. Default is trvLayer.workingLayer
     * @returns The smallest feature at a pixel. Undefined if no feature present
     */
    getSmallestFeatureAtPixel(pixel, _layer = this.trvMap.trvLayer.workingLayer) {
        const thethis = this;
        let smallFeature = undefined;
        let smallArea = Infinity;
        this.trvMap.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
            let extent = feature.getGeometry()?.getExtent();
            const area = getArea(extent);
            if (area < smallArea) {
                smallArea = area;
                smallFeature = feature;
            }
        }, {
            layerFilter: function (layer) {
                return layer === _layer;
            },
        });
        return smallFeature;
    }
    //functions for handling different tools
    /**
     * Method that initializes Zoom Tool. This one is binded to MapTools.Zoom
     */
    initZoom(trvMap) {
        trvMap.map.addInteraction(this.DragZoomCustom);
        this.DragZoomCustom.setActive(true);
        this.DragPanShift.setActive(true);
        this.trvMap.trvLayer.tempLayer2?.getSource()?.clear();
    }
    /**
     * Method that resets the Zoom Tool. This one is binded to MapTools.Zoom
     */
    resetZoom(trvMap) {
        this.DragZoomCustom.setActive(false);
        this.DragPanShift.setActive(false);
        trvMap.trvLayer.tempLayer2?.getSource()?.clear();
    }
    //RULER
    //#region Ruler functions
    /**
     * Method that calculates the distance between points that has been placed with the ruler tool.
     * The returning RulerDistance object also contains a list with the accumulated distance
     * @returns The RulerDistance object
     */
    calculateLengthRuler() {
        let distance = [];
        let totalDistance = [];
        let wkt = [];
        if (this.rulerCoordinates.length < 1)
            return {
                distance: [],
                totalDistance: [],
                wkt: [],
            };
        let maxLength = 0;
        //If new length is less than 10m, add length to current instead.
        const minLength = 10;
        for (let index = 0; index < this.rulerCoordinates.length - 1; index++) {
            const coord1 = this.rulerCoordinates[index];
            const coord2 = this.rulerCoordinates[index + 1];
            const length = distanceBetweenPoints(coord1, coord2);
            let line = new LineString([coord1, coord2]);
            let wktStr = this.trvMap.trvLayer.wktFormat.writeGeometry(line);
            maxLength += length;
            if (index == 0) {
                distance.push(length);
                totalDistance.push(maxLength);
                wkt.push(wktStr);
            }
            else {
                if (length < minLength) {
                    distance[distance.length - 1] += length;
                    totalDistance[totalDistance.length - 1] = maxLength;
                    wkt[totalDistance.length - 1] = wktStr;
                }
                else {
                    distance.push(length);
                    totalDistance.push(maxLength);
                    wkt.push(wktStr);
                }
            }
        }
        //Add ruler mouse point
        if (this.rulerMouseCoord && this.rulerActive) {
            const lastCoord = this.rulerCoordinates[this.rulerCoordinates.length - 1];
            const length = distanceBetweenPoints(lastCoord, this.rulerMouseCoord);
            maxLength += length;
            distance.push(length);
            totalDistance.push(maxLength);
            wkt.push("");
        }
        const rulerDistance = {
            distance: distance,
            totalDistance: totalDistance,
            wkt: wkt,
        };
        return rulerDistance;
    }
    removeRulerOverlay() {
        this.rulerCoordinates = [];
        if (this.rulerDistanceComponent) {
            this.rulerDistanceComponent.close();
        }
    }
    addOrUpdateRulerOverlay(trvMap, coordinate) {
        if (!this.rulerDistanceComponent) {
            this.rulerDistanceComponent = this.trvMapOverlayService.addOverlay(trvMap, RulerLengthComponent, coordinate, [25, -15], "center-left");
            this.rulerDistanceComponent.rulerDistance = this.calculateLengthRuler();
            this.rulerDistanceComponent.simpleRulerTool = this.simpleRulerTool;
            this.rulerDistanceComponent.trvMap = trvMap;
        }
        else {
            this.rulerDistanceComponent?.overLay?.setPosition(coordinate);
            this.rulerDistanceComponent.rulerDistance = this.calculateLengthRuler();
            this.rulerDistanceComponent.simpleRulerTool = this.simpleRulerTool;
            this.rulerDistanceComponent.trvMap = trvMap;
        }
    }
    //Street view
    streetViewInit(trvMap) {
        this.trvMapService.isStreetViewAvailable = false;
        this.currentStreetViewCoordinates = [0, 0];
        this.trvMapService.streetViewLocation = null;
    }
    streetViewReset(trvMap) {
        trvMap.showStreetView = false;
        this.trvMapService.isStreetViewAvailable = false;
        this.currentStreetViewCoordinates = [0, 0];
        this.trvMapService.streetViewLocation = null;
    }
    streetViewToolClick(evt, trvMap) {
        this.currentStreetViewCoordinates = evt.coordinate;
        //this.trvMapService.streetViewAvailable(evt.coordinate);
        if (this.trvMapService.isStreetViewAvailable && trvMap.map.getView().getZoom() > this.streetViewZoomThreshold) {
            trvMap.showStreetView = true;
        }
    }
    streetViewToolMove(evt, trvMap) {
        trvMap.trvLayer.tempLayer?.getSource()?.clear();
        //check distance
        const featurePixel = trvMap.map.getPixelFromCoordinate(this.currentStreetViewCoordinates);
        const clickDistance = distance(evt.pixel, featurePixel);
        if (clickDistance > this.streetViewDistanceThreshold && this.trvMap.map.getView().getZoom() > this.streetViewZoomThreshold) {
            this.currentStreetViewCoordinates = evt.coordinate;
            this.trvMapService.streetViewAvailable(evt.coordinate);
        }
        StreetViewIconLaying.getText().setText("");
        if (this.trvMapService.streetViewLocation) {
            let location = this.trvMapService.streetViewLocation;
            let coord = trvMap.transformWgs84ToSweref(location.latLng.lng(), location.latLng.lat());
            if (coord) {
                let point2 = new Point(coord);
                let feature2 = new Feature(point2);
                trvMap.trvLayer.tempLayer?.getSource()?.addFeature(feature2);
                feature2.setStyle(DefaultPointStyle);
            }
            //Set text
            if (this.trvMapService.streetViewLocation.description)
                StreetViewIconLaying.getText().setText(this.trvMapService.streetViewLocation.description);
        }
        let point = new Point(evt.coordinate);
        let feature = new Feature(point);
        trvMap.trvLayer.tempLayer?.getSource()?.addFeature(feature);
        feature.setStyle(StreetViewIconLaying);
        if (!this.trvMapService.isStreetViewAvailable || trvMap.map.getView().getZoom() <= this.streetViewZoomThreshold) {
            feature.setStyle(StreetViewIconStanding);
            this.trvMapService.streetViewLocation = null;
        }
    }
    removeExportMapToolFeature() {
        if (this.exportMapFeature) {
            this.trvMap.trvLayer.printLayer?.getSource()?.clear();
            this.exportMapFeature = undefined;
        }
    }
    addExportMapToolFeature(paperString, scale, horizontal, center = null) {
        let centerCoord = center ?? this.trvMap.map.getView().getCenter();
        if (this.exportMapFeature) {
            const ext = this.exportMapFeature.getGeometry()?.getExtent();
            if (ext) {
                const center = getCenter(ext);
                centerCoord = center;
            }
        }
        this.removeExportMapToolFeature();
        let PaperSizeObj = PaperSize.A0;
        if (paperString == "A1")
            PaperSizeObj = PaperSize.A1;
        else if (paperString == "A2")
            PaperSizeObj = PaperSize.A2;
        else if (paperString == "A3")
            PaperSizeObj = PaperSize.A3;
        else if (paperString == "A4")
            PaperSizeObj = PaperSize.A4;
        if (centerCoord) {
            let rectangleWidth = (PaperSizeObj[0] / 1000) * scale;
            let rectangleHeight = (PaperSizeObj[1] / 1000) * scale;
            if (!horizontal) {
                rectangleHeight = (PaperSizeObj[0] / 1000) * scale;
                rectangleWidth = (PaperSizeObj[1] / 1000) * scale;
            }
            const vertOffset = rectangleWidth / 2;
            const horiOffset = rectangleHeight / 2;
            const topLeft = [centerCoord[0] - vertOffset, centerCoord[1] - horiOffset];
            const topRight = [centerCoord[0] + vertOffset, centerCoord[1] - horiOffset];
            const botRight = [centerCoord[0] + vertOffset, centerCoord[1] + horiOffset];
            const botLeft = [centerCoord[0] - vertOffset, centerCoord[1] + horiOffset];
            var rectGeometry = new Polygon([[topLeft, topRight, botRight, botLeft, topLeft]]);
            this.exportMapFeature = new Feature(rectGeometry);
            this.trvMap.trvLayer.addFeature(this.exportMapFeature, this.trvMap.trvLayer.printLayer);
            this.exportMapFeature.setStyle(DefaultExportRectStyle);
        }
    }
    _exportMapToolReset() {
        this.trvMap.trvLayer.tempLayer2?.getSource()?.clear();
    }
    exportMapToolPointerDown(evt, trvMap) {
        //Check if we hoover feature
        let hooverFeature = false;
        if (this.exportMapFeature) {
            hooverFeature = containsCoordinate(this.exportMapFeature.getGeometry()?.getExtent(), evt.coordinate);
        }
        if (this.mouseDown && (hooverFeature || this.isDraggingExportFeature)) {
            //this.registerInteractionStateForTool(MapTools.ExportRectangle, DragPan, false);
            this.dragPanInteraction.setActive(false);
            if (!this.isDraggingExportFeature) {
                this.startDragCoordinate = evt.coordinate;
                this.isDraggingExportFeature = true;
            }
            if (this.startDragCoordinate) {
                var deltaX = evt.coordinate[0] - this.startDragCoordinate[0];
                var deltaY = evt.coordinate[1] - this.startDragCoordinate[1];
                this.startDragCoordinate = evt.coordinate;
                if (this.exportMapFeature) {
                    this.exportMapFeature.getGeometry()?.translate(deltaX, deltaY);
                }
            }
        }
        else {
            this.isDraggingExportFeature = false;
        }
        if (!this.isDraggingExportFeature) {
            this.dragPanInteraction.setActive(true);
        }
    }
    /**
     initFunc: this.exportMapToolInit().bind(this),
            resetFunc: this.exportMapToolInit().bind(this),
            moveFunc: this.exportMapToolMove().bind(this),

     */
    exportMapToolInit(trvMap) {
        let source = trvMap.trvLayer.printLayer.getSource();
        if (source) {
            if (this.exportMapFeature == undefined && trvMap.printMenuState.exportSizeOption.value != ExportSize.MapView) {
                //this.addExportMapToolFeature();
                const paperString = exportSizeToString(trvMap.printMenuState.exportSizeOption.value);
                if (trvMap.printMenuState.areaCenterCoordinate == null) {
                    const map = trvMap.map;
                    const mapExtent = map.getView().calculateExtent();
                    trvMap.printMenuState.areaCenterCoordinate = getCenter(mapExtent);
                }
                trvMap.trvInteractions.addExportMapToolFeature(paperString, trvMap.printMenuState.scale.value, trvMap.printMenuState.exportDirectionOption.value == ExportDirection.Standing, trvMap.printMenuState.areaCenterCoordinate);
            }
            this.exportTranslate = new Translate({
                features: this.exportTranslateFeaturesCollection,
            });
            trvMap.map.addInteraction(this.exportTranslate);
            this.exportTranslate.on("translatestart", (event) => {
                this.isExportTranslating = true;
            });
            this.exportTranslate.on("translateend", (event) => {
                this.isExportTranslating = false;
            });
        }
    }
    exportMapToolReset(trvMap) {
        const extent = trvMap?.trvLayer?.printLayer?.getSource()?.getExtent();
        if (extent && extent[0] != Infinity) {
            trvMap.printMenuState.areaCenterCoordinate = getCenter(extent);
        }
        this.trvMap.trvLayer.tempLayer2?.getSource()?.clear();
        trvMap.map.removeInteraction(this.exportTranslate);
        this.removeExportMapToolFeature();
    }
    exportMapToolMove(evt, trvMap) {
        trvMap.trvLayer.tempLayer2?.getSource()?.clear();
        if (this.isExportTranslating)
            return;
        this.exportTranslateFeaturesCollection.clear();
        if (this.exportMapFeature)
            this.exportTranslateFeaturesCollection.push(this.exportMapFeature);
    }
    //#endregion
    zoomPointerMove(evt, trvMap) {
        trvMap.trvLayer.tempLayer2?.getSource()?.clear();
        if (!evt.originalEvent.shiftKey) {
            const point = new Point(evt.coordinate);
            const feature = new Feature(point);
            feature.setStyle(ZoomPointStyle);
            trvMap.trvLayer.tempLayer2?.getSource()?.addFeature(feature);
        }
    }
    //Trv Routing
    /**
     * Method that attaches a list of coordinates to the nearest road, and returns a MultiLineString-feature along with some metadata.
     * @param inputCoords List of coordinates
     * @param travelMode The travel mode. Default is "Kortaste vägen", other possible values are: \
     * "Kortaste vägen" | "Bästa vägen" | "Snabbaste vägen" | "Bästa cykelfärden" | "Bara cykelvägar" | "Bästa promenaden" | "Bara gångvägar"
     * @returns Observable<AttachCoordinatesToRoadResult | null> \
     * AttachCoordinatesToRoadResult has the following properties:
     * feature: MultiLineString-feature \
     * Shape_Length: The length of the feature \
     * StopCount: The number of stops \
     * TotalKilometers: The total length in kilometers \
     * TotalMinutes: The total time in minutes
     */
    attachCoordinatesToRoad(inputCoords, travelMode = "Kortaste vägen") {
        let iStops = {
            displayFieldName: "",
            fieldAliases: { OBJECTID: "OBJECTID" },
            geometryType: "esriGeometryPoint",
            spatialReference: {
                wkid: 3006,
                latestWkid: 3006,
            },
            fields: [
                { name: "OBJECTID", type: "esriFieldTypeOID", alias: "OBJECTID", length: null },
                { name: "Name", type: "esriFieldTypeString", alias: "Name", length: 255 },
                { name: "RouteName", type: "esriFieldTypeString", alias: "RouteName", length: 255 },
                { name: "Sequence", type: "esriFieldTypeInteger", alias: "Sequence", length: null },
                { name: "LocationType", type: "esriFieldTypeInteger", alias: "LocationType", length: null },
            ],
            features: [],
        };
        inputCoords.forEach((coord, index) => {
            const feat = {
                attributes: { OBJECTID: index, name: index.toString(), routeName: "routeName", sequence: null, locationType: 0 },
                geometry: { x: coord[0], y: coord[1] },
            };
            iStops.features.push(feat);
        });
        const inputStops = JSON.stringify(iStops);
        const vehicleHeight = 0;
        const toolPath = "SolveRoutes";
        const url = `${this.trvRoutingBaseUrl}/${toolPath}/execute?InputStops=${encodeURI(inputStops)}&TravelMode=${encodeURI(travelMode)}&VehicleHeight=${encodeURI(vehicleHeight.toString())}&context=&f=pjson`;
        return new Observable((observer) => {
            this.httpClient.get(url).subscribe({
                next: (data) => {
                    console.log(data);
                    const outputStops = data.results[0].value;
                    if (outputStops.features.length > 0 && outputStops.features[0].geometry?.paths.length > 0) {
                        const feat = outputStops.features[0];
                        const multiLineStringFeature = new Feature(new MultiLineString(feat.geometry.paths));
                        let res = {
                            feature: multiLineStringFeature,
                            Shape_Length: feat.attributes.Shape_Length,
                            StopCount: feat.attributes.StopCount,
                            TotalKilometers: feat.attributes.TotalKilometers,
                            TotalMinutes: feat.attributes.TotalMinutes,
                        };
                        observer.next(res);
                    }
                    else {
                        //observer.next(null);
                        observer.error("Could not attach coordinates to road");
                    }
                    observer.complete();
                },
                error: (err) => {
                    observer.error(err);
                },
            });
        });
    }
    attachCoordinatesToRoadSegment(inputCoords, travelMode = "Kortaste vägen") {
        let iStops = {
            displayFieldName: "",
            fieldAliases: { OBJECTID: "OBJECTID" },
            geometryType: "esriGeometryPoint",
            spatialReference: {
                wkid: 3006,
                latestWkid: 3006,
            },
            fields: [
                { name: "OBJECTID", type: "esriFieldTypeOID", alias: "OBJECTID", length: null },
                { name: "Name", type: "esriFieldTypeString", alias: "Name", length: 255 },
                { name: "RouteName", type: "esriFieldTypeString", alias: "RouteName", length: 255 },
                { name: "Sequence", type: "esriFieldTypeInteger", alias: "Sequence", length: null },
                { name: "LocationType", type: "esriFieldTypeInteger", alias: "LocationType", length: null },
            ],
            features: [],
        };
        inputCoords.forEach((coord, index) => {
            const feat = {
                attributes: { OBJECTID: index, name: index.toString(), routeName: "routeName", sequence: null, locationType: 0 },
                geometry: { x: coord[0], y: coord[1] },
            };
            iStops.features.push(feat);
        });
        const inputStops = JSON.stringify(iStops);
        const vehicleHeight = 0;
        const toolPath = "SolveSegments";
        const url = `${this.trvRoutingBaseUrl}/${toolPath}/execute?InputStops=${encodeURI(inputStops)}&TravelMode=${encodeURI(travelMode)}&VehicleHeight=${encodeURI(vehicleHeight.toString())}&context=&f=pjson`;
        return new Observable((observer) => {
            this.httpClient.get(url).subscribe({
                next: (data) => {
                    console.log(data);
                    const outputStops = data.results[0].value;
                    if (outputStops.features.length > 0 && outputStops.features[0].geometry?.paths.length > 0) {
                        let result = [];
                        outputStops.features.forEach(feat => {
                            const multiLineStringFeature = new Feature(new MultiLineString(feat.geometry.paths));
                            let res = {
                                feature: multiLineStringFeature,
                                Direction: feat.attributes.Direction,
                                FromMeasure: feat.attributes.FromMeasure,
                                ToMeasure: feat.attributes.ToMeasure,
                                Hastighet: feat.attributes.Hastighet,
                                OBJECTID: feat.attributes.OBJECTID,
                                RouteId: feat.attributes.RouteId,
                                RouteName: feat.attributes.RouteName,
                                Shape_Length: feat.attributes.Shape_Length,
                                Vaghallare: feat.attributes.Vaghallare,
                                Vagklass: feat.attributes.Vagklass,
                                Vagnummer: feat.attributes.Vagnummer,
                            };
                            result.push(res);
                        });
                        observer.next(result);
                    }
                    else {
                        //observer.next(null);
                        observer.error("Could not attach coordinates to road");
                    }
                    observer.complete();
                },
                error: (err) => {
                    observer.error(err);
                },
            });
        });
    }
}
//#endregion
class DragZoomShift extends DragZoom {
    isDragZoomCustom = true;
    constructor(options) {
        super(options);
    }
}
class DragPanShiftDisable extends DragPan {
    constructor(options) {
        super(options);
    }
}

/**
 * Class that handles the layers in TrvNgMap.
 */
class TrvLayer {
    /** Reference to parent TrvMap object */
    trvMap;
    wktFormat = new WKT();
    geoJsonFormat = new GeoJSON();
    layersUpdated = new EventEmitter();
    /** LayerGroup that contains all background layers */
    backgroundLayerGroup = new LayerGroup({
        layers: [],
        visible: true,
    });
    /** LayerGroup that contains all wms / wmts layers */
    wmsLayerGroup = new LayerGroup();
    /** LayerGroup that contains all Vector layers */
    vectorLayerGroup = new LayerGroup();
    /** LayerGroup that contains all user defined layers */
    userLayerGroup = new LayerGroup();
    rasterLayer;
    /**
     * Grund-lager där geometrier ritas ut
     */
    workingLayer;
    /**
     * Grund-lager där geometrier ritas ut
     */
    pinLayer;
    /**
     * Lager som används för att rita ut temporära geometrier. T.ex. feature som följer musen
     */
    tempLayer;
    /**
     * Lager som används för att rita ut temporära geometrier. T.ex. feature som följer musen
     */
    tempLayer2;
    /**
     * Lager som används för att rita ut temporära geometrier. T.ex. feature som följer musen
     */
    rulerLayer;
    /**
     * Lager som används för att rita ut temporära geometrier. T.ex. feature som följer musen
     */
    printLayer;
    /**
     * List of all temporary layers. Invoking "clearAllTemporaryLayers()" will reset all these layers
     */
    temporaryLayers = [];
    /** Queue that holds new user-defined layers to add. */
    layerToAddQueue = [];
    defaultZIndexVectorLayer = 500;
    defaultZIndexWms = 100;
    /**
     * Lista som används för att hantera lista med bakgrundslager i gränssnittet
     */
    backgroundLayerListItems = [];
    currentBackroundLayer;
    currentAttribution = "bas";
    wmsLayerListItems = [];
    WMS_LAYER_LIST_ID_COUNTER = 0;
    BACKGROUND_LAYER_LIST_ID_COUNTER = 0;
    initialized = false;
    layerInput;
    layerInitialized = new EventEmitter();
    constructor(trvMap, layerInput) {
        this.trvMap = trvMap;
        this.layerInput = layerInput;
        this.initLayers().then(() => {
            this.initialized = true;
            this.layerInitialized.emit();
        });
    }
    /**
     * This method adds a new layer to the layer group userLayerGroup that's over everything else.
     * @param layer The Layer to add
     */
    addLayer(layer, temporaryLayer = false) {
        this.userLayerGroup.getLayers().push(layer);
        if (temporaryLayer)
            this.temporaryLayers.push(layer);
        layer.setZIndex(this.defaultZIndexVectorLayer);
    }
    /**
     * This method clears ALL temporary layers from features.
     */
    clearAllTemporaryLayers() {
        this.temporaryLayers.forEach(layer => {
            layer.getSource()?.clear();
        });
    }
    /**
     * Method that initializies all wms/wmts/oms layers from det layerData object.
     */
    async initializeAllLayers() {
        await this.initializeBackgroundLayers();
        await this.initializeLayers();
        this.processGetCapabilitiesQueue();
    }
    /**
     * Method that initializes all wms/wmts/oms background layers
     */
    async initializeBackgroundLayers() {
        let addOsm = true;
        if (this.layerInput) {
            if (this.layerInput.BackgroundLayer.LayerList.length > 0)
                addOsm = false;
            for (const layer of this.layerInput.BackgroundLayer.LayerList) {
                await this.createAndAddLayer({
                    id: layer.Id ? layer.Id : undefined,
                    url: layer.Url,
                    title: layer.Title,
                    layerName: layer.LayerName,
                    attributions: layer.Attribution ?? "",
                    display: layer.DisplayInLayerSwitcher ? layer.DisplayInLayerSwitcher : false,
                    type: layer.Type ? layer.Type : "wms",
                    format: layer.format ? layer.format : "image/png",
                    zIndex: layer.zIndex ? layer.zIndex : 1,
                    version: layer.Version ?? "1.1.1",
                    darkMode: layer.DarkMode ?? false,
                    overrideWmtsUrl: layer.OverrideWmtsUrl,
                }, true);
            }
        }
        if (addOsm) {
            await this.createAndAddLayer({
                id: "bgOpenLayersId",
                url: "layer.Url",
                title: "OpenStreetMap's bakgrundskarta",
                layerName: "layer.LayerName",
                attributions: "© OpenStreetMap contributors",
                display: true,
                type: "osm",
                format: "image/png",
                zIndex: 1,
            }, true);
        }
    }
    /**
     * Method that initializes all wms/wmts/oms layers from layerData
     */
    async initializeLayers() {
        if (this.layerInput) {
            for (const layer of this.layerInput?.Layers.LayerList) {
                let singleTile = false;
                if (layer.hasOwnProperty("SingleTile"))
                    singleTile = layer.SingleTile;
                if (layer.Type == undefined)
                    layer.Type = "wms";
                //Parse trvData
                let trvData = {};
                Object.keys(layer).forEach((key) => {
                    if (key.startsWith("trv:")) {
                        const keyParts = key.split("trv:");
                        let realKey = keyParts[1];
                        trvData[realKey] = layer[key];
                    }
                });
                let opacity = 1;
                if (layer.hasOwnProperty("Opacity") && !isNaN(layer.Opacity)) {
                    opacity = layer.Opacity;
                }
                await this.createAndAddLayer({
                    id: layer.Id,
                    url: layer.Url,
                    title: layer.Title,
                    layerName: layer.LayerName,
                    attributions: layer.Attribution ? layer.Attribution : "",
                    trvData: trvData,
                    format: layer.format ? layer.format : "image/png",
                    opacity: opacity,
                    display: layer.DisplayInLayerSwitcher !== undefined ? layer.DisplayInLayerSwitcher : true,
                    type: layer.Type ? layer.Type : "wms",
                    minScaleDenominator: layer.minScaleDenominator,
                    maxScaleDenominator: layer.maxScaleDenominator,
                    zIndex: layer.zIndex ? layer.zIndex : 100,
                    version: layer.Version ?? "1.1.1",
                    singleTile: singleTile,
                    darkMode: layer.DarkMode ?? false,
                    overrideWmtsUrl: layer.OverrideWmtsUrl,
                });
            }
        }
    }
    /**
     * Async method that creates and adds a LayerListItem to either backgroundLayerListItems or wmsLayerListItems
     * @param layerOptions LayerOptions object
     * @param isBackgroundLayer boolean. If value is true, LayerListItem is added to backgroundLayerListItems, otherwise wmsLayerListItems. False by default
     * @param emitUpdatesignal boolean. If true, it emits a signal to the event-emitter layersUpdated. True by default
     * @returns Promise of either a LayerListItem if success, otherwise null
     */
    async createAndAddLayer(layerOptions, isBackgroundLayer = false, emitUpdatesignal = true) {
        //Generate id for layerListItem
        let _id = "" + this.WMS_LAYER_LIST_ID_COUNTER;
        if (isBackgroundLayer)
            _id = "" + this.BACKGROUND_LAYER_LIST_ID_COUNTER;
        //Populate with default values if it doesn't exist on layerOptions
        const options = {
            id: _id,
            format: "image/png",
            srs: SWEREF_99_TM.getCode(),
            tilegrid: tileGrid,
            version: "1.1.1",
            attributions: "",
            singleTile: false,
            display: true,
            trvData: {},
            opacity: 1,
            zIndex: 100,
            type: "wms",
            darkMode: false,
            ...layerOptions,
        };
        if (isBackgroundLayer)
            this.BACKGROUND_LAYER_LIST_ID_COUNTER++;
        else
            this.WMS_LAYER_LIST_ID_COUNTER++;
        //Make sure id exits...
        if (!options.id)
            options.id = _id;
        let layer = null;
        if (options.type == "wms") {
            if (options.singleTile) {
                //If singleTile -> layer: ImageLayer<ImageWms>
                layer = await this.createImageLayerFromWms(options.url, options.layerName, options.format, options.srs, options.version, options.attributions);
            }
            else {
                //If not singleTile -> layer: TileLayer<TileWms>
                layer = await this.createTileLayerFromWms(options.url, options.layerName, options.format, options.srs, options.tilegrid, options.version, options.attributions);
            }
        }
        else if (options.type == "wmts") {
            options.tilegrid = tileGridWmts;
            //console.log(getTopLeft(SWEREF_99_TM?.getExtent()!))
            //const ovurl = "https://bas.trafikverket.se/gis/rest/services/Basemap/BakgrundskartaNorden/MapServer/WMTS/tile/1.0.0/Basemap_BakgrundskartaNorden/{Style}/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}.png";
            const dataLayers = await this.createTileLayerFromWmts(options.url, options.layerName, options.format, options.srs, tileGridWmts, options.version, options.attributions, options.overrideWmtsUrl);
            if (dataLayers && dataLayers.length > 0) {
                layer = dataLayers[0];
            }
        }
        else if (options.type == "osm") {
            layer = new TileLayer({
                source: new OSM(),
            });
        }
        if (layer) {
            const layerListItem = {
                id: options.id,
                name: options.title,
                version: options.version,
                layer: layer,
                attribution: options.attributions,
                active: false,
                display: options.display,
                url: options.url,
                layerName: options.layerName,
                opacity: options.opacity,
                type: options.type,
                trvData: options.trvData,
                zIndex: options.zIndex,
                darkMode: options.darkMode,
            };
            if (layerListItem.darkMode) {
                //If dark mode, invert colors of layer and grayscale 80% on render
                layer.on("prerender", evt => {
                    if (evt.context) {
                        const context = evt.context;
                        context.filter = "grayscale(80%) invert(100%) ";
                        context.globalCompositeOperation = "source-over";
                    }
                });
                //Reset filters after
                layer.on("postrender", evt => {
                    if (evt.context) {
                        const context = evt.context;
                        context.filter = "none";
                    }
                });
            }
            if (options.hasOwnProperty("minScaleDenominator"))
                layerListItem.customMinScaleDenominator = options.minScaleDenominator;
            if (options.hasOwnProperty("maxScaleDenominator"))
                layerListItem.customMaxScaleDenominator = options.maxScaleDenominator;
            layerListItem.layer.setVisible(false);
            layerListItem.layer.setOpacity(layerListItem.opacity);
            layerListItem.layer.setZIndex(layerListItem.zIndex);
            if (isBackgroundLayer) {
                this.backgroundLayerGroup.getLayers().push(layer);
                this.backgroundLayerListItems.push(layerListItem);
            }
            else {
                this.wmsLayerGroup.getLayers().push(layerListItem.layer);
                this.wmsLayerListItems.push(layerListItem);
            }
            //console.log("Adding layer ", layerListItem.id, layerListItem.name);
            //If type is wms, do getCapabilities on the layerListItem
            if (layerListItem.type == "wms" && !isBackgroundLayer) {
                //this.getCapabilities(layerListItem);
                this.queueGetCapabilities(layerListItem);
            }
            this.layersUpdated.emit();
            return layerListItem;
        }
        else {
            console.error("Could not add layer from options: ", options);
        }
        return null;
    }
    /**
     * Method that initialises all the layers on the map.
     */
    async initLayers() {
        //Layer group init
        this.trvMap.map.addLayer(this.backgroundLayerGroup);
        this.trvMap.map.addLayer(this.wmsLayerGroup);
        this.trvMap.map.addLayer(this.vectorLayerGroup);
        this.trvMap.map.addLayer(this.userLayerGroup);
        //await this.cacheAllGetCapabilities();
        await this.initializeAllLayers();
        //await this.callAllGetCapabilities();
        this.workingLayer = new VectorLayer({
            source: new VectorSource({}),
        });
        this.pinLayer = new VectorLayer({
            source: new VectorSource({}),
        });
        this.tempLayer = new VectorLayer({
            source: new VectorSource({}),
        });
        this.tempLayer2 = new VectorLayer({
            source: new VectorSource({}),
        });
        this.rulerLayer = new VectorLayer({
            source: new VectorSource({}),
        });
        this.printLayer = new VectorLayer({
            source: new VectorSource({}),
        });
        this.temporaryLayers.push(this.tempLayer);
        this.temporaryLayers.push(this.tempLayer2);
        this.temporaryLayers.push(this.rulerLayer);
        this.temporaryLayers.push(this.printLayer);
        this.vectorLayerGroup.getLayers().push(this.workingLayer);
        this.vectorLayerGroup.getLayers().push(this.pinLayer);
        this.vectorLayerGroup.getLayers().push(this.tempLayer);
        this.vectorLayerGroup.getLayers().push(this.tempLayer2);
        this.vectorLayerGroup.getLayers().push(this.rulerLayer);
        this.vectorLayerGroup.getLayers().push(this.printLayer);
        this.vectorLayerGroup.getLayers().forEach(layer => {
            layer.setZIndex(this.defaultZIndexVectorLayer);
        });
        if (this.backgroundLayerListItems.length > 0)
            this.activateBackgroundLayer(this.backgroundLayerListItems[0]);
        this.layersUpdated.emit();
    }
    /**
     * Creates a tile-layer from a wms source
     * @param url Url to the wms source. Required
     * @param layer Name of layer in wms. Required
     * @param format Layer-format. Default = image/png
     * @param srs The coordinat system in ESPG format. Default = EPSG:3006
     * @param tilegrid Custom TileGrid object. If null, default (lantmäteriet) will be used.
     * @param version Wms version to use. Default = null
     * @param attributions Who to give attribution to. Default = ""
     * @returns TileLayer
     */
    createTileLayerFromWms(url, layer, format = "image/png", srs = SWEREF_99_TM?.getCode(), tilegrid = null, version = null, attributions = "") {
        let params = {
            LAYERS: layer,
            FORMAT: format,
            SRS: srs,
            TRANSPARENT: "true",
        };
        if (version != null)
            params["VERSION"] = version;
        const wmsSource = new TileWms({
            url: url,
            params: params,
            attributions: attributions,
            crossOrigin: "anonymous",
            tileGrid: tilegrid != null ? tilegrid : tileGrid,
        });
        const tileLayerOptions = {
            source: wmsSource,
        };
        return new TileLayer(tileLayerOptions);
    }
    createImageLayerFromWms(url, layer, format = "image/png", srs = "SWEREF_99_TM", version = null, attributions = "") {
        let params = {
            LAYERS: layer,
            FORMAT: format,
            SRS: srs,
            TRANSPARENT: "true",
        };
        if (version != null) {
            params["VERSION"] = version;
        }
        const wmsSource = new ImageWMS({
            url: url,
            params: params,
            attributions: attributions,
            crossOrigin: "anonymous",
        });
        const imageLayerOptions = {
            source: wmsSource,
        };
        return new Image$1(imageLayerOptions);
    }
    async createTileLayerFromWmts(url, layer, format = "image/png", srs = SWEREF_99_TM?.getCode(), tilegrid = null, version = null, attributions = "", overrideWmtsUrl = undefined) {
        const parser = new WMTSCapabilities();
        let tileLayerResult = null;
        try {
            await fetch(url)
                .then(function (response) {
                return response.text();
            })
                .then(function (text) {
                const result = parser.read(text);
                const options = optionsFromCapabilities(result, {
                    layer: layer,
                    matrixSet: "EPSG:3006",
                });
                options.wrapX = true;
                // https://gis.stackexchange.com/questions/224270/display-epsg3844-arcgis-wmts-service-in-openlayers-origin-axes-in-wrong-order
                const originalTileGrid = options.tileGrid;
                var org = originalTileGrid.getOrigin(0);
                options.tileGrid = new WMTSTileGrid({
                    origin: org,
                    resolutions: originalTileGrid.getResolutions(),
                    matrixIds: originalTileGrid.getMatrixIds(),
                    tileSizes: originalTileGrid.getResolutions().map((_, z) => {
                        return originalTileGrid.getTileSize(z);
                    }),
                });
                if (options.url)
                    options.url = overrideWmtsUrl;
                if (options.urls && overrideWmtsUrl) {
                    options.urls[0] = overrideWmtsUrl;
                }
                const tileLayer = [
                    new TileLayer({
                        extent: [-850284, 5810671, 1902167, 9110000],
                        opacity: 1,
                        source: new WMTS(options),
                    }),
                ];
                tileLayerResult = tileLayer;
            });
        }
        catch (error) {
            console.error("Couldn't get WMTS layer with name: ", layer, " from: ", url);
        }
        return tileLayerResult;
    }
    getCapabilitiesQueue = [];
    getCapablitiesCache = {};
    queueGetCapabilities(layer) {
        if (layer.type != "wms")
            return;
        if (!layer.layerName)
            return;
        layer.getCapabilitiesStatus = "Not started";
        this.getCapabilitiesQueue.push(layer);
    }
    async processGetCapabilitiesQueue() {
        for (let i = 0; i < this.getCapabilitiesQueue.length; i++) {
            const layer = this.getCapabilitiesQueue[i];
            //this.getCapabilities(layer);
            let capabilitiesUrl = layer.url + "?Service=WMS&request=GetCapabilities";
            layer.getCapabilitiesStatus = "Loading";
            //Check if we have already fetched capabilities for this layer
            if (!this.getCapablitiesCache[capabilitiesUrl]) {
                //await this.getCapabilities(layer);
                await fetch(capabilitiesUrl)
                    .then(response => {
                    return response.text();
                })
                    .then(text => {
                    this.getCapablitiesCache[capabilitiesUrl] = text;
                });
            }
        }
        for (let i = 0; i < this.getCapabilitiesQueue.length; i++) {
            const layer = this.getCapabilitiesQueue[i];
            let capabilitiesUrl = layer.url + "?Service=WMS&request=GetCapabilities";
            if (this.getCapablitiesCache[capabilitiesUrl]) {
                this._getCapabilities(layer, this.getCapablitiesCache[capabilitiesUrl]);
                layer.getCapabilitiesStatus = "Done";
            }
            else {
                console.error("Couldn't get capabilities for: ", layer.id);
                layer.getCapabilitiesStatus = "Error";
            }
        }
        this.getCapabilitiesQueue = [];
    }
    getCapabilities(layer) {
        if (layer.type != "wms")
            return;
        if (!layer.layerName)
            return;
        let capabilitiesUrl = layer.url + "?Service=WMS&request=GetCapabilities";
        fetch(capabilitiesUrl)
            .then(response => {
            return response.text();
        })
            .then(text => {
            // Store data in cache
            this._getCapabilities(layer, text);
        })
            .catch(error => {
            console.error("Error fetching capabilities from: ", error);
        });
    }
    _getCapabilities(layer, xml) {
        const parser = new WMSCapabilities();
        const result = parser.read(xml);
        if (result.Capability?.Layer.Layer) {
            const layList = result.Capability.Layer.Layer;
            //Handle multiple layers
            const multipleLayersNames = layer.layerName?.split(",");
            multipleLayersNames?.forEach(layerName => {
                const findLayer = layList.find(element => element.Name == layerName);
                //If we found a layer in capabilitieis corresponding to our layerlist Item, get values from it.
                if (findLayer) {
                    layer.maxWidth = findLayer.MaxWidth;
                    layer.maxHeight = findLayer.MaxHeight;
                    layer.minScaleDenominator = findLayer.MinScaleDenominator;
                    layer.maxScaleDenominator = findLayer.MaxScaleDenominator;
                    //remove 5% of the maxScaleDenominator
                    if (layer.maxScaleDenominator) {
                        layer.maxScaleDenominator = Math.round(layer.maxScaleDenominator * 0.97);
                        layer.maxScaleDenominator = roundDownToMultiple(layer.maxScaleDenominator, 5000);
                    }
                    //Set custom min-max scales if any is set
                    if (layer.customMinScaleDenominator)
                        layer.minScaleDenominator = layer.customMinScaleDenominator;
                    if (layer.customMaxScaleDenominator)
                        layer.maxScaleDenominator = layer.customMaxScaleDenominator;
                    //Check if we can find legend url
                    if (findLayer.Style?.length > 0) {
                        if (findLayer.Style[0].LegendURL?.length > 0) {
                            //let legendUrl = findLayer.Style[0].LegendURL[0].OnlineResource;
                            //layer.legendGraphics = legendUrl;
                            let firstLayerName = layer.layerName ?? "";
                            let layerNames = firstLayerName.split(",");
                            if (layerNames.length > 0) {
                                layer.legendGraphics =
                                    layer.url +
                                        "?SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=" +
                                        layer.version +
                                        "&FORMAT=image/png&LAYER=" +
                                        layerNames[0];
                            }
                        }
                    }
                }
            });
        }
    }
    /**
     * Removes a layer from wmsLayerListItems, as well as it's binding to openlayers/map
     * @param layerToRemove The LayerListItem to remove
     */
    removeLayer(layerToRemove) {
        //First of all, remove reference from map
        this.trvMap.map.removeLayer(layerToRemove.layer);
        //Remove refernce from layerList
        this.wmsLayerListItems = this.wmsLayerListItems.filter(layer => layer.id !== layerToRemove.id);
        //Emit update signal
        this.layersUpdated.emit();
    }
    /**
     * Removes a backgroundlayer from backgroundLayerListItems, as well as it's binding to openlayers/map
     * @param layerToRemove The LayerListItem to remove
     */
    removeBackgroundLayer(layerToRemove) {
        //First of all, remove reference from map
        this.trvMap.map.removeLayer(layerToRemove.layer);
        //Remove refernce from layerList
        this.backgroundLayerListItems = this.backgroundLayerListItems.filter(layer => layer !== layerToRemove);
        //Emit update signal
        this.layersUpdated.emit();
    }
    /**
     * Method that adds a feature to a VectorLayer
     * @param feature The feature object
     * @param layer The layer to add the feature to
     * @param isSelectable If the feature is selectable or not. Not required
     * @param data Custom data to add to the feature. Not required.
     */
    addFeature(feature, layer, isSelectable = true, data) {
        feature.set("selectable", isSelectable);
        //add feature to layer
        layer.getSource()?.addFeature(feature);
        //Add custom data to feature
        feature.set("data", data);
    }
    /**
     * This method creates and adds a feature to the map based on a WKT string \
     *
     * @param wkt Well-known text representation of Geometry
     * @param dataProjection The projection of the wkt object. Preferably as EPSG-format. (Etc. EPSG:3000)
     * @param featureProjection The projection of the created OL feature. Preferably as EPSG-format. (Etc. EPSG:3000)
     * @param layer The VectorLayer to add feature to
     * @param data Custom data to add to the feature
     * @returns The OL feature
     */
    addFeatureFromWkt(wkt, dataProjection, featureProjection, layer, data = null) {
        //Create feature from WKT
        let feature = this.getFeatureFromWkt(wkt, dataProjection, featureProjection, data);
        this.addFeature(feature, layer, true, data);
        return feature;
    }
    /**
     * Method that creates a feature from WKT.
     * @param wkt Well-known text representation of Geometry
     * @param dataProjection  The projection of the wkt object. Preferably as EPSG-format. (Etc. EPSG:3000)
     * @param featureProjection The projection of the created OL feature. Preferably as EPSG-format. (Etc. EPSG:3000)
     * @param data Custom data to add to the feature
     * @returns The OL feature
     */
    getFeatureFromWkt(wkt, dataProjection = SWEREF_99_TM?.getCode(), featureProjection = SWEREF_99_TM?.getCode(), data = null) {
        //Create feature from WKT
        let feature = this.wktFormat.readFeature(wkt, {
            dataProjection: dataProjection,
            featureProjection: featureProjection,
        });
        return feature;
    }
    /**
     * Method that creates a feature from GeoJSON object
     * @param geoJSON The geojson object
     * @param switchPlaceCoordinates Default = false. \
     * If this method should switch the place of coordinates.\
     * In some GeoJson objects (Like GetFeatureInfo from WMS, the coordinates could be in the wrong order for coordinate systems like Sweref99tm)
     * @param dataProjection  The projection of the wkt object. Preferably as EPSG-format. (Etc. EPSG:3000)
     * @param featureProjection The projection of the created OL feature. Preferably as EPSG-format. (Etc. EPSG:3000)
     * @returns The OL feature
     */
    getFeatureFromGeoJson(geoJSON, switchPlaceCoordinates = false, dataProjection = SWEREF_99_TM?.getCode(), featureProjection = SWEREF_99_TM?.getCode()) {
        if (switchPlaceCoordinates) {
            const reversedCoordinates = geoJSON.coordinates.map((coordinate) => {
                return [coordinate[1], coordinate[0]];
            });
            if (geoJSON.type == "Point") {
                const coord = geoJSON.coordinates;
                geoJSON.coordinates = [coord[1], coord[0]];
            }
            else
                geoJSON.coordinates = reversedCoordinates;
        }
        let feature = this.geoJsonFormat.readFeature(geoJSON, {
            dataProjection: dataProjection,
            featureProjection: featureProjection,
        });
        return feature;
    }
    /**
     * Method that removes a feature from a specific layer
     * @param feature The feature to remove.
     * @param layer The targeted layer.
     */
    removeFeature(feature, layer) {
        layer.getSource().removeFeature(feature);
    }
    /**
     * Method that activates a specific background layer based on it's index in a list. \
     * The method also deactivates all other layers.
     * @param index
     */
    activateBackgroundLayer(layer) {
        //if (index >= 0 && index < this.backgroundLayerListItems.length) {
        //First of all, make all layers invisible
        this.backgroundLayerListItems.forEach(layer => {
            layer.layer.setVisible(false);
            layer.active = false;
        });
        //Then set targeted layer to visible
        layer.layer.setVisible(true);
        layer.active = true;
        this.currentBackroundLayer = layer;
        this.currentAttribution = layer.attribution ?? "undef";
        this.trvMap.updateLayerVisibilityMap();
    }
    /**
     * Method that returns the highest z-index value of a layer
     * @returns The highest found z-index number
     */
    getMaxZIndex() {
        var zIndex = this.defaultZIndexWms;
        this.wmsLayerListItems.forEach(layer => {
            var foundZIndex = layer.zIndex ?? this.defaultZIndexWms;
            if (foundZIndex > zIndex)
                zIndex = foundZIndex;
        });
        return zIndex;
    }
    /**
     * Method that moves (set z-index) to the top.
     * @param layer The layer to move to the top
     */
    moveLayerToTop(layer) {
        var newZIndex = this.getMaxZIndex() + 1;
        this.setZIndex(newZIndex, layer);
    }
    /**
     * Method that sets the z-index of a layer
     * @param zIndex The z-index to set
     * @param layer the layer
     */
    setZIndex(zIndex, layer) {
        layer.layer.setZIndex(zIndex);
        layer.zIndex = zIndex;
    }
    /**
     * Method that gets all visible(active) layers
     * @returns All active layers
     */
    getVisibleWmsLayer() {
        let res = [];
        this.wmsLayerListItems.forEach(layer => {
            if (layer.active) {
                res.push(layer);
            }
        });
        return res;
    }
    /**
     * Method that checks if any layer that has a Label/Legend Graphics is active
     * @returns True if a layer with Label/Legend graphics is active, otherwise false
     */
    isAnyLayerWithLabelActive() {
        let activeLayers = this.getVisibleWmsLayer();
        for (let i = 0; i < activeLayers.length; i++) {
            const layer = activeLayers[i];
            if (layer.legendGraphics)
                return true;
        }
        return false;
    }
    /**
     * Toggles the layers visibility
     * @param layer The layer to toggle visibility on
     */
    toggleLayerVisibility(layer) {
        layer.active = !layer.active;
        layer.layer.setVisible(layer.active);
        this.trvMap.updateLayerVisibilityMap();
    }
    /**
     * Sets the layers visibility
     * @param layer The layer to set visiblity on
     * @param visible Value of visiblity
     */
    setLayerVisibility(layer, visible) {
        layer.active = visible;
        layer.layer.setVisible(layer.active);
        this.trvMap.updateLayerVisibilityMap();
    }
    /**
     * Deactivates all active wms-layers
     */
    deactivateAllLayers() {
        this.wmsLayerListItems.forEach(layer => {
            layer.active = false;
            layer.layer.setVisible(false);
        });
        this.trvMap.updateLayerVisibilityMap();
    }
    /**
     * Method that returns true/false if a layerlist item has custom data bound to a key. \
     * \
     * To add custom data to a LayerListItem you can add \
     * `"trv:yourKey": "your data"` to a layer in your \
     * json-config file. In this example `"yourKey"` will be the key.
     * @param layer : LayerListItem
     * @param key  : string
     * @returns true/false
     */
    hasLayerData(layer, key) {
        return layer.trvData.hasOwnProperty(key);
    }
    /**
     * Method that returns a value/undefined if a layerlist item has custom data bound to a key. \
     * \
     * To add custom data to a LayerListItem you can add \
     * `"trv:yourKey": "your data"` to a layer in your \
     * json-config file. In this example `"yourKey"` will be the key.
     * @param layer
     * @param key
     * @returns
     */
    getLayerData(layer, key) {
        if (this.hasLayerData(layer, key)) {
            return layer.trvData[key];
        }
        return undefined;
    }
}

/**
 * @module map
 */
/**
 * Class that handles the OpenLayers map. \
 * Parent class holds references to the main "ol/map" object \
 * as well as to its own instances of:
 * - TrvLayer
 * - TrvControl
 * - TrvInteractions
 */
class TrvMap {
    trvMapService;
    httpClient;
    mapCanvas;
    /** Variable that holds the current active MapTool */
    activeMapTool = new BehaviorSubject(MapTools.None);
    /** Variable that holds the previously used MapTool. */
    prevMapTool = MapTools.None;
    /** Reference to the instance of type ol/map. */
    map;
    /** References to the instance of ol/view that is linked to the map */
    view;
    hideControls = false;
    /** Unique identifier for this instance of TrvMap. If no id, this is the "main" instance of TrvMap */
    id;
    isDefaultMap = false;
    /** Reference to an instance of TrvLayer that is connected to this instance of TrvMap */
    trvLayer;
    /** Reference to an instance of TrvControl that is connected to this instance of TrvMap */
    trvControl;
    /** Reference to an instance of TrvInteractions that is connected to this instance of TrvMap */
    trvInteractions;
    /** Variable that determines whether the map is currently panning. Currently disabled. */
    isPanning = false;
    /** Reference to the parentComponent that this instance of TrvMap is instantiated in. */
    //public parentComponent!: any;
    latestMapExportUrl = "";
    mapExportTrigger = new EventEmitter();
    scaleIntervals = [400, 500, 1000, 5000, 10000, 50000, 100000, 500000, 1000000, 5000000];
    printMenuState = {
        showLabel: false,
        areaCenterCoordinate: null,
        title: new FormControl("", { nonNullable: true }),
        fileTypeOption: new FormControl(FileType.PNG, { nonNullable: true }),
        exportDirectionOption: new FormControl(ExportDirection.Standing, { nonNullable: true }),
        exportSizeOption: new FormControl(ExportSize.MapView, { nonNullable: true }),
        showLabelOption: new FormControl(false),
        showCompassOption: new FormControl(true),
        showScaleOption: new FormControl(true),
        scale: new FormControl(5000, { nonNullable: true }),
        slider: new FormControl(this.scaleIntervals.indexOf(5000), { nonNullable: true }),
    };
    previousSize = ExportSize.MapView;
    showLoadingLayers = true;
    showStreetView = false;
    // recent views so you can go back and forth between views
    viewHistory = [];
    currentHistoryIndex = 0;
    // when moving the camera we want to enable go back to last saved position
    hasMovedSinceLastSavepoint = false;
    // when setting the camera to a specific location we often dont want to set hasMoved to true
    // it is automatically turned off when the camera stops moving
    ignoreMoveSinceLastSavepoint = false;
    constructor(trvMapOverlayService, trvMapService, layerInput, httpClient, id, isDefaultMap) {
        this.trvMapService = trvMapService;
        this.httpClient = httpClient;
        this.id = id;
        this.isDefaultMap = isDefaultMap;
        this.trvControl = new TrvControl(this);
        this.initilizeMap();
        this.trvLayer = new TrvLayer(this, layerInput);
        this.trvInteractions = new TrvInteractions(this, trvMapService, trvMapOverlayService, httpClient);
        //this.trvMapService.createOnMapLoaded(this.id);
        //this.changeActiveMapTool(MapTools.Ruler)
        this.trvLayer.layerInitialized.subscribe(() => {
            this.changeActiveMapTool(MapTools.Pointer);
            if (isDefaultMap) {
                this.trvMapService.setIsMapLoaded(true, undefined);
            }
            else {
                this.trvMapService.setIsMapLoaded(true, this.id);
            }
        });
        this.map.getView().on("change:resolution", () => {
            this.startSavePositionTimer();
        });
        this.map.getView().on("change:center", () => {
            this.startSavePositionTimer();
        });
        this.map.on("moveend", this.updateLayerVisibilityMap.bind(this));
    }
    /**
     * Method that checks all active layers, and sets the visibility to false if the min/max scaleDonominator says so.
     *
     * This method is triggered on 'moveend' event on map, as well as every time a layer is activated/deactivated.
     *
     * Can be called manually.
     */
    updateLayerVisibilityMap() {
        //Loop through all layers and see if they should be visible or not based on scale
        const scale = this.getScaleForResolution();
        this.trvLayer.wmsLayerListItems.forEach(layer => {
            if (layer.active) {
                if ((layer.maxScaleDenominator && layer.maxScaleDenominator < scale) ||
                    (layer.minScaleDenominator && layer.minScaleDenominator > scale)) {
                    layer.layer.setVisible(false);
                }
                else {
                    layer.layer.setVisible(true);
                }
            }
        });
    }
    /**
     * Method that sets the map view to the previous view.
     */
    previousView() {
        this.ignoreMoveSinceLastSavepoint = true;
        if (this.viewHistory.length === 0)
            return;
        // if you have moved you should simply go back to last saved position instead of
        // going back in history
        if (!this.hasMovedSinceLastSavepoint) {
            this.currentHistoryIndex--;
        }
        this.hasMovedSinceLastSavepoint = false;
        const view = this.viewHistory[this.currentHistoryIndex];
        this.map.getView().setCenter(view.center);
        this.map.getView().setZoom(view.zoom);
        clearTimeout(this.savePositionTimerId);
    }
    /**
     * Method that sets the map view to the next view.
     */
    nextView() {
        this.ignoreMoveSinceLastSavepoint = true;
        this.hasMovedSinceLastSavepoint = false;
        if (this.currentHistoryIndex >= this.viewHistory.length - 1) {
            return;
        }
        this.currentHistoryIndex++;
        const view = this.viewHistory[this.currentHistoryIndex];
        this.map.getView().setCenter(view.center);
        this.map.getView().setZoom(view.zoom);
        clearTimeout(this.savePositionTimerId);
    }
    /**
     * Method that saves a new view. If no center or zoom is give, it will use the current zoom and center from the current map view.
     * @param center The center coordinate of the saved view.
     * @param zoom The zoom-amount
     */
    savePosition(center, zoom) {
        this.map.once("postrender", () => {
            zoom = zoom ?? this.map.getView().getZoom();
            center = center ?? this.map.getView().getCenter();
            if (!zoom || !center)
                return;
            let currentView = this.viewHistory[this.currentHistoryIndex];
            // if there is a currentview, check that the new view is a meaningful distance away before saving
            // we dont want to pollute the history with a bunch of views that are almost identical
            if (currentView) {
                const distanceMoved = Math.sqrt(Math.pow(Math.abs(this.map.getPixelFromCoordinate(center)[0]) - this.map.getPixelFromCoordinate(currentView.center)[0], 2) +
                    Math.pow(Math.abs(this.map.getPixelFromCoordinate(center)[1] - this.map.getPixelFromCoordinate(currentView.center)[1]), 2));
                const zoomDifference = Math.abs(zoom - currentView.zoom);
                // TODO: adjust this is necessary
                if (distanceMoved < 400 && zoomDifference < 0.3)
                    return;
            }
            if (this.currentHistoryIndex != this.viewHistory.length - 1) {
                // if you are not in the latest history view and add a new view
                // we have to add a new head and remove the old one
                this.viewHistory = this.viewHistory.slice(0, this.currentHistoryIndex + 1);
            }
            this.viewHistory.push({ center: center, zoom: zoom });
            this.currentHistoryIndex = this.viewHistory.length - 1;
            this.savePositionTimerId = undefined;
            this.hasMovedSinceLastSavepoint = false;
        });
    }
    savePositionTimerId;
    ignoreChangeTimerId;
    startSavePositionTimer() {
        // When the camera stops moving we should remove ignoreMoveSinceLastSavepoint as we only want it for a specific
        // movement
        if (this.ignoreChangeTimerId !== undefined) {
            clearTimeout(this.ignoreChangeTimerId);
        }
        this.ignoreChangeTimerId = setTimeout(() => {
            this.ignoreMoveSinceLastSavepoint = false;
        }, 50);
        if (!this.ignoreMoveSinceLastSavepoint)
            this.hasMovedSinceLastSavepoint = true;
        // After 10 seconds of not moving, save the current position to the history
        if (this.savePositionTimerId !== undefined) {
            clearTimeout(this.savePositionTimerId);
        }
        this.savePositionTimerId = setTimeout(() => {
            this.savePosition();
        }, 5000);
    }
    /**
     * Method that sets the map state. \
     * You can leave parameters as undefined to not set them.
     * @param coord The coordinate to set
     * @param zoom The zoom-level to set
     * @param activeBackgroundLayerId The unique index of the background layer to set
     * @param activeLayersId List of unique indexes to activate. All other layers will be deactivated unless value is undefined.
     * @param durationMilliseconds Time in milliseconds it takes to zoom
     */
    async setMapStateWithCoord(coord, zoom, activeBackgroundLayerId, activeLayersId, durationMilliseconds = 0, addOldPositionToHistory = false) {
        // we dont want to store intermediate positions while we move
        this.ignoreMoveSinceLastSavepoint = true;
        if (coord && zoom) {
            if (addOldPositionToHistory) {
                this.savePosition(coord, zoom);
            }
            this.zoomInOnCoordinate(coord, zoom, durationMilliseconds);
        }
        const _id = this.isDefaultMap ? undefined : this.id;
        // wait for map to load so the available backgroundlayers and layerlistitems are loaded
        if (!this.trvMapService.isMapLoaded(_id)) {
            await firstValueFrom(this.trvMapService.onMapLoaded(_id)).then(() => { });
        }
        if (activeBackgroundLayerId != undefined) {
            let backgroundLayerExists = false;
            let foundLayer = undefined;
            for (let layer of this.trvLayer.backgroundLayerListItems) {
                if (layer.id === activeBackgroundLayerId) {
                    backgroundLayerExists = true;
                    foundLayer = layer;
                    break;
                }
            }
            if (foundLayer != undefined) {
                this.trvLayer.activateBackgroundLayer(foundLayer);
            }
            else {
                this.trvLayer.activateBackgroundLayer(this.trvLayer.backgroundLayerListItems[0]);
            }
        }
        //if (activeBackgroundLayerId != undefined) this.trvLayer.activateBackgroundLayer(activeBackgroundLayerId);
        if (activeLayersId) {
            //Deactivate all layers
            this.trvLayer.wmsLayerListItems.forEach(layer => {
                this.trvLayer.setLayerVisibility(layer, false);
            });
            //Activate all layers with id in list activeLayersId
            activeLayersId.forEach(id => {
                for (let i = 0; i < this.trvLayer.wmsLayerListItems.length; i++) {
                    const layer = this.trvLayer.wmsLayerListItems[i];
                    if (layer && layer.id === id) {
                        this.trvLayer.setLayerVisibility(layer, true);
                        break;
                    }
                }
            });
        }
    }
    setMapStateWithExtent(extent, activeBackgroundLayerId, activeLayersId, durationMilliseconds = 1000) {
        if (extent)
            this.zoomInOnExtent(extent, durationMilliseconds);
        if (activeBackgroundLayerId) {
            let foundBg = this.trvLayer.backgroundLayerListItems.find(layer => layer.id == activeBackgroundLayerId);
            if (foundBg)
                this.trvLayer.activateBackgroundLayer(foundBg);
        }
        if (activeLayersId) {
            //Deactivate all layers
            this.trvLayer.wmsLayerListItems.forEach(layer => {
                this.trvLayer.setLayerVisibility(layer, false);
            });
            //Activate all layers with id in list activeLayersId
            activeLayersId.forEach(id => {
                for (let i = 0; i < this.trvLayer.wmsLayerListItems.length; i++) {
                    const layer = this.trvLayer.wmsLayerListItems[i];
                    if (layer && layer.id === id) {
                        this.trvLayer.setLayerVisibility(layer, true);
                        break;
                    }
                }
            });
        }
    }
    /**
     * Method that initializes the map.
     */
    initilizeMap() {
        this.view = new View({
            projection: SWEREF_99_TM?.getCode(),
            center: SWEDEN_CENTER_COORD,
            zoom: 0,
            resolutions: resolutions,
        });
        this.map = new Map({
            controls: this.trvControl.controlList,
            target: "map" + this.id,
            layers: [],
            view: this.view,
        });
    }
    /**
     * Method that changes the current active maptool. \
     * The method also trigger some changes in TrvInteractions to reset some interactions.
     * @param activeMapTool The MapTool to change to.
     */
    changeActiveMapTool(activeMapTool, setPrevTool = true) {
        if (setPrevTool)
            this.prevMapTool = this.activeMapTool.value;
        this.activeMapTool.next(activeMapTool);
        //Reset all interactions to default.
        this.trvInteractions.defaultInteractionsState();
        this.trvInteractions.setInteractionsStateForTool(this.activeMapTool.value);
        this.trvInteractions.resetMaptoolInteractions();
        this.trvInteractions.initMaptoolInteractions();
    }
    /**
     * Method that zooms in around the extent of a specific ol/VectorLayer
     * @param layer The layer to zoom in on.
     * @param duration The number of milliseconds the zoom-animation should be. Default is 1000ms.
     */
    zoomInOnLayer(layer, duration = 1000, padding = [100, 100, 100, 200]) {
        const extent = layer.getSource().getExtent();
        this.zoomInOnExtent(extent, duration, padding);
    }
    /**
     * Method that zooms in around an ol/feature.
     * @param feature The feature to zoom in on.
     * @param duration The number of milliseconds the zoom-animation should be. Default is 1000ms.
     */
    zoomInOnFeature(feature, duration = 1000, padding = [100, 100, 100, 200]) {
        let extent = feature.getGeometry()?.getExtent();
        if (!extent)
            return;
        let _extent = [extent[0], extent[1], extent[2], extent[3]];
        if (_extent && feature.getGeometry() && feature.getGeometry()?.getType() == "Point") {
            let offset = [500, 500];
            _extent[0] = _extent[0] - offset[0];
            _extent[1] = _extent[1] - offset[1];
            _extent[2] = _extent[2] + offset[0];
            _extent[3] = _extent[3] + offset[1];
        }
        this.zoomInOnExtent(_extent, duration, padding);
    }
    /**
     * Method that zooms in the map around an ol/extent
     * @param extent The extent to zoom in on.
     * @param duration The number of milliseconds the zoom-animation should be. Default is 1000ms.
     */
    zoomInOnExtent(extent, duration = 1000, padding = [100, 100, 100, 100]) {
        this.view.fit(extent, {
            duration: duration,
            padding: padding,
        });
    }
    /**
     * Method that zooms in on a coordinate.
     * @param center The coordinate to zoom in on.
     * @param zoom The zoom level
     * @param duration The number of milliseconds the zoom-animation should be. Default is 1000ms.
     */
    zoomInOnCoordinate(center, zoom, duration = 1000) {
        this.view.animate({
            center,
            zoom,
            duration,
        });
    }
    /**
     * Method that zooms in to the maxScaleDenominator of a LayerListItem. This only happens if the maxScaleDenominator exists on a LayerListLitem
     * @param layer The LayerListItem
     */
    zoomInOnLayerMaxScaleDenominator(layer) {
        if (layer.maxScaleDenominator) {
            var zoom = this.getZoomForScale(layer.maxScaleDenominator);
            this.map.getView().setZoom(zoom);
        }
    }
    /**
     * This method compares the current zoomlevel with the maxScaleDenominator of a LayerListItem, and returns true if you need to zoom in to see the layer.
     * @param layer The LayerListItem
     * @returns True if need to zoom in, else false
     */
    needToZoomInOnLayer(layer) {
        if (layer.maxScaleDenominator) {
            const scale = this.getScaleForResolution();
            return scale > layer.maxScaleDenominator;
        }
        return false;
    }
    /**
     * Method that calls the GetFeatureInfo on a WMS layer. Returns the GeoJson-object of GetFeatureInfo. \
     * The method also inserts the LayerListItem into the GeoJson object.
     * @param layer The layer list item. The source of layer.layer needs to be of type TileWMS, otherwise returns empty object
     * @param coordinate The coordinate to make the request on
     * @param FEATURE_COUNT The number of features that can return
     * @returns A Promise of a GeoJson object
     */
    async getFeatureInfo(layer, coordinate, FEATURE_COUNT = 10) {
        const source = layer.layer.getSource();
        if (!(source instanceof TileWms)) {
            console.error("The layer source needs to be of type TileWMS. Layername: " + layer.name);
            return {};
        }
        const view = this.map.getView();
        const resolution = view.getResolution();
        const projection = view.getProjection();
        const url = source.getFeatureInfoUrl(coordinate, resolution, projection, {
            INFO_FORMAT: "application/json",
            FEATURE_COUNT: FEATURE_COUNT,
        });
        if (!url) {
            console.error("No GetFeature url was found for layer: " + layer.name);
            return {};
        }
        return await fetch(url)
            .then(response => response.json())
            .then(data => {
            data.layerListItem = layer;
            return data;
        })
            .catch(error => {
            console.error("Error fetching GetFeatureInfo:", error);
            return {};
        });
    }
    /**
     * This method pans the view so that the center of the feature aligns with pixel
     * Etc: panToFeatureOffsetLocalPixel(feature, [100,200]) pans the view so that the center of the feature is at 100,200 in the map-canvas.
     * @param feature The feature to pan to
     * @param pixel The Pixel coordinate. (Etc: [100,200])
     * @param duration Number of milliseconds the pan will take. Default is 400ms
     */
    panToFeatureOffsetLocalPixel(feature, pixel, duration = 400) {
        if (feature) {
            const featureExtent = feature.getGeometry().getExtent();
            this.panToExtentOffsetLocalPixel(featureExtent, pixel, duration);
        }
    }
    /**
     * This method pans the view so that the center of the feature aligns with pixel
     * Etc: panToFeatureOffsetLocalPixel(feature, [100,200]) pans the view so that the center of the feature is at 100,200 in the map-canvas.
     * @param feature The feature to pan to
     * @param pixel The Pixel coordinate. (Etc: [100,200])
     * @param duration Number of milliseconds the pan will take. Default is 400ms
     */
    panToExtentOffsetLocalPixel(extent, pixel, duration = 400) {
        const featureCenter = [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
        const pixelCoordinates = this.map.getPixelFromCoordinate(featureCenter);
        const centerPixelCoordinates = this.map.getPixelFromCoordinate(this.map.getView().getCenter());
        const desiredPixelX = pixel[0];
        const desiredPixelY = pixel[1];
        let pixelx = pixelCoordinates[0] - desiredPixelX;
        let pixely = pixelCoordinates[1] - desiredPixelY;
        centerPixelCoordinates[0] = centerPixelCoordinates[0] + pixelx;
        centerPixelCoordinates[1] = centerPixelCoordinates[1] + pixely;
        const newCoord = this.map.getCoordinateFromPixel(centerPixelCoordinates);
        const view = this.map.getView();
        const oldExtent = view.calculateExtent();
        const offsetX = (oldExtent[2] - oldExtent[0]) / 2;
        const offsetY = (oldExtent[3] - oldExtent[1]) / 2;
        const newExtent = [newCoord[0] - offsetX, newCoord[1] - offsetY, newCoord[0] + offsetX, newCoord[1] + offsetY];
        view.fit(newExtent, {
            duration: duration,
        });
    }
    /**
     * Method that transforms sweref99 tm coordinate to WGS84
     * @param swerefX
     * @param swerefY
     * @returns
     */
    transformSwerefToWgs84(swerefX, swerefY) {
        // Transform SWEREF99TM coordinates to WGS84
        const wgs84Coordinates = proj4("EPSG:3006", "EPSG:4326", [swerefX, swerefY]);
        return wgs84Coordinates;
    }
    /**
     * Method that transforms WGS84 coordinate to sweref99 tm
     * @param wgs84X
     * @param wgs84Y
     * @returns
     */
    transformWgs84ToSweref(wgs84X, wgs84Y) {
        // Transform SWEREF99TM coordinates to WGS84
        const wgs84Coordinates = proj4("EPSG:4326", "EPSG:3006", [wgs84X, wgs84Y]);
        return wgs84Coordinates;
    }
    /**
     * Method that returns the current scale of the map.
     * @returns The scale
     */
    getScaleForResolution(numberOfDecimals = 5) {
        const resolution = this.map.getView().getResolution();
        const dpi = 96;
        const mpu = this.map.getView().getState().projection.getMetersPerUnit();
        const inchesPerMeter = 39.37;
        return parseFloat((parseFloat(resolution.toString()) * mpu * inchesPerMeter * dpi).toFixed(numberOfDecimals));
    }
    /**
     * Method that returns a view-zoom level based on a scale
     * @param scale The scale. Etc 1:50000, then input is 50000
     * @returns The zoom level that corresponds to the scale
     */
    getZoomForScale(scale) {
        const dpi = 96;
        const inchesPerMeter = 39.37;
        const mpu = this.map.getView().getState().projection.getMetersPerUnit();
        const resolution = scale / (mpu * inchesPerMeter * dpi);
        // Calculate the fractional zoom level
        const zoomAtResolution = this.map.getView().getZoomForResolution(resolution);
        const fractionalZoom = zoomAtResolution - Math.floor(zoomAtResolution);
        // Return the decimal zoom level
        return zoomAtResolution + fractionalZoom;
    }
    /**
     * Method that updates the map size. \
     * If the viewport is changed, it is good to update the map-size to prevent visual bugs from appearing.
     */
    updateMapSize() {
        setTimeout(() => {
            this.map.updateSize();
        }, 10);
    }
    /**
     * Function the re-renders the map.
     */
    render() {
        this.map?.render();
    }
    //Todo: This should be moved to a separate file
    /**
     * Method used for exporting a piece of the map to png or pdf. See https://trv-ng-map.trafikverket.local/example/tools#print for more info
     * @param showLegends If legends should be displayed
     * @param extent The extent to export
     * @param paperSize The "papersize" to export.
     * @param horizontal If the exported view should be horizontal or vertical
     * @param layers VectorLayers to export
     * @param pdfTitle The title displayed in the pdf
     * @param exportAsPdf If the export should be pdf or png
     * @param scale The scale
     * @param showCompass If the "compass" should be displayed
     * @param showScaleLine If the scale line should be displayed
     * @returns Promise<string | jsPDF | undefined>
     */
    async exportMap(showLegends, extent, paperSize, horizontal, layers = [], pdfTitle = "", exportAsPdf = false, scale = 5000, showCompass = true, showScaleLine = true) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        this.setCanvasSize(canvas, paperSize, horizontal);
        const data = await this.getExportMapData(canvas, extent);
        const mainImage = this.createMainImage(data.backgroundData);
        await mainImage.decode();
        ctx.drawImage(mainImage, 0, 0);
        await this.drawLayersOnImage(ctx, data.layersData);
        this.drawFeaturesOnImage(layers, canvas, paperSize, extent, ctx);
        const activeLayers = this.trvLayer.getVisibleWmsLayer() ?? [];
        if (showLegends && activeLayers.length > 0) {
            await this.drawLegendsOnImage(ctx, data.legendsData ?? []);
        }
        if (showCompass)
            await this.drawNorthArrowOnImage(ctx);
        if (showScaleLine) {
            const currentBackroundLayer = this.trvLayer.currentBackroundLayer;
            const darkMode = currentBackroundLayer.darkMode;
            await this.drawScaleLine(ctx, scale, extent, darkMode ?? false);
        }
        return this.exportImageAsPdfOrUrl(mainImage, scale, pdfTitle, horizontal, paperSize, canvas, exportAsPdf, extent);
    }
    // _______________________EXPORT MAP HELPER FUNCTIONS____________________
    setCanvasSize(canvas, paperSize, horizontal) {
        if (paperSize) {
            let Paper = PaperSize;
            let dpi = 96;
            let side1 = Math.round((Paper[paperSize][0] * dpi) / 25.4);
            let side2 = Math.round((Paper[paperSize][1] * dpi) / 25.4);
            if (!horizontal) {
                canvas.width = side1;
                canvas.height = side2;
            }
            else {
                canvas.width = side2;
                canvas.height = side1;
            }
        }
        else {
            const size = this.map.getSize();
            canvas.width = size[0];
            canvas.height = size[1];
        }
    }
    async getExportMapData(canvas, extent) {
        let activeLayers = this.trvLayer.getVisibleWmsLayer() ?? [];
        //Sort layers based on z-index
        activeLayers.sort((a, b) => {
            const aZIndex = a.zIndex !== undefined ? a.zIndex : 100;
            const bZIndex = b.zIndex !== undefined ? b.zIndex : 100;
            return aZIndex - bZIndex;
        });
        //Get legend images
        const legendLayers = activeLayers.filter(layer => layer.type == "wms");
        const legends = legendLayers.map(layer => {
            const vers = layer.version;
            if (layer.type == undefined || layer.type == "wmts") {
            }
            return {
                name: layer.name,
                url: `${layer.url}?TRANSPARENT=true&LAYER=${layer.layerName}&FORMAT=image%2Fpng&SERVICE=WMS&VERSION=${vers}&REQUEST=GetLegendGraphic&SRS=EPSG%3A3006`,
            };
        });
        //Promise to fetch the background layer
        let fetchBackground = this.getLayerImage(this.trvLayer.currentBackroundLayer, canvas.width, canvas.height, extent);
        //Promises to fetch all active layers
        const fetchLayers = activeLayers.map(layer => this.getLayerImage(layer, canvas.width, canvas.height, extent, true));
        //Promises to fetch all legends
        const fetchLegends = legends.map(legend => this.httpClient
            .get(legend.url, { responseType: "arraybuffer" })
            .toPromise()
            .then(arrayBuffer => ({
            name: legend.name,
            legend: arrayBuffer,
        })));
        let backgroundData;
        let layersData;
        let legendsData;
        try {
            [backgroundData, layersData, legendsData] = await Promise.all([fetchBackground, Promise.all(fetchLayers), Promise.all(fetchLegends)]);
        }
        catch (error) {
            console.error("An error occurred:", error);
            this.trvMapService.messageEmitter.emit({
                type: MessageType.Error,
                message: "An error occurred: " + error,
            });
            return;
        }
        return { backgroundData, layersData, legendsData };
    }
    async getLayerImage(layer, width, height, extent, transperant = false) {
        if (layer.type == undefined || layer.type == "wms") {
            return this.getWmsImageQuad(layer, width, height, extent, transperant);
        }
        else if (layer.type == "wmts") {
            return this.exportWmtsExtentToArrayBuffer(layer, layer.layer, extent, width, height);
        }
        else if (layer.type == "osm") {
            return this.exportOSMExtentToArrayBuffer(layer, layer.layer, extent, width, height);
        }
        return Promise.resolve(undefined);
    }
    //quad
    async getWmsImageQuad(layer, width, height, extent, transperant = false) {
        const w2 = Math.ceil(width / 2);
        const h2 = Math.ceil(height / 2);
        const exw2 = (extent[2] - extent[0]) / 2;
        const exh2 = (extent[3] - extent[1]) / 2;
        const extent_topleft = [extent[0], extent[1], extent[2] - exw2, extent[3] - exh2];
        const extent_topright = [extent[0] + exw2, extent[1], extent[2], extent[3] - exh2];
        const extent_botleft = [extent[0], extent[1] + exh2, extent[2] - exw2, extent[3]];
        const extent_botright = [extent[0] + exw2, extent[1] + exh2, extent[2], extent[3]];
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        if (layer.darkMode) {
            context.filter = "grayscale(80%) invert(100%) ";
            context.globalCompositeOperation = "source-over";
        }
        //topleft
        await this.getWmsImage(layer, w2, h2, extent_topleft, transperant)
            .then(response => {
            if (response == undefined)
                throw new Error(`Failed to fetch tile:`);
            return new Blob([response]);
        })
            .then(blob => createImageBitmap(blob))
            .then(image => {
            context.drawImage(image, 0, height - h2, w2, h2);
        });
        //topright
        await this.getWmsImage(layer, w2, h2, extent_topright, transperant)
            .then(response => {
            if (response == undefined)
                throw new Error(`Failed to fetch tile:`);
            return new Blob([response]);
        })
            .then(blob => createImageBitmap(blob))
            .then(image => {
            context.drawImage(image, width - w2, height - h2, w2, h2);
        });
        //botleft
        await this.getWmsImage(layer, w2, h2, extent_botleft, transperant)
            .then(response => {
            if (response == undefined)
                throw new Error(`Failed to fetch tile:`);
            return new Blob([response]);
        })
            .then(blob => createImageBitmap(blob))
            .then(image => {
            context.drawImage(image, 0, 0, w2, h2);
        });
        //botright
        await this.getWmsImage(layer, w2, h2, extent_botright, transperant)
            .then(response => {
            if (response == undefined)
                throw new Error(`Failed to fetch tile:`);
            return new Blob([response]);
        })
            .then(blob => createImageBitmap(blob))
            .then(image => {
            context.drawImage(image, width - w2, 0, w2, h2);
        });
        context.filter = "none";
        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (blob) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        if (reader.result instanceof ArrayBuffer) {
                            resolve(reader.result);
                        }
                        else {
                            reject(new Error("Failed to convert canvas to ArrayBuffer"));
                        }
                    };
                    reader.onerror = reject;
                    reader.readAsArrayBuffer(blob);
                }
                else {
                    reject(new Error("Failed to convert canvas to Blob"));
                }
            }, "image/png");
        });
    }
    //Single
    async getWmsImage(layer, width, height, extent, transperant = false) {
        var version = this.trvLayer.currentBackroundLayer.version;
        let bboxAndSrs = `&STYLES=&BBOX=${extent[0]}%2C${extent[1]}%2C${extent[2]}%2C${extent[3]}`;
        if (version == "1.3.0") {
            bboxAndSrs += "&CRS=EPSG%3A3006";
        }
        else {
            bboxAndSrs += "&SRS=EPSG%3A3006";
        }
        if (transperant) {
            bboxAndSrs += "&TRANSPARENT=true";
        }
        const backgroundUrl = `${layer.url}?LAYERS=${layer.layerName}&FORMAT=image%2Fpng&SERVICE=WMS&VERSION=${version}&REQUEST=GetMap&WIDTH=${width}&HEIGHT=${height}${bboxAndSrs}`;
        return this.httpClient.get(backgroundUrl, { responseType: "arraybuffer" }).toPromise();
    }
    async exportOSMExtentToArrayBuffer(layerListItem, layer, extent, width, height) {
        const source = layer.getSource();
        const tileGrid = source.getTileGrid();
        // Transform the extent from EPSG:3006 to EPSG:3857
        const extent3857 = transformExtent(extent, "EPSG:3006", source.getProjection().getCode());
        // Calculate scale factor to fit the extent into the canvas size
        const extentWidth = getWidth(extent3857);
        const extentHeight = getHeight(extent3857);
        const resolutionX = extentWidth / width;
        const resolutionY = extentHeight / height;
        const resolution = Math.max(resolutionX, resolutionY);
        // Calculate zoom level that fits the extent within the desired width or height
        const zoom = tileGrid.getZForResolution(resolution);
        // Calculate canvas size based on width and height
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        // Get tile size at the current zoom level
        const tileSize = tileGrid.getTileSize(zoom);
        // Get the range of tiles that intersect with the extent
        const tileRange = tileGrid.getTileRangeForExtentAndZ(extent3857, zoom);
        const fetchPromises = [];
        if (layerListItem.darkMode) {
            context.filter = "grayscale(80%) invert(100%) ";
            context.globalCompositeOperation = "source-over";
        }
        for (let x = tileRange.minX; x <= tileRange.maxX; x++) {
            for (let y = tileRange.minY; y <= tileRange.maxY; y++) {
                const tileCoord = [zoom, x, y];
                const tileUrl = source.getTileUrlFunction()(tileCoord, 1, source.getProjection());
                const fetchPromise = fetch(tileUrl)
                    .then(response => {
                    if (!response.ok) {
                        throw new Error(`Failed to fetch tile: ${response.status} ${response.statusText}`);
                    }
                    return response.blob();
                })
                    .then(blob => createImageBitmap(blob))
                    .then(image => {
                    // Calculate position and size of the tile on the canvas
                    const tileExtent = tileGrid.getTileCoordExtent(tileCoord);
                    const tileWidth = Math.ceil(getWidth(tileExtent) / resolutionX);
                    const tileHeight = Math.ceil(getHeight(tileExtent) / resolutionY);
                    const dx = Math.floor((tileExtent[0] - extent3857[0]) / resolutionX);
                    const dy = Math.floor((extent3857[3] - tileExtent[3]) / resolutionY);
                    // Draw the tile on the canvas
                    context.drawImage(image, dx, dy, tileWidth, tileHeight);
                })
                    .catch(error => {
                    console.error("Error fetching or drawing tile:", error);
                    throw error; // Propagate error further
                });
                fetchPromises.push(fetchPromise);
            }
        }
        // Wait for all tiles to be fetched and drawn
        await Promise.all(fetchPromises);
        context.filter = "none";
        // Convert canvas to ArrayBuffer (image/png format)
        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (blob) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        if (reader.result instanceof ArrayBuffer) {
                            resolve(reader.result);
                        }
                        else {
                            reject(new Error("Failed to convert canvas to ArrayBuffer"));
                        }
                    };
                    reader.onerror = reject;
                    reader.readAsArrayBuffer(blob);
                }
                else {
                    reject(new Error("Failed to convert canvas to Blob"));
                }
            }, "image/png");
        });
    }
    async exportWmtsExtentToArrayBuffer(layerListItem, layer, extent, width, height) {
        const tileGrid = layer.getSource().getTileGrid();
        const source = layer.getSource();
        // Calculate scale factor to fit the extent into the canvas size
        const extentWidth = getWidth(extent);
        const extentHeight = getHeight(extent);
        const resolutionX = extentWidth / width;
        const resolutionY = extentHeight / height;
        const resolution = Math.max(resolutionX, resolutionY);
        // Calculate zoom level that fits the extent within the desired width or height
        const zoom = tileGrid.getZForResolution(resolution);
        // Calculate canvas size based on width and height
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        // Get tile size at the current zoom level
        const tileSize = tileGrid.getTileSize(zoom);
        const tileSizeX = typeof tileSize === "number" ? tileSize : tileSize[0];
        const tileSizeY = typeof tileSize === "number" ? tileSize : tileSize[1];
        // Transform extent to match the projection of the WMTS layer
        const mapProjection = source.getProjection();
        const extentInLayerProjection = transformExtent(extent, "EPSG:3006", mapProjection);
        // Get the range of tiles that intersect with the extent
        const tileRange = tileGrid.getTileRangeForExtentAndZ(extentInLayerProjection, zoom);
        if (layerListItem.darkMode) {
            context.filter = "grayscale(80%) invert(100%) ";
            context.globalCompositeOperation = "source-over";
        }
        // Fetch and draw each tile
        const fetchPromises = [];
        for (let x = tileRange.minX; x <= tileRange.maxX; x++) {
            for (let y = tileRange.minY; y <= tileRange.maxY; y++) {
                const tileCoord = [zoom, x, y];
                const tileUrl = source.getTileUrlFunction()(tileCoord, 1, mapProjection);
                const fetchPromise = fetch(tileUrl)
                    .then(response => {
                    if (!response.ok) {
                        throw new Error(`Failed to fetch tile: ${response.status} ${response.statusText}`);
                    }
                    return response.blob();
                })
                    .then(blob => createImageBitmap(blob))
                    .then(image => {
                    // Calculate position and size of the tile on the canvas
                    const tileExtent = tileGrid.getTileCoordExtent(tileCoord);
                    //const tileExtentInExtentProjection = transformExtent(tileExtent, mapProjection, extentInLayerProjection);
                    const tileWidth = Math.ceil(getWidth(tileExtent) / resolutionX);
                    const tileHeight = Math.ceil(getHeight(tileExtent) / resolutionY);
                    const dx = Math.floor((tileExtent[0] - extent[0]) / resolutionX);
                    const dy = Math.floor((extent[3] - tileExtent[3]) / resolutionY);
                    // Draw the tile on the canvas
                    context.drawImage(image, dx, dy, tileWidth, tileHeight);
                })
                    .catch(error => {
                    console.error("Error fetching or drawing tile:", error);
                    throw error; // Propagate error further
                });
                fetchPromises.push(fetchPromise);
            }
        }
        // Wait for all tiles to be fetched and drawn
        await Promise.all(fetchPromises);
        context.filter = "none";
        // Convert canvas to ArrayBuffer (image/png format)
        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (blob) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        if (reader.result instanceof ArrayBuffer) {
                            resolve(reader.result);
                        }
                        else {
                            reject(new Error("Failed to convert canvas to ArrayBuffer"));
                        }
                    };
                    reader.onerror = reject;
                    reader.readAsArrayBuffer(blob);
                }
                else {
                    reject(new Error("Failed to convert canvas to Blob"));
                }
            }, "image/png");
        });
    }
    createMainImage(backgroundData) {
        const mainImage = new Image();
        mainImage.src = URL.createObjectURL(new Blob([new Uint8Array(backgroundData)], {
            type: "image/png",
        }));
        return mainImage;
    }
    async drawLayersOnImage(ctx, layersData) {
        let promises = [];
        for (const layerData of layersData) {
            const layerImageBlob = new Blob([new Uint8Array(layerData)], { type: "image/png" });
            const layerImageUrl = URL.createObjectURL(layerImageBlob);
            const layerImg = new Image();
            layerImg.src = layerImageUrl;
            promises.push(new Promise(async (resolve) => {
                try {
                    await layerImg.decode();
                    if (layerImg.width != 0 && layerImg.height != 0) {
                        ctx.drawImage(layerImg, 0, 0);
                    }
                }
                catch (error) {
                    console.error("Error decoding image:", error);
                }
                finally {
                    resolve();
                }
            }));
        }
        await Promise.all(promises);
    }
    drawFeatureStyleToImage(feature, style, canvas, paperSize, extent, ctx) {
        const geometry = feature.getGeometry();
        const resolution = paperSize ? (extent[2] - extent[0]) / canvas.width : this.map.getView().getResolution();
        // Point Geometry
        if (geometry instanceof Point) {
            const coordinates = geometry.getCoordinates();
            const pixelX = (coordinates[0] - extent[0]) / resolution;
            const pixelY = (extent[3] - coordinates[1]) / resolution;
            const imageStyle = style.getImage();
            // apperently the size get set to null when its not in view????
            if (imageStyle && ctx && imageStyle.getSize() != null) {
                const imageElement = imageStyle.getImage(1);
                let scale = imageStyle.getScale();
                let scaleWidth = Array.isArray(scale) ? scale[0] : scale;
                let scaleHeight = Array.isArray(scale) ? scale[1] : scale;
                const imgWidth = imageStyle.getSize()[0] * scaleWidth;
                const imgHeight = imageStyle.getSize()[1] * scaleHeight;
                const anchorX = imageStyle.getAnchor()[0] * scaleWidth;
                const anchorY = imageStyle.getAnchor()[1] * scaleHeight;
                ctx.drawImage(imageElement, pixelX - anchorX, pixelY - anchorY, imgWidth, imgHeight);
            }
            const textStyle = style.getText();
            if (textStyle && ctx) {
                const fill = textStyle.getFill();
                const offsetX = textStyle.getOffsetX();
                const offsetY = textStyle.getOffsetY();
                const text = textStyle.getText();
                const textAlign = textStyle.getTextAlign();
                const color = fill?.getColor();
                if (color)
                    ctx.fillStyle = color.toString();
                if (textAlign)
                    ctx.textAlign = textAlign;
                if (text instanceof Array) {
                    text.forEach(txt => {
                        ctx.fillText(txt, pixelX + offsetX, pixelY + offsetY);
                    });
                }
                else {
                    ctx.fillText(text, pixelX + offsetX, pixelY + offsetY);
                }
            }
        }
        // LineString Geometry
        else if (geometry instanceof LineString) {
            const coordinates = geometry.getCoordinates();
            const stroke = style.getStroke();
            if (stroke && ctx) {
                ctx.beginPath();
                ctx.strokeStyle = stroke.getColor();
                ctx.setLineDash(stroke.getLineDash() ?? []);
                ctx.lineWidth = stroke.getWidth() || 1;
                for (let i = 0; i < coordinates.length; i++) {
                    const pixelX = (coordinates[i][0] - extent[0]) / resolution;
                    const pixelY = (extent[3] - coordinates[i][1]) / resolution;
                    if (i === 0) {
                        ctx.moveTo(pixelX, pixelY);
                    }
                    else {
                        ctx.lineTo(pixelX, pixelY);
                    }
                }
                ctx.stroke();
            }
        }
        else if (geometry instanceof MultiLineString) {
            const line_coords = geometry.getCoordinates();
            const stroke = style.getStroke();
            if (stroke && ctx) {
                ctx.beginPath();
                ctx.strokeStyle = stroke.getColor();
                ctx.setLineDash(stroke.getLineDash() ?? []);
                ctx.lineWidth = stroke.getWidth() || 1;
                for (let coordinates of line_coords) {
                    for (let i = 0; i < coordinates.length; i++) {
                        const pixelX = (coordinates[i][0] - extent[0]) / resolution;
                        const pixelY = (extent[3] - coordinates[i][1]) / resolution;
                        if (i === 0) {
                            ctx.moveTo(pixelX, pixelY);
                        }
                        else {
                            ctx.lineTo(pixelX, pixelY);
                        }
                    }
                }
                ctx.stroke();
            }
        }
        // Polygon Geometry
        else if (geometry instanceof Polygon) {
            const fill = style.getFill();
            const stroke = style.getStroke();
            if ((fill || stroke) && ctx) {
                ctx.beginPath();
                const rings = geometry.getCoordinates();
                for (const ring of rings) {
                    for (let i = 0; i < ring.length; i++) {
                        const pixelX = (ring[i][0] - extent[0]) / resolution;
                        const pixelY = (extent[3] - ring[i][1]) / resolution;
                        if (i === 0) {
                            ctx.moveTo(pixelX, pixelY);
                        }
                        else {
                            ctx.lineTo(pixelX, pixelY);
                        }
                    }
                }
                if (fill) {
                    ctx.fillStyle = fill.getColor();
                    ctx.fill();
                }
                if (stroke) {
                    ctx.strokeStyle = stroke.getColor();
                    ctx.lineWidth = stroke.getWidth() || 1;
                    ctx.stroke();
                }
            }
        }
    }
    drawFeaturesOnImage(layers, canvas, paperSize, extent, ctx) {
        const resolution = this.map.getView().getResolution();
        for (const layer of layers) {
            const source = layer.getSource();
            let features = source?.getFeatures() ?? [];
            if (source instanceof Cluster) {
                features = source.getSource()?.getFeatures() ?? [];
            }
            for (const feature of features) {
                let style = feature.getStyle();
                if (style == undefined) {
                    style = layer.getStyle();
                }
                if (style instanceof Style) {
                    this.drawFeatureStyleToImage(feature, style, canvas, paperSize, extent, ctx);
                }
                else if (Array.isArray(style)) {
                    for (const s of style) {
                        this.drawFeatureStyleToImage(feature, s, canvas, paperSize, extent, ctx);
                    }
                }
                else if (typeof style === "function") {
                    const computedStyles = style(feature, resolution);
                    if (!computedStyles)
                        continue;
                    if (Array.isArray(computedStyles)) {
                        for (const s of computedStyles) {
                            this.drawFeatureStyleToImage(feature, s, canvas, paperSize, extent, ctx);
                        }
                    }
                    else {
                        this.drawFeatureStyleToImage(feature, computedStyles, canvas, paperSize, extent, ctx);
                    }
                }
            }
        }
    }
    async drawNorthArrowOnImage(ctx) {
        const img = new Image();
        img.src = "assets/images/misc/norrpil.png";
        await img.decode();
        const margin = 20;
        const x = ctx.canvas.width - img.width - margin;
        const y = margin;
        this.enableBlur(ctx);
        ctx.drawImage(img, x, y);
        this.disableBlur(ctx);
    }
    async drawScaleLine(ctx, scale, extent, darkMode = false) {
        const mapWidthInM = extent[2] - extent[0]; // Calculate map width in meters
        const imageWidth = ctx.canvas.width; // Get image width from canvas
        const pixPerMeter = imageWidth / mapWidthInM; // Calculate pixels per meter
        const startX = 20; // Starting x position of the scale line
        const startY = ctx.canvas.height - 30; // Y position for the scale line
        const desiredLengthInPixels = 300; // Desired length of the scale line in pixels
        // Find the closest significant length in meters that represents the desired pixel length
        const scaleLineLengthInM = this.getClosestSignificantLength(desiredLengthInPixels, pixPerMeter);
        const scaleLineLengthInPixels = scaleLineLengthInM * pixPerMeter; // Convert to pixels
        ctx.fillStyle = "rgba(255,255,255,0.85)"; // Background color
        ctx.beginPath();
        ctx.roundRect(0, //x
        startY - 30, // y
        scaleLineLengthInPixels + 30 + 40, // width
        ctx.canvas.height - startY + 60, // height
        [0, 10, 0, 0] // top right rounded corner
        );
        ctx.fill();
        ctx.font = '16px "Open sans", Helvetica, Arial, sans-serif';
        ctx.setLineDash([]);
        // Draw the main scale line
        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.lineTo(startX + scaleLineLengthInPixels, startY);
        ctx.strokeStyle = "black"; // Default line color
        if (darkMode)
            ctx.strokeStyle = "white"; // Dark mode line color
        ctx.lineWidth = 2;
        ctx.stroke();
        // Determine positions for ticks
        const tickPositions = this.getTickPositions(scaleLineLengthInM, 4); // Get 3 main ticks (including start and end)
        // Add an additional tick position between the first and second
        const additionalTickPosition = (tickPositions[0] + tickPositions[1]) / 2;
        tickPositions.splice(1, 0, additionalTickPosition); // Insert the additional tick position
        // Create arrays for short ticks
        const leftShortTicks = this.getShortTickPositions(additionalTickPosition, -1, 4); // 4 ticks to the left
        const rightShortTicks = this.getShortTickPositions(additionalTickPosition, 1, 4); // 4 ticks to the right
        // Draw ticks
        this.drawTicks(ctx, tickPositions, startX, startY, pixPerMeter, true, darkMode); // Main ticks with labels
        this.drawTicks(ctx, leftShortTicks, startX, startY, pixPerMeter, false, darkMode); // Short ticks to the left
        this.drawTicks(ctx, rightShortTicks, startX, startY, pixPerMeter, false, darkMode); // Short ticks to the right
        // Scale label
        const scaleLabel = `1:${scale}`; // Use the provided scale parameter
        ctx.textAlign = "center";
        ctx.fillText(scaleLabel, startX + scaleLineLengthInPixels / 2, startY - 10); // Positioning the scale label
    }
    // Function to draw ticks based on provided positions
    drawTicks(ctx, positions, startX, startY, pixPerMeter, mainTicks, darkMode = false) {
        ctx.fillStyle = "black"; // Text color
        if (darkMode)
            ctx.fillStyle = "white"; // Dark mode text color
        var i = 0;
        for (const length of positions) {
            const tickPositionX = startX + length * pixPerMeter; // Calculate tick position in pixels
            // Draw vertical markers
            ctx.beginPath();
            ctx.strokeStyle = "black"; // Marker color
            if (darkMode)
                ctx.strokeStyle = "white"; // Dark mode line color
            ctx.moveTo(tickPositionX, startY - (mainTicks ? 5 : 3)); // Adjust height for short ticks
            ctx.lineTo(tickPositionX, startY + (mainTicks ? 5 : 3)); // Adjust height for short ticks
            ctx.stroke();
            ctx.lineWidth = mainTicks ? 2 : 1; // Adjust line width for short ticks
            // Only draw label for the main ticks
            if (mainTicks && i != 1) {
                // Label in meters or kilometers
                const isKilometers = length >= 1000;
                const distanceLabel = isKilometers ? `${(length / 1000).toFixed(0)}km` : `${length.toFixed(0)}m`;
                ctx.fillStyle = "black";
                if (darkMode)
                    ctx.fillStyle = "white"; // Dark mode line color
                ctx.fillText(distanceLabel, tickPositionX - 10, startY + 20); // Draw text on top
                // Draw text outline (white)
                //ctx.fillStyle = "black"; // Reset to text color
                //ctx.fillText(distanceLabel, tickPositionX - 10, startY + 20); // Draw text on top
            }
            i++;
        }
    }
    // Function to get short tick positions
    getShortTickPositions(referencePosition, direction, count) {
        const positions = [];
        const interval = referencePosition / (count + 1); // Calculate interval for short ticks
        for (let i = 1; i <= count; i++) {
            positions.push(referencePosition + direction * i * interval); // Add tick positions based on interval
        }
        return positions;
    }
    // Function to determine the closest significant length in meters based on desired pixel length
    getClosestSignificantLength(desiredLengthInPixels, pixPerMeter) {
        //const significantLengths = [10, 50, 100, 200, 300, 400, 500, 1000, 2000, 3000, 4000, 5000, 10000, 50000, 100000]; // Significant lengths in meters
        const significantLengths = [30, 60, 90, 300, 900, 3000, 9000, 30000, 90000, 300000, 900000]; // Significant lengths in meters
        let closestLength = significantLengths[0];
        let closestDiff = Math.abs(desiredLengthInPixels - closestLength * pixPerMeter);
        for (const length of significantLengths) {
            const currentDiff = Math.abs(desiredLengthInPixels - length * pixPerMeter);
            if (currentDiff < closestDiff) {
                closestDiff = currentDiff;
                closestLength = length;
            }
        }
        return closestLength;
    }
    // Function to get tick positions
    getTickPositions(lengthInM, totalTicks) {
        const positions = [];
        const interval = lengthInM / (totalTicks - 1); // Calculate interval for ticks
        for (let i = 0; i < totalTicks; i++) {
            positions.push(i * interval); // Add tick positions based on interval
        }
        return positions;
    }
    async drawLegendsOnImage(mainCtx, legendsData) {
        const padding = 6;
        const gapBetweenTextAndImage = 2;
        const gapBetweenItems = 4;
        const fontSize = 16;
        const minWidth = 150;
        const tmpCanvas = document.createElement("canvas");
        tmpCanvas.width = mainCtx.canvas.width;
        tmpCanvas.height = mainCtx.canvas.height;
        const tmpCtx = tmpCanvas.getContext("2d");
        tmpCtx.fillStyle = "white";
        tmpCtx.fillRect(0, 0, tmpCanvas.width, tmpCanvas.height);
        tmpCtx.font = "600 " + fontSize + "px Arial";
        tmpCtx.textBaseline = "top";
        tmpCtx.fillStyle = "rgb(33, 37, 41)";
        let currentHeight = padding;
        let maxWidth = 0;
        mainCtx.font = "600 " + fontSize + "px Arial";
        for (const legend of legendsData) {
            if (!legend.legend)
                continue;
            const layerImageBlob = new Blob([new Uint8Array(legend.legend)], { type: "image/png" });
            const layerImageUrl = URL.createObjectURL(layerImageBlob);
            const layerImg = new Image();
            layerImg.src = layerImageUrl;
            try {
                await layerImg.decode();
                if (layerImg.width == 0 || layerImg.height == 0)
                    return;
                tmpCtx.fillText(legend.name, padding, currentHeight + gapBetweenItems);
                tmpCtx.drawImage(layerImg, padding, currentHeight + fontSize + gapBetweenTextAndImage);
                currentHeight += Math.round(layerImg.height + fontSize + gapBetweenItems + gapBetweenTextAndImage);
                maxWidth = Math.max(maxWidth, layerImg.width, mainCtx.measureText(legend.name).width, minWidth);
            }
            catch (error) {
                console.error("Error decoding image:", error);
            }
        }
        this.enableBlur(mainCtx);
        mainCtx.drawImage(tmpCanvas, 0, 0, maxWidth + 2 * padding, currentHeight + 2 * padding, 10, 10, maxWidth + 2 * padding, currentHeight);
        this.disableBlur(mainCtx);
    }
    enableBlur(ctx) {
        ctx.shadowColor = "rgba(0, 0, 0, 0.5)"; // Black shadow with 50% opacity
        ctx.shadowBlur = 10; // Blur level of the shadow
        ctx.shadowOffsetX = 5; // Horizontal shadow offset
        ctx.shadowOffsetY = 5;
    }
    disableBlur(ctx) {
        ctx.shadowColor = "transparent"; // Disable shadow
        ctx.shadowBlur = 0; // No blur
        ctx.shadowOffsetX = 0; // No horizontal offset
        ctx.shadowOffsetY = 0;
    }
    exportImageAsPdfOrUrl(image, scale, pdfTitle, horizontal, paperSize, canvas, exportAsPdf, extent) {
        const dataUrl = canvas.toDataURL("image/png");
        if (exportAsPdf) {
            const pdf = new jsPDF({
                orientation: horizontal ? "landscape" : "portrait",
                unit: "mm",
                format: paperSize.toLowerCase(),
            });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const titleFontSize = 16;
            const regularFontSize = 10;
            const imageMarginTop = 20;
            let pdfImageHeight = pageHeight - imageMarginTop * 2;
            let imageMarginleftPercentage = (1 - pdfImageHeight / pageHeight) / 2;
            let pdfImageWidth = pageWidth * (pdfImageHeight / pageHeight);
            // see if either the image height or the width is the limiting factor when displaying
            // the image and crop to keep the aspect ratio. We change the left margin since we want to center it horizontally but not vertically
            if ((horizontal && 1.414 > canvas.width / canvas.height) || 1 / 1.414 > canvas.width / canvas.height) {
                pdfImageWidth = (pdfImageHeight * canvas.width) / canvas.height;
                imageMarginleftPercentage = (1 - pdfImageWidth / pageWidth) / 2;
            }
            else {
                pdfImageHeight = (pdfImageWidth * canvas.height) / canvas.width;
            }
            // MAP CENTER
            pdf.addImage(dataUrl, "PNG", pageWidth * imageMarginleftPercentage, imageMarginTop, pdfImageWidth, pdfImageHeight);
            //line 1
            const topleftx = pageWidth * imageMarginleftPercentage;
            const toplefty = imageMarginTop;
            pdf.line(topleftx - 2, toplefty, topleftx + 5, toplefty);
            pdf.line(topleftx, toplefty - 2, topleftx, toplefty + 5);
            pdf.setFontSize(6);
            pdf.text("N: " + extent[1].toFixed(0), topleftx + 1, toplefty - 1);
            const toplefteText = "E: " + extent[0].toFixed(0);
            const eTextWidth = (pdf.getStringUnitWidth(toplefteText) * 6) / pdf.internal.scaleFactor;
            pdf.text(toplefteText, topleftx - 1, toplefty + eTextWidth + 1, {
                align: "justify",
                angle: 90,
            });
            const rightbotx = pageWidth * imageMarginleftPercentage + pdfImageWidth;
            const rightboty = imageMarginTop + pdfImageHeight;
            pdf.line(rightbotx + 2, rightboty, rightbotx - 5, rightboty);
            pdf.line(rightbotx, rightboty + 2, rightbotx, rightboty - 5);
            pdf.setFontSize(6);
            const botrightText = "N: " + extent[3].toFixed(0);
            const eTextWidthbot = (pdf.getStringUnitWidth(botrightText) * 6) / pdf.internal.scaleFactor;
            pdf.text(botrightText, rightbotx - eTextWidthbot - 1, rightboty + 2.5);
            pdf.text("E: " + extent[2].toFixed(0), rightbotx + 2.5, rightboty - 1, {
                align: "justify",
                angle: 90,
            });
            // TITLE TOP CENTER
            pdf.setFontSize(titleFontSize);
            const titleWidth = (pdf.getStringUnitWidth(pdfTitle) * titleFontSize) / pdf.internal.scaleFactor;
            const titleX = (pageWidth - titleWidth) / 2;
            pdf.text(pdfTitle, titleX, imageMarginTop / 2);
            // TRAFIKVERKET LOGO TOP LEFT
            const img = new Image();
            img.src = "assets/images/misc/trafikverket-logo.png";
            // it cannot be more than titleX - 48 since it would then overlap the title text
            const logoX = Math.min((pageWidth - pdfImageWidth) / 2, titleX - 48);
            pdf.addImage(img, "PNG", logoX, (imageMarginTop - 10) / 2, 48, 10);
            // DATE IN THE BOTTOM LEFT
            pdf.setFontSize(regularFontSize);
            const ownerInfo = this.trvLayer.currentBackroundLayer.attribution ?? "";
            pdf.text(ownerInfo, pageWidth * imageMarginleftPercentage, pdfImageHeight + imageMarginTop + 7);
            // DATE IN THE BOTTOM RIGHT
            const scaleInfo = "Skala 1:" + scale;
            const scaleInfoWidth = (pdf.getStringUnitWidth(scaleInfo) * regularFontSize) / pdf.internal.scaleFactor;
            pdf.text(scaleInfo, pageWidth * (1 - imageMarginleftPercentage) - scaleInfoWidth, pdfImageHeight + imageMarginTop + 7);
            // DATE IN THE BOTTOM RIGHT
            let d = new Date();
            let month = "" + (d.getMonth() + 1);
            let day = "" + d.getDate();
            let year = d.getFullYear();
            if (month.length < 2)
                month = "0" + month;
            if (day.length < 2)
                day = "0" + day;
            let formattedDate = [year, month, day].join("-");
            const dateWidth = (pdf.getStringUnitWidth(formattedDate) * regularFontSize) / pdf.internal.scaleFactor;
            pdf.text(formattedDate, pageWidth * (1 - imageMarginleftPercentage) - dateWidth, pdfImageHeight + imageMarginTop + 13); // adjust x and y as necessary
            return pdf;
        }
        else {
            return dataUrl;
        }
    }
}
function transformSwerefToWgs84Func(swerefX, swerefY) {
    // Transform SWEREF99TM coordinates to WGS84
    const wgs84Coordinates = proj4("EPSG:3006", "EPSG:4326", [swerefX, swerefY]);
    return wgs84Coordinates;
}
var MessageType;
(function (MessageType) {
    MessageType[MessageType["Success"] = 0] = "Success";
    MessageType[MessageType["Info"] = 1] = "Info";
    MessageType[MessageType["Warn"] = 2] = "Warn";
    MessageType[MessageType["Error"] = 3] = "Error";
})(MessageType || (MessageType = {}));
var FileType;
(function (FileType) {
    FileType[FileType["PNG"] = 0] = "PNG";
    FileType[FileType["PDF"] = 1] = "PDF";
})(FileType || (FileType = {}));
var ExportDirection;
(function (ExportDirection) {
    ExportDirection[ExportDirection["Standing"] = 0] = "Standing";
    ExportDirection[ExportDirection["Laying"] = 1] = "Laying";
})(ExportDirection || (ExportDirection = {}));
var ExportSize;
(function (ExportSize) {
    ExportSize[ExportSize["MapView"] = 0] = "MapView";
    ExportSize[ExportSize["A4"] = 1] = "A4";
    ExportSize[ExportSize["A3"] = 2] = "A3";
    ExportSize[ExportSize["A2"] = 3] = "A2";
    ExportSize[ExportSize["A1"] = 4] = "A1";
    ExportSize[ExportSize["A0"] = 5] = "A0";
})(ExportSize || (ExportSize = {}));

/**
 * Service used mainly for retrieving TrvMap and checking wether a map has loaded. \
 *
 */
class TrvNgMapService {
    trvMap;
    trvMaps = {};
    latestMapExportTrigger = new EventEmitter();
    messageEmitter = new EventEmitter();
    mapKeyLoaded = new EventEmitter();
    _isMapLoaded = false;
    _onMapLoaded = new EventEmitter();
    _isMapLoadedForKey = {};
    _onMapLoadedForKey = {};
    latestMapExportTriggerForKey = {};
    //Street view variables
    isStreetViewAvailable = false;
    streetViewLocation;
    numStreetViewcalls = 0;
    scriptLoadingPromise;
    constructor() { }
    /**
     * Registers a trvMap. If no key is provided the variable trvMap is set, otherwise the trvMap is stored in trvMaps key value storage
     * @param trvMap the trvMap instance
     * @param key The key. Not required
     * @returns void
     */
    setTrvMap(trvMap, key, defaultMap = false) {
        if (defaultMap) {
            this.trvMap = trvMap;
        }
        this.latestMapExportTriggerForKey[key] = new EventEmitter();
        this.trvMaps[key] = trvMap;
    }
    /**
     * Returns the instance of TrvMap, either the main TrvMap or a TrvMap mapped to a key
     * @param key Not required
     * @returns TrvMap
     */
    getTrvMap(key) {
        if (!key) {
            return this.trvMap;
        }
        if (key in this.trvMaps) {
            return this.trvMaps[key];
        }
        return undefined;
    }
    setIsMapLoaded(value, key) {
        if (key == undefined) {
            this._isMapLoaded = value;
        }
        else {
            this._isMapLoadedForKey[key] = value;
        }
        if (value) {
            this.onMapLoaded(key).emit();
            this.mapKeyLoaded.emit(key);
        }
    }
    destroyMapEmitter(key) {
        if (key != undefined) {
            delete this._onMapLoadedForKey[key];
        }
        else {
            this._onMapLoaded = undefined;
        }
    }
    /**
     * Returns true/false if trvMap has loaded. \
     * If Key is provided, it will check if the trvMap with that key is loaded. \
     * If the key doesn't exists, it will return fase.
     * @param key The key to check
     * @returns true/false
     */
    isMapLoaded(key) {
        if (key == undefined)
            return this._isMapLoaded;
        if (key in this._isMapLoadedForKey)
            return this._isMapLoadedForKey[key];
        return false;
    }
    /**
     * Returns EventEmitter<void> that will trigger when a trvMap loads for the first time. \
     * If a key is provided, it will return the event-emitter that represents a specific trvMap with id key.
     * @param key The key to check
     * @returns EventEmitter<void>
     */
    onMapLoaded(key) {
        if (key == undefined) {
            if (!this._onMapLoaded)
                this._onMapLoaded = new EventEmitter();
            return this._onMapLoaded;
        }
        if (!(key in this._onMapLoadedForKey))
            this._onMapLoadedForKey[key] = new EventEmitter();
        return this._onMapLoadedForKey[key];
    }
    createOnMapLoaded(key) {
        if (key == undefined)
            return;
        this._onMapLoadedForKey[key] = new EventEmitter();
    }
    /**
     * Method that returns the current MapTool for a trvMap.\
     * If a key  is provided, it will return the MapTool for a trvMap with that id.
     * @param key The key to check
     * @returns Current Maptool
     */
    getTool(key) {
        let trvMap = undefined;
        if (!key) {
            trvMap = this.trvMap;
        }
        else {
            trvMap = this.trvMaps[key];
        }
        if (trvMap) {
            return trvMap.activeMapTool?.value;
        }
        return MapTools.None;
    }
    /**
     * Loads the google-api script onto the page
     * @param apiKey You google-api key.
     * @returns
     */
    loadScriptApi(apiKey) {
        return new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=Function.prototype`;
            script.onload = () => {
                resolve();
            };
            script.onerror = error => {
                reject(error);
            };
            document.body.appendChild(script);
        });
    }
    /**
     * Checks if street-view is available on a specific coordinate. \
     * Requires API key to have been set.
     * @param coordinate The ol/coordinate to check
     */
    streetViewAvailable(coordinate) {
        try {
            const streetViewService = new google.maps.StreetViewService();
            const wgs = transformSwerefToWgs84Func(coordinate[0], coordinate[1]);
            let latlng = { lat: wgs[1], lng: wgs[0] };
            streetViewService.getPanorama({ location: latlng, radius: 50 }, (data, status) => {
                this.numStreetViewcalls++;
                if (status === "OK") {
                    this.isStreetViewAvailable = true;
                    this.streetViewLocation = data.location;
                }
                else {
                    this.isStreetViewAvailable = false;
                    this.streetViewLocation = null;
                }
            });
        }
        catch (e) {
            this.isStreetViewAvailable = false;
            console.log("CUSTOM ERROR");
            console.log(e);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: TrvNgMapService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: TrvNgMapService, providedIn: "root" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: TrvNgMapService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: () => [] });

class StreetViewComponent {
    initStreetView = new EventEmitter();
    exitStreetView = new EventEmitter();
    streetViewRef;
    constructor() { }
    ngOnInit() {
        this.initStreetView.emit(this.streetViewRef);
    }
    closeStreetView() {
        this.exitStreetView.emit();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: StreetViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.0", type: StreetViewComponent, isStandalone: true, selector: "lib-street-view", outputs: { initStreetView: "initStreetView", exitStreetView: "exitStreetView" }, viewQueries: [{ propertyName: "streetViewRef", first: true, predicate: ["streetView"], descendants: true, static: true }], ngImport: i0, template: "<div style=\"position: absolute; width: 100%; height: 100%; z-index: 1500;\">\r\n    <div style=\"position: relative; width: 100%; height: 100%; z-index: 1000\">\r\n        <div style=\"position: absolute; z-index: 2; width: 100%; display: flex; justify-content: center\">\r\n            <button class=\"street-view-close\" (click)=\"closeStreetView()\">St\u00E4ng streetview</button>\r\n        </div>\r\n        <div #streetView style=\"width: 100%; height: 100%\"></div>\r\n    </div>\r\n</div>\r\n", styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: StreetViewComponent, decorators: [{
            type: Component,
            args: [{ selector: "lib-street-view", standalone: true, template: "<div style=\"position: absolute; width: 100%; height: 100%; z-index: 1500;\">\r\n    <div style=\"position: relative; width: 100%; height: 100%; z-index: 1000\">\r\n        <div style=\"position: absolute; z-index: 2; width: 100%; display: flex; justify-content: center\">\r\n            <button class=\"street-view-close\" (click)=\"closeStreetView()\">St\u00E4ng streetview</button>\r\n        </div>\r\n        <div #streetView style=\"width: 100%; height: 100%\"></div>\r\n    </div>\r\n</div>\r\n" }]
        }], ctorParameters: () => [], propDecorators: { initStreetView: [{
                type: Output
            }], exitStreetView: [{
                type: Output
            }], streetViewRef: [{
                type: ViewChild,
                args: ["streetView", { static: true }]
            }] } });

class TrvNgMapComponent {
    trvMapService;
    trvMapOverlayService;
    appRef;
    httpClient;
    trvMap;
    layerInput;
    id;
    defaultMap = true;
    hideControls = false;
    mapElement;
    isMouseLeftdown = false;
    componentRef;
    componentRefs = [];
    constructor(trvMapService, trvMapOverlayService, appRef, httpClient) {
        this.trvMapService = trvMapService;
        this.trvMapOverlayService = trvMapOverlayService;
        this.appRef = appRef;
        this.httpClient = httpClient;
        if (!this.id)
            this.id = generateGUID();
    }
    ngOnInit() {
        this.trvMap = new TrvMap(this.trvMapOverlayService, this.trvMapService, this.layerInput, this.httpClient, this.id, this.defaultMap);
        this.trvMap.hideControls = this.hideControls;
        if (this.hideControls) {
            this.trvMap.trvControl.resetControls();
        }
        this.trvMapService.setTrvMap(this.trvMap, this.id, this.defaultMap);
    }
    ngAfterViewInit() {
        this.trvMap.mapCanvas = this.mapElement;
        this.trvMap.map.setTarget(this.trvMap.mapCanvas.nativeElement);
        this.trvMap.trvControl.resetControls();
    }
    onResize(event) { }
    mapCursorClass() {
        return "";
    }
    mouseDown() {
        this.isMouseLeftdown = true;
    }
    mouseUp() {
        this.isMouseLeftdown = false;
    }
    initStreetView(streetViewRef) {
        if (this.trvMap) {
            let trvMap = this.trvMap;
            let coords = trvMap.trvInteractions.currentStreetViewCoordinates;
            let lat = 60.731849;
            let lng = 14.986731;
            if (coords) {
                let wgs = trvMap.transformSwerefToWgs84(coords[0], coords[1]);
                lat = wgs[1];
                lng = wgs[0];
            }
            const streetView = new google.maps.StreetViewPanorama(streetViewRef.nativeElement, {
                position: { lat: lat, lng: lng },
                pov: { heading: 0, pitch: 0 },
            });
        }
    }
    exitStreetView() {
        if (this.trvMap)
            this.trvMap.showStreetView = false;
    }
    ngOnDestroy() {
        if (this.componentRef)
            this.appRef.detachView(this.componentRef.hostView);
        this.trvMapService.setIsMapLoaded(false, this.id);
        this.trvMapService.destroyMapEmitter(this.id);
        if (this.trvMap?.isDefaultMap)
            this.trvMapService.destroyMapEmitter();
        this.componentRefs.forEach(componentRef => {
            componentRef.destroy();
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: TrvNgMapComponent, deps: [{ token: TrvNgMapService }, { token: TrvNgMapOverlayService }, { token: i0.ApplicationRef }, { token: i3.HttpClient }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.2.0", type: TrvNgMapComponent, isStandalone: true, selector: "lib-trv-ng-map", inputs: { layerInput: "layerInput", id: "id", defaultMap: "defaultMap", hideControls: "hideControls" }, viewQueries: [{ propertyName: "mapElement", first: true, predicate: ["map"], descendants: true }], ngImport: i0, template: "<div #map [attr.id]=\"'map' + (id ? id : '')\" class=\"map\" (window:resize)=\"onResize($event)\" (mousedown)=\"mouseDown()\" (mouseup)=\"mouseUp()\">\r\n    @if (trvMap.showStreetView) {\r\n    <lib-street-view (initStreetView)=\"initStreetView($event)\" (exitStreetView)=\"exitStreetView()\"></lib-street-view>\r\n    } @if (!hideControls && trvMap) {\r\n    <div [attr.id]=\"'map-scale-line' + (id ? id : '')\"></div>\r\n    <div\r\n        class=\"mouse-position-coordinate noselect\"\r\n        [ngClass]=\"{\r\n            dark: trvMap?.trvLayer?.currentBackroundLayer?.darkMode ?? false\r\n        }\"\r\n    >\r\n        <div class=\"info-attribution\">{{ trvMap.trvLayer.currentAttribution }}</div>\r\n        <div class=\"info-mouse-scale\" [attr.id]=\"'mouse-position' + (id ? id : '')\"></div>\r\n        <div class=\"info-map-scale\" [attr.id]=\"'map-scale' + (id ? id : '')\">Skala 1:{{ trvMap.getScaleForResolution(0) }}</div>\r\n    </div>\r\n    } @if (trvMap?.showLoadingLayers && !trvMapService.isMapLoaded(trvMap.isDefaultMap ? undefined : trvMap.id)) {\r\n    <div class=\"loading_wrapper\" data-tooltip=\"Applikationen laddas\" data-tooltip-position=\"bottom\">\r\n        <div class=\"loading\"></div>\r\n    </div>\r\n    }\r\n</div>\r\n", styles: ["::ng-deep .ol-scale-line{bottom:2.5rem}\n"], dependencies: [{ kind: "component", type: StreetViewComponent, selector: "lib-street-view", outputs: ["initStreetView", "exitStreetView"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: TrvNgMapComponent, decorators: [{
            type: Component,
            args: [{ selector: "lib-trv-ng-map", imports: [StreetViewComponent, NgClass], template: "<div #map [attr.id]=\"'map' + (id ? id : '')\" class=\"map\" (window:resize)=\"onResize($event)\" (mousedown)=\"mouseDown()\" (mouseup)=\"mouseUp()\">\r\n    @if (trvMap.showStreetView) {\r\n    <lib-street-view (initStreetView)=\"initStreetView($event)\" (exitStreetView)=\"exitStreetView()\"></lib-street-view>\r\n    } @if (!hideControls && trvMap) {\r\n    <div [attr.id]=\"'map-scale-line' + (id ? id : '')\"></div>\r\n    <div\r\n        class=\"mouse-position-coordinate noselect\"\r\n        [ngClass]=\"{\r\n            dark: trvMap?.trvLayer?.currentBackroundLayer?.darkMode ?? false\r\n        }\"\r\n    >\r\n        <div class=\"info-attribution\">{{ trvMap.trvLayer.currentAttribution }}</div>\r\n        <div class=\"info-mouse-scale\" [attr.id]=\"'mouse-position' + (id ? id : '')\"></div>\r\n        <div class=\"info-map-scale\" [attr.id]=\"'map-scale' + (id ? id : '')\">Skala 1:{{ trvMap.getScaleForResolution(0) }}</div>\r\n    </div>\r\n    } @if (trvMap?.showLoadingLayers && !trvMapService.isMapLoaded(trvMap.isDefaultMap ? undefined : trvMap.id)) {\r\n    <div class=\"loading_wrapper\" data-tooltip=\"Applikationen laddas\" data-tooltip-position=\"bottom\">\r\n        <div class=\"loading\"></div>\r\n    </div>\r\n    }\r\n</div>\r\n", styles: ["::ng-deep .ol-scale-line{bottom:2.5rem}\n"] }]
        }], ctorParameters: () => [{ type: TrvNgMapService }, { type: TrvNgMapOverlayService }, { type: i0.ApplicationRef }, { type: i3.HttpClient }], propDecorators: { layerInput: [{
                type: Input
            }], id: [{
                type: Input
            }], defaultMap: [{
                type: Input
            }], hideControls: [{
                type: Input
            }], mapElement: [{
                type: ViewChild,
                args: ["map"]
            }] } });

class TrvNgMapExportComponent {
    trvMapService;
    FileType = FileType;
    ExportDirection = ExportDirection;
    ExportSize = ExportSize;
    mapId;
    exportLoading = false;
    loading = true;
    constructor(trvMapService) {
        this.trvMapService = trvMapService;
    }
    ngOnInit() {
        if (this.trvMapService.isMapLoaded(this.mapId)) {
            this.initWhenMapLoaded();
        }
        else {
            this.trvMapService
                .onMapLoaded(this.mapId)
                .pipe(take(1))
                .subscribe(() => {
                this.initWhenMapLoaded();
            });
        }
    }
    initWhenMapLoaded() {
        const trvMap = this.trvMapService.getTrvMap(this.mapId);
        trvMap.printMenuState.exportSizeOption.valueChanges.subscribe(value => {
            if (trvMap.activeMapTool.value != MapTools.ExportRectangle) {
                trvMap.changeActiveMapTool(MapTools.ExportRectangle);
            }
            if (trvMap.previousSize == ExportSize.MapView && value != ExportSize.MapView) {
                const currentPaperSizeType = Object.entries(ExportSize).find(a => a[1] == value)[0];
                //@ts-ignore
                const currentPaperSize = PaperSize[currentPaperSizeType];
                const map = trvMap.map;
                const mapExtent = map.getView().calculateExtent();
                const mapSizeHorizontal = mapExtent[2] - mapExtent[0];
                const mapSizeVertical = mapExtent[3] - mapExtent[1];
                const maxHorizontalScale = (mapSizeHorizontal * 0.8 * 1000) / currentPaperSize[0];
                const maxVerticalScale = (mapSizeVertical * 0.8 * 1000) / currentPaperSize[1];
                trvMap.printMenuState.scale.setValue(Math.round(Math.min(Math.min(maxHorizontalScale, maxVerticalScale), trvMap.scaleIntervals[trvMap.scaleIntervals.length - 1])));
                this.centerExportArea();
            }
            trvMap.previousSize = value;
            this.updateExportView();
            this.loading = false;
        });
        trvMap.printMenuState.exportDirectionOption.valueChanges.subscribe(value => {
            this.updateExportView();
        });
        trvMap.printMenuState.scale.valueChanges.subscribe(value => {
            let result = 0;
            for (let i = 0; i < trvMap.scaleIntervals.length; i++) {
                if (value < trvMap.scaleIntervals[i]) {
                    if (Math.abs(trvMap.scaleIntervals[i] - value) < Math.abs(trvMap.scaleIntervals[i - 1] - value)) {
                        result = i;
                    }
                    else {
                        result = i - 1;
                    }
                    break;
                }
                else if (value === trvMap.scaleIntervals[i]) {
                    result = i;
                    break;
                }
            }
            trvMap.printMenuState.slider.patchValue(result, { emitEvent: false }); // Prevent infinite loop
            this.updateExportView();
        });
        trvMap.printMenuState.slider.valueChanges.subscribe(index => {
            if (trvMap.scaleIntervals[index] !== undefined) {
                trvMap.printMenuState.scale.patchValue(trvMap.scaleIntervals[index], {
                    emitEvent: false,
                }); // Prevent infinite loop
            }
            this.updateExportView();
        });
        trvMap.map.getView().on("change:resolution", () => {
            this.updateExportView();
        });
    }
    formatThumbLabel = (val) => {
        const trvMap = this.trvMapService.getTrvMap(this.mapId);
        return "1:" + trvMap.scaleIntervals[val];
    };
    updateExportView() {
        const trvMap = this.trvMapService.getTrvMap(this.mapId);
        if (trvMap.activeMapTool.value != MapTools.ExportRectangle) {
            return;
        }
        if (trvMap.printMenuState.exportSizeOption.value == ExportSize.MapView) {
            trvMap.trvInteractions.removeExportMapToolFeature();
        }
        else {
            const paperString = exportSizeToString(trvMap.printMenuState.exportSizeOption.value);
            if (trvMap.printMenuState.areaCenterCoordinate == null) {
                const map = trvMap.map;
                const mapExtent = map.getView().calculateExtent();
                trvMap.printMenuState.areaCenterCoordinate = getCenter(mapExtent);
            }
            trvMap.trvInteractions.addExportMapToolFeature(paperString, trvMap.printMenuState.scale.value, trvMap.printMenuState.exportDirectionOption.value == ExportDirection.Standing, trvMap.printMenuState.areaCenterCoordinate);
        }
    }
    centerExportArea() {
        const trvMap = this.trvMapService.getTrvMap(this.mapId);
        trvMap.trvInteractions.removeExportMapToolFeature();
        const map = trvMap.map;
        const mapExtent = map.getView().calculateExtent();
        const mapCenter = getCenter(mapExtent);
        if (mapCenter)
            trvMap.printMenuState.areaCenterCoordinate = mapCenter;
        this.updateExportView();
    }
    zoomToExtent() {
        const trvMap = this.trvMapService.getTrvMap(this.mapId);
        const exportAreaExtent = trvMap.trvLayer?.printLayer?.getSource()?.getExtent();
        if (exportAreaExtent) {
            trvMap.zoomInOnExtent(exportAreaExtent, 0, [100, 100, 100, 100]);
        }
    }
    saveCurrentPosition() {
        const trvMap = this.trvMapService.getTrvMap(this.mapId);
        const extent = trvMap?.trvLayer?.printLayer?.getSource()?.getExtent();
        if (extent && extent[0] != Infinity) {
            trvMap.printMenuState.areaCenterCoordinate = getCenter(extent);
        }
    }
    async export() {
        const trvMap = this.trvMapService.getTrvMap(this.mapId);
        this.exportLoading = true;
        try {
            //this.globalMessagesService.component(ExportAreaLoaderComponent, null, 1000000);
            const userLayers = trvMap?.trvLayer?.userLayerGroup?.getLayersArray();
            let vectorLayers = trvMap?.trvLayer?.vectorLayerGroup?.getLayersArray();
            const layers = [...userLayers, ...vectorLayers];
            const map = trvMap.map;
            let extent = trvMap?.trvLayer?.printLayer?.getSource()?.getExtent();
            if (!extent || extent[0] === Infinity)
                extent = map?.getView().calculateExtent(map.getSize());
            trvMap?.trvLayer?.tempLayer?.getSource()?.clear();
            trvMap?.trvLayer?.tempLayer2?.getSource()?.clear();
            // hide exportarea while taking screenshot
            this.saveCurrentPosition();
            trvMap?.trvInteractions.removeExportMapToolFeature();
            this.trvMapService.messageEmitter.emit({
                message: "Exporten påbörjades",
                type: MessageType.Info,
            });
            const result = await trvMap?.exportMap(trvMap.printMenuState.showLabelOption.value, extent, exportSizeToString(trvMap.printMenuState.exportSizeOption.value), trvMap.printMenuState.exportDirectionOption.value == ExportDirection.Laying, layers, trvMap.printMenuState.title.value ?? "", trvMap.printMenuState.fileTypeOption.value == FileType.PDF, trvMap.printMenuState.exportSizeOption.value == ExportSize.MapView
                ? Math.round(trvMap.getScaleForResolution())
                : trvMap.printMenuState.scale.value, trvMap.printMenuState.showCompassOption.value, trvMap.printMenuState.showScaleOption.value);
            // show exportarea again
            this.updateExportView();
            //this.globalMessagesService.clearType("component");
            //this.globalMessagesService.component(ExportAreaLoaderComponent, null, 0.01);
            this.trvMapService.messageEmitter.emit({
                message: "Exporten lyckades",
                type: MessageType.Success,
            });
            if (!result) {
                this.trvMapService.messageEmitter.emit({
                    message: "Ett okänt fel skedde vid export.",
                    type: MessageType.Error,
                });
                this.exportLoading = false;
                return;
            }
            trvMap.mapExportTrigger.emit(result);
        }
        catch (e) {
            this.updateExportView();
            this.exportLoading = false;
            console.log(e);
            let emsg = ["Utskriften misslyckades."];
            emsg.push("Kontakta support ifall problemet återstår.");
            this.trvMapService.messageEmitter.emit({
                message: emsg,
                type: MessageType.Error,
            });
        }
        this.exportLoading = false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: TrvNgMapExportComponent, deps: [{ token: TrvNgMapService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.2.0", type: TrvNgMapExportComponent, isStandalone: true, selector: "lib-trv-ng-map-export", inputs: { mapId: "mapId" }, ngImport: i0, template: "@if(trvMapService.isMapLoaded(mapId)) {\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Spara som:</span>\r\n    <div class=\"d-flex gap-4\">\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                name=\"test1\"\r\n                id=\"simpleRadio1\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.fileTypeOption\"\r\n                [value]=\"FileType.PNG\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio1\">png</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                name=\"test1\"\r\n                id=\"simpleRadio2\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.fileTypeOption\"\r\n                [value]=\"FileType.PDF\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio2\">pdf</label>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n@if (trvMapService.getTrvMap(mapId)!.printMenuState.fileTypeOption.value == FileType.PDF) {\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Spara pdf som:</span>\r\n    <input\r\n        class=\"form-check-label\"\r\n        type=\"text\"\r\n        class=\"form-control\"\r\n        placeholder=\"Titel\"\r\n        [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.title\"\r\n    />\r\n</div>\r\n}\r\n\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Teckenf\u00F6rklaring</span>\r\n    <div class=\"form-check\">\r\n        <input\r\n            class=\"form-check-input\"\r\n            type=\"checkbox\"\r\n            id=\"simpleCheck1\"\r\n            [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.showLabelOption\"\r\n            [value]=\"false\"\r\n        />\r\n        <label class=\"form-check-label\" for=\"simpleCheck1\">Visa teckenf\u00F6rklaring</label>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"mb-3\">\r\n    <div class=\"d-flex gap-4\">\r\n        <div>\r\n            <span class=\"fw-600\">Norrpil</span>\r\n            <div class=\"form-check\">\r\n                <input\r\n                    class=\"form-check-input\"\r\n                    type=\"checkbox\"\r\n                    id=\"simpleCheck2\"\r\n                    [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.showCompassOption\"\r\n                />\r\n                <label class=\"form-check-label\" for=\"simpleCheck2\">Visa norrpil</label>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <span class=\"fw-600\">Skalstock</span>\r\n            <div class=\"form-check\">\r\n                <input\r\n                    class=\"form-check-input\"\r\n                    type=\"checkbox\"\r\n                    id=\"simpleCheckScale\"\r\n                    [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.showScaleOption\"\r\n                />\r\n                <label class=\"form-check-label\" for=\"simpleCheckScale\">Visa skalstock</label>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Sidorientering</span>\r\n    <div class=\"d-flex gap-4\">\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio3\"\r\n                class=\"form-check-input\"\r\n                name=\"test2\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportDirectionOption\"\r\n                [value]=\"ExportDirection.Standing\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio3\">St\u00E5ende</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio4\"\r\n                name=\"test2\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportDirectionOption\"\r\n                [value]=\"ExportDirection.Laying\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio4\">Liggande</label>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Sidstorlek</span>\r\n    <div class=\"d-flex gap-4\">\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio6\"\r\n                class=\"form-check-input\"\r\n                name=\"test4\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.MapView\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio6\">Hela</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio7\"\r\n                name=\"test4\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.A4\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio7\">A4</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio8\"\r\n                name=\"test4\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.A3\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio8\">A3</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio9\"\r\n                name=\"test4\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.A2\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio9\">A2</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio10\"\r\n                name=\"test4\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.A1\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio10\">A1</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio11\"\r\n                name=\"test4\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.A0\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio11\">A0</label>\r\n        </div>\r\n    </div>\r\n    @if (trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption.value != ExportSize.MapView) {\r\n    <div class=\"d-flex gap-2 mt-2\">\r\n        <button class=\"btn btn-primary\" (click)=\"centerExportArea()\">Centrera</button>\r\n        <button class=\"btn btn-primary\" (click)=\"zoomToExtent()\">Zooma till</button>\r\n    </div>\r\n    }\r\n</div>\r\n@if (trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption.value != ExportSize.MapView) {\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Exportarea (skala)</span>\r\n    <div style=\"width: 95%; z-index: 10\">\r\n        <mat-slider\r\n            style=\"width: 100%; z-index: 10\"\r\n            min=\"0\"\r\n            [max]=\"trvMapService.getTrvMap(mapId)!.scaleIntervals.length - 1\"\r\n            step=\"1\"\r\n            discrete=\"thumbLabel\"\r\n            [displayWith]=\"formatThumbLabel\"\r\n        >\r\n            <input matSliderThumb [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.slider\" />\r\n        </mat-slider>\r\n    </div>\r\n    <div class=\"print-scale-wrapper\">\r\n        <div class=\"print-scale-prepend\">1:</div>\r\n        <input type=\"number\" class=\"form-control\" placeholder=\"Skala\" [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.scale\" />\r\n    </div>\r\n</div>\r\n}\r\n\r\n<div class=\"print-export-button\">\r\n    <div>\r\n        <button class=\"btn btn-primary\" (click)=\"export()\">Exportera</button>\r\n    </div>\r\n</div>\r\n}\r\n", styles: [".print-scale-wrapper{display:flex}.print-scale-prepend{width:35.75px;display:flex;align-items:center;justify-content:center;background-color:#ced4da;font-weight:600}.mat-mdc-slider.mat-primary{--mdc-slider-handle-color: #1E5C88;--mdc-slider-focus-handle-color: #1E5C88;--mdc-slider-hover-handle-color: #1E5C88;--mdc-slider-active-track-color: #1E5C88;--mdc-slider-inactive-track-color: #1E5C88;--mdc-slider-with-tick-marks-active-container-color: #fff;--mdc-slider-with-tick-marks-inactive-container-color: #1E5C88;--mat-mdc-slider-ripple-color: #1E5C88;--mat-mdc-slider-hover-ripple-color: rgba(24, 47, 194, .05);-----mat-mdc-slider-focus-ripple-color: rgba(24, 84, 194, .2);--mat-mdc-slider-focus-ripple-color: #1e5c8824}\n"], dependencies: [{ kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i1$1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1$1.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "ngmodule", type: MatSliderModule }, { kind: "component", type: i2.MatSlider, selector: "mat-slider", inputs: ["disabled", "discrete", "showTickMarks", "min", "color", "disableRipple", "max", "step", "displayWith"], exportAs: ["matSlider"] }, { kind: "directive", type: i2.MatSliderThumb, selector: "input[matSliderThumb]", inputs: ["value"], outputs: ["valueChange", "dragStart", "dragEnd"], exportAs: ["matSliderThumb"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: TrvNgMapExportComponent, decorators: [{
            type: Component,
            args: [{ selector: "lib-trv-ng-map-export", imports: [ReactiveFormsModule, MatSliderModule], template: "@if(trvMapService.isMapLoaded(mapId)) {\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Spara som:</span>\r\n    <div class=\"d-flex gap-4\">\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                name=\"test1\"\r\n                id=\"simpleRadio1\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.fileTypeOption\"\r\n                [value]=\"FileType.PNG\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio1\">png</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                name=\"test1\"\r\n                id=\"simpleRadio2\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.fileTypeOption\"\r\n                [value]=\"FileType.PDF\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio2\">pdf</label>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n@if (trvMapService.getTrvMap(mapId)!.printMenuState.fileTypeOption.value == FileType.PDF) {\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Spara pdf som:</span>\r\n    <input\r\n        class=\"form-check-label\"\r\n        type=\"text\"\r\n        class=\"form-control\"\r\n        placeholder=\"Titel\"\r\n        [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.title\"\r\n    />\r\n</div>\r\n}\r\n\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Teckenf\u00F6rklaring</span>\r\n    <div class=\"form-check\">\r\n        <input\r\n            class=\"form-check-input\"\r\n            type=\"checkbox\"\r\n            id=\"simpleCheck1\"\r\n            [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.showLabelOption\"\r\n            [value]=\"false\"\r\n        />\r\n        <label class=\"form-check-label\" for=\"simpleCheck1\">Visa teckenf\u00F6rklaring</label>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"mb-3\">\r\n    <div class=\"d-flex gap-4\">\r\n        <div>\r\n            <span class=\"fw-600\">Norrpil</span>\r\n            <div class=\"form-check\">\r\n                <input\r\n                    class=\"form-check-input\"\r\n                    type=\"checkbox\"\r\n                    id=\"simpleCheck2\"\r\n                    [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.showCompassOption\"\r\n                />\r\n                <label class=\"form-check-label\" for=\"simpleCheck2\">Visa norrpil</label>\r\n            </div>\r\n        </div>\r\n        <div>\r\n            <span class=\"fw-600\">Skalstock</span>\r\n            <div class=\"form-check\">\r\n                <input\r\n                    class=\"form-check-input\"\r\n                    type=\"checkbox\"\r\n                    id=\"simpleCheckScale\"\r\n                    [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.showScaleOption\"\r\n                />\r\n                <label class=\"form-check-label\" for=\"simpleCheckScale\">Visa skalstock</label>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Sidorientering</span>\r\n    <div class=\"d-flex gap-4\">\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio3\"\r\n                class=\"form-check-input\"\r\n                name=\"test2\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportDirectionOption\"\r\n                [value]=\"ExportDirection.Standing\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio3\">St\u00E5ende</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio4\"\r\n                name=\"test2\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportDirectionOption\"\r\n                [value]=\"ExportDirection.Laying\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio4\">Liggande</label>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Sidstorlek</span>\r\n    <div class=\"d-flex gap-4\">\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio6\"\r\n                class=\"form-check-input\"\r\n                name=\"test4\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.MapView\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio6\">Hela</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio7\"\r\n                name=\"test4\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.A4\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio7\">A4</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio8\"\r\n                name=\"test4\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.A3\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio8\">A3</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio9\"\r\n                name=\"test4\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.A2\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio9\">A2</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio10\"\r\n                name=\"test4\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.A1\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio10\">A1</label>\r\n        </div>\r\n        <div class=\"form-check\">\r\n            <input\r\n                type=\"radio\"\r\n                id=\"simpleRadio11\"\r\n                name=\"test4\"\r\n                class=\"form-check-input\"\r\n                [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption\"\r\n                [value]=\"ExportSize.A0\"\r\n            />\r\n            <label class=\"form-check-label\" for=\"simpleRadio11\">A0</label>\r\n        </div>\r\n    </div>\r\n    @if (trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption.value != ExportSize.MapView) {\r\n    <div class=\"d-flex gap-2 mt-2\">\r\n        <button class=\"btn btn-primary\" (click)=\"centerExportArea()\">Centrera</button>\r\n        <button class=\"btn btn-primary\" (click)=\"zoomToExtent()\">Zooma till</button>\r\n    </div>\r\n    }\r\n</div>\r\n@if (trvMapService.getTrvMap(mapId)!.printMenuState.exportSizeOption.value != ExportSize.MapView) {\r\n<div class=\"mb-3\">\r\n    <span class=\"fw-600\">Exportarea (skala)</span>\r\n    <div style=\"width: 95%; z-index: 10\">\r\n        <mat-slider\r\n            style=\"width: 100%; z-index: 10\"\r\n            min=\"0\"\r\n            [max]=\"trvMapService.getTrvMap(mapId)!.scaleIntervals.length - 1\"\r\n            step=\"1\"\r\n            discrete=\"thumbLabel\"\r\n            [displayWith]=\"formatThumbLabel\"\r\n        >\r\n            <input matSliderThumb [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.slider\" />\r\n        </mat-slider>\r\n    </div>\r\n    <div class=\"print-scale-wrapper\">\r\n        <div class=\"print-scale-prepend\">1:</div>\r\n        <input type=\"number\" class=\"form-control\" placeholder=\"Skala\" [formControl]=\"trvMapService.getTrvMap(mapId)!.printMenuState.scale\" />\r\n    </div>\r\n</div>\r\n}\r\n\r\n<div class=\"print-export-button\">\r\n    <div>\r\n        <button class=\"btn btn-primary\" (click)=\"export()\">Exportera</button>\r\n    </div>\r\n</div>\r\n}\r\n", styles: [".print-scale-wrapper{display:flex}.print-scale-prepend{width:35.75px;display:flex;align-items:center;justify-content:center;background-color:#ced4da;font-weight:600}.mat-mdc-slider.mat-primary{--mdc-slider-handle-color: #1E5C88;--mdc-slider-focus-handle-color: #1E5C88;--mdc-slider-hover-handle-color: #1E5C88;--mdc-slider-active-track-color: #1E5C88;--mdc-slider-inactive-track-color: #1E5C88;--mdc-slider-with-tick-marks-active-container-color: #fff;--mdc-slider-with-tick-marks-inactive-container-color: #1E5C88;--mat-mdc-slider-ripple-color: #1E5C88;--mat-mdc-slider-hover-ripple-color: rgba(24, 47, 194, .05);-----mat-mdc-slider-focus-ripple-color: rgba(24, 84, 194, .2);--mat-mdc-slider-focus-ripple-color: #1e5c8824}\n"] }]
        }], ctorParameters: () => [{ type: TrvNgMapService, decorators: [{
                    type: Inject,
                    args: [TrvNgMapService]
                }] }], propDecorators: { mapId: [{
                type: Input
            }] } });
function exportSizeToString(exportSize) {
    switch (exportSize) {
        case ExportSize.A4:
            return "A4";
        case ExportSize.A3:
            return "A3";
        case ExportSize.A2:
            return "A2";
        case ExportSize.A1:
            return "A1";
        case ExportSize.A0:
            return "A0";
        default:
            return "";
    }
}

/**
 * Service for handling Overlays. \
 * \
 *
 */
class TrvNgMapOverlayService {
    trvMapService;
    componentFactoryResolver;
    appRef;
    injector;
    componentRef;
    componentRefs = [];
    overlays = [];
    constructor(trvMapService, componentFactoryResolver, appRef, injector) {
        this.trvMapService = trvMapService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
    }
    /**
     * Adds an overlay to the main TrvMap. The component reference is returned.
     * @param overLayComponentType The type that the component should be off. The componentType must extend OlOverlayComponent. (Warning, no type checking for this atm.)
     * @param coordinate The coordinate to place the overlay
     * @param offset The offset in pixels. Format: [xOffset, yOffset]
     * @param positioning The anchoring point of the overlay. Default is "center-center". \
     * Available values: 'bottom-left', 'bottom-center', 'bottom-right', 'center-left', 'center-center', 'center-right', 'top-left', 'top-center', or 'top-right'.
     * @returns The component reference of type overLayComponentType
     */
    addOverlay(trvMap, overLayComponentType, coordinate, offset = [0, 0], positioning = "center-center") {
        //const trvMapComponent = this.trvMapService.trvMap!.parentComponent as TrvNgMapComponent;
        const compRef = this._addOverlay(trvMap, overLayComponentType, coordinate, offset, positioning);
        const comp = compRef.instance;
        return comp;
    }
    /**
     * Removes an overlay completely from the map.
     * @param component The component that was created with addOverlay().
     */
    removeOverlay(trvMap, component) {
        if (component.overLay) {
            trvMap.map.removeOverlay(component.overLay);
        }
    }
    _addOverlay(trvMap, componentClass, coordinate, offset = [0, 0], positioning = "center-center") {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentClass);
        const componentRef = componentFactory.create(this.injector);
        this.appRef.attachView(componentRef.hostView);
        this.componentRefs.push(componentRef);
        const element = componentRef.location.nativeElement;
        const overlay = new Overlay({
            element: element,
            position: coordinate,
            positioning: positioning,
            autoPan: false,
            offset: offset,
        });
        //If component has variable-name "overLay", set overlay to
        const compAsAny = componentRef.instance;
        if ("overLay" in compAsAny) {
            compAsAny.overLay = overlay;
        }
        //componentRef.instance.overlay = overlay;
        this.overlays.push(overlay);
        trvMap.map.addOverlay(overlay);
        return componentRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: TrvNgMapOverlayService, deps: [{ token: TrvNgMapService }, { token: i0.ComponentFactoryResolver }, { token: i0.ApplicationRef }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: TrvNgMapOverlayService, providedIn: "root" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.0", ngImport: i0, type: TrvNgMapOverlayService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: () => [{ type: TrvNgMapService, decorators: [{
                    type: Inject,
                    args: [TrvNgMapService]
                }] }, { type: i0.ComponentFactoryResolver }, { type: i0.ApplicationRef }, { type: i0.Injector }] });

/*
 * Public API Surface of trv-ng-map
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BORLANGE_COORD, DefaultDottedStyle, DefaultExportRectStyle, DefaultPointStyle, DefaultStyle, DefaultZoomStyle, ExportDirection, ExportSize, FileType, FormatDistanceMeterKilometer, INIT_EXTENT, LEKSAND_COORD, LEKSAND_WKT, LineIntersectCircle, MapTools, MessageType, NORRLAND_WKT, OlOverlayComponent, PaperSize, PinBlueDarkStyle, PinBlueExclamationStyle, PinBlueHouseStyle, PinBlueInfoStyle, PinBluePenStyle, PinBlueQuestionStyle, PinBlueSearchStyle, PinBlueStarStyle, PinBlueStyle, PinBlueUserStyle, PinGreenDarkStyle, PinGreenExclamationStyle, PinGreenHouseStyle, PinGreenInfoStyle, PinGreenPenStyle, PinGreenQuestionStyle, PinGreenSearchStyle, PinGreenStarStyle, PinGreenStyle, PinGreenUserStyle, PinOrangeDarkStyle, PinOrangeExclamationStyle, PinOrangeHouseStyle, PinOrangeInfoStyle, PinOrangePenStyle, PinOrangeQuestionStyle, PinOrangeSearchStyle, PinOrangeStarStyle, PinOrangeStyle, PinOrangeUserStyle, PinPinkDarkStyle, PinPinkExclamationStyle, PinPinkHouseStyle, PinPinkInfoStyle, PinPinkPenStyle, PinPinkQuestionStyle, PinPinkSearchStyle, PinPinkStarStyle, PinPinkStyle, PinPinkUserStyle, PinPurpleDarkStyle, PinPurpleExclamationStyle, PinPurpleHouseStyle, PinPurpleInfoStyle, PinPurplePenStyle, PinPurpleQuestionStyle, PinPurpleSearchStyle, PinPurpleStarStyle, PinPurpleStyle, PinPurpleUserStyle, PinRedDarkStyle, PinRedExclamationStyle, PinRedHouseStyle, PinRedInfoStyle, PinRedPenStyle, PinRedQuestionStyle, PinRedSearchStyle, PinRedStarStyle, PinRedStyle, PinRedUserStyle, PinTealDarkStyle, PinTealExclamationStyle, PinTealHouseStyle, PinTealInfoStyle, PinTealPenStyle, PinTealQuestionStyle, PinTealSearchStyle, PinTealStarStyle, PinTealStyle, PinTealUserStyle, PinYellowDarkStyle, PinYellowExclamationStyle, PinYellowHouseStyle, PinYellowInfoStyle, PinYellowPenStyle, PinYellowQuestionStyle, PinYellowSearchStyle, PinYellowStarStyle, PinYellowStyle, PinYellowUserStyle, RulerLineHover, RulerLinePoint, RulerLineString, STOCKHOLM_COORD, SUNDBYBERG_WKT, SWEDEN_CENTER_COORD, SWEREF_99_TM, StreetViewIconLaying, StreetViewIconStanding, TrvControl, TrvInteractions, TrvLayer, TrvMap, TrvNgMapComponent, TrvNgMapExportComponent, TrvNgMapOverlayService, TrvNgMapService, WGS_84, ZoomPointStyle, customCoordinateString, distanceBetweenPoints, exportSizeToString, extendMapTools, extent, generateGUID, getCenterPointOfLine, getCenterRight, getExtentFromCoordinates, registerProjection, resolutions, roundDownToMultiple, tileGrid, tileGridWmts, transformSwerefToWgs84Func };
